import {globals, globalUser} from "../modules/globals.js";
import {
    getViewCompaniesData,
    getViewObjectivesData,
    getViewManagementActivityData,
    getFanHistoryData,
    getViewCompanyStaffData,
    getViewCompanyFacilitiesData,
    upgradeCompanyFacility,
    getViewIndieStaffData,
    hireStaffMember,
    fireStaffMember,
    getEditStaffMemberData,
    changeStaffMemberName,
    changeStaffMemberPronoun,
    changeStaffMemberGraphic,
    cancelStaffMemberTask,
    getYearlyRankingsHistoryData,
    getAnnualTournamentHistoryData,
    getAnnualTournamentStatsData,
    getCompanySelectData,
    getViewStatsData,
    getViewTournamentsData,
    getViewGimmickMatchesData,
    getRemoveGimmickMatchesData,
    removeGimmickMatch,
    addGimmickMatch,
    getViewTitlesData,
    getCompanyBrandNames,
    getCompanyGimmickMatchesForChampionshipGimmick,
    getCompanyChampionshipsData,
    vacateChampionship,
    retireChampionship,
    addChampionship,
    rebrandChampionship,
    rebrandCompany, getBuyoutInformation, makeBuyoutOffer, getFormNewCompanyInformation, startFormingNewCompany
} from "../modules/companies.js";
import {
    getFansHtml,
    hideContent,
    parseObjectiveName,
    getViewershipText,
    getPointsHtml,
    getShortenedName,
    setRating,
    runFuseElementsSearch,
    getStarRatingHtml,
    getChampionshipPrestigeIconHtml,
    escapeHTML,
    getChampionshipGimmickRestrictionText,
    getChampionshipPrestigeProgressHtml,
    getCompanyHeaderHtml,
    makeGameRequest,
    getItemColumnDiv,
    getChampionshipsInfo,
    getRosterInfo,
    previewSegmentSinglesParticipants,
    previewSegmentTagParticipants
} from "./ui-helpers.js";
import {
    commaSeparate, generateName,
    getCurrentGame,
    getMonthsWord,
    getRandomChoice, getRandomInt, getTimeDiffHuman, getYearsWord, myround,
    shuffle,
    toTitleCase
} from "../modules/helpers.js";
import {playSoundEffect} from "./sounds.js"
import {
    characterBackgroundImage,
    showAddChampionshipPageGraphic,
    showChangeAppearancePageGraphic,
    showEventPosterPageGraphic,
    showStaffMemberPageGraphic,
    showTitlePageGraphic
} from "./graphics.js"
import {
    getEventPosterData,
    getCompanyEventsData,
    getViewEventsData,
    rebrandEvent,
    getEventCardData
} from "../modules/events.js";
import {getSpecialSegmentHistoryData, getSpecialSegmentsData} from "../modules/segments.js";
import {showViewSpecialSegmentsPageData, viewSpecialSegmentStart} from "./segments.js";
import {applyPowerup, buyPowerup, getPowerupsData, usePowerup} from "../modules/powerups.js";
import {
    changeGameSetting,
    changeNumberOfWeeklyShows,
    changeUserSetting,
    getOptionsData
} from "../modules/games.js";
import {addCompaniesDataToSelectElement, loadAddStaffTaskPage} from "./roster-sub-menu.js";
import {
    addEventCardMatchesAndSegments,
    displayEventPrestigeAndEffects,
    getMatchParticipantManagersHtml,
    updateEventCardBrand
} from "./event-card.js";
import {
    createFeud,
    endViewFeudsFeud, generateRandomFeudItemName, getCreateFeudItemsData,
    getAllTalentData,
    getFeudHistoryData,
    getViewFeudsData
} from "../modules/feuds.js";
import {
    getAddCustomSegmentRequest,
    getRemoveSegmentRequest,
    loadCustomSegmentTemplate,
    loadEditSegmentPage,
    loadEditSegmentsPage,
    parseCustomSegmentText,
    runCustomSegmentPreviewAnimation,
    getEditCustomSegmentRequest,
    customSegmentsData
} from "./custom-segments.js";
import {getPowerupImage} from "../modules/powerups.js";
import {loadCommunitySegment} from "./community.js";
import {downloadGameDatabase, saveGameDataBaseToCloud} from "./games.js";
import {checkTutorialStepAction, disableTutorialPointerEvents} from "./tutorial.js";

let fanHistoryChart;
let randomizeFeudHintShown = false;

$(document).ready(function() {
    const $viewershipHistoryContainer = $('.viewership-history-container');
    const $game = $('#game');

    // Fan history graph type select
    $viewershipHistoryContainer.on('change', '.viewership-history-graph-type-select', async function () {
        let graphValue = $(this).val();
        let graphPeriod = $('.viewership-history-graph-period-select').val();

        // Show 'show brands separately' checkbox for all options except 'fans'
        if (graphValue === 'fans') {
            $('.viewership-history-graph-brand-option').parent().parent().hide();
        }
        else {
            $('.viewership-history-graph-brand-option').parent().parent().show();
        }

        await loadFanHistoryPage(graphValue, graphPeriod);
    });

    // Fan history graph period select
    $viewershipHistoryContainer.on('change', '.viewership-history-graph-period-select', async function () {
        let graphPeriod = $(this).val();
        let graphValue = $('.viewership-history-graph-type-select').val();
        await loadFanHistoryPage(graphValue, graphPeriod);
    });

    // Fan history show brands separately check
    $viewershipHistoryContainer.on('click', '.viewership-history-graph-brand-option', async function () {
        let graphPeriod = $('.viewership-history-graph-period-select').val();
        let graphValue = $('.viewership-history-graph-type-select').val();
        await loadFanHistoryPage(graphValue, graphPeriod);
    });

    // Fan history graph visibility buttons
    $viewershipHistoryContainer.on('click', '.viewership-history-show-all-button, .viewership-history-hide-all-button, ' +
        '.viewership-history-show-5-button, .viewership-history-show-users-button', async function () {
        playSoundEffect('success');
        changeFanHistoryVisibility($(this).attr('data-value'));
    });

    // Fan history show labels checkbox
    $viewershipHistoryContainer.on('click', '.viewership-history-graph-labels-option', async function () {
        playSoundEffect('success');
        let enabled = !!$(this).is(":checked");
        fanHistoryChart.updateOptions({
            dataLabels: {
                enabled: enabled
            }
        });
        notie.alert({type: 4, text: 'Graph setting changed'});
    });

    // Go back to staff view from staff member details
    const $staffMemberDetails = $('.staff-member-details');
    $staffMemberDetails.on('click', '#back-to-staff-view-button', function () {
        playSoundEffect('success');
        let element = $staffMemberDetails.data('element');
        $staffMemberDetails.hide();
        $(element).fadeIn();

        let staffMemberName = $(".staff-member-name").text();
        let staffMemberElement = $('.staff-member-container:contains(' + staffMemberName + ')')[0];

        if (staffMemberElement) {
            // Scroll to center
            Element.prototype.documentOffsetTop = function () {
                return this.offsetTop + ( this.offsetParent ? this.offsetParent.documentOffsetTop() : 0 );
            };
            let top = staffMemberElement.documentOffsetTop() - ( window.innerHeight / 2 );
            window.scrollTo(0, top);
        }

        // Tutorial action check
        checkTutorialStepAction('click_back_to_staff_view_button');
    });

    // View indie staff button handler
    $('.company-staff-container').on('click', '#view-indie-staff-menu-button', async function () {
        await loadViewIndieStaffPage();
    });

    // Hire staff button handler
    $staffMemberDetails.on('click', '#hire-staff-member-button', async function () {
        let uid = $('.staff-member-details').data('uid');
        await getHireStaffMemberRequest(uid);
    });

    // Fire staff button handler
    $staffMemberDetails.on('click', '#fire-staff-member-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let uid = $('.staff-member-details').data('uid');
                await getFireStaffMemberRequest(uid);
            }
        });
    });

    // Go back to view staff from staff hiring board
    $game.on('click', '.back-to-view-staff-button', async function () {
        await loadViewCompanyStaffPage();
    });

    // Open 'change staff name' page
    $staffMemberDetails.on('click', '#change-staff-name-menu-button', async function () {
        let uid =  $('.staff-member-details').data('uid');
        await loadChangeStaffMemberNamePage(uid);
    });

    // Change staff name handler
    $(".change-staff-name-container").on('click', '.change-staff-name-button', async function () {
        let parent = $('.change-staff-name-container');
        let name = parent.find('.change-staff-name-input').val();
        let uid = parent.data('uid');
        await getChangeStaffMemberNameRequest(uid, name);
    });

    // Open 'change staff pronoun' page
    $staffMemberDetails.on('click', '#change-staff-pronoun-menu-button', async function () {
        let uid =  $('.staff-member-details').data('uid');
        await loadChangeStaffMemberPronounPage(uid);
    });

    // Change staff pronoun handler
    $(".change-staff-pronoun-container").on('click', '.change-staff-pronoun-button', async function () {
        let parent = $('.change-staff-pronoun-container');
        let pronoun = parent.find('.change-staff-pronoun-select').val();
        let uid = parent.data('uid');
        await getChangeStaffMemberPronounRequest(uid, pronoun);
    });

    // Open 'change staff appearance' page
    $staffMemberDetails.on('click', '#change-staff-appearance-menu-button', async function () {
        let uid =  $('.staff-member-details').data('uid');
        await loadChangeStaffMemberAppearancePage(uid);
    });

    // Change staff appearance handler
    $(".change-staff-appearance-container").on('click', '.change-staff-appearance-button', async function () {
        let parent = $('.change-staff-appearance-container');
        let uid = parent.data('uid');
        parent.find('#change-staff-appearance-graphic-container .share-character').trigger('click').removeClass('selected');
        parent.find('#change-staff-appearance-graphic-container .share-character-code-container').hide();
        let graphic = $('#change-staff-appearance-graphic-container .share-character-code-input').val();
        await getChangeStaffMemberGraphicRequest(uid, graphic);
    });

    // Transition to superstar handler
    $staffMemberDetails.on('click', '#transition-staff-to-talent-button', async function () {
        let uid = $('.staff-member-details').data('uid');
        let staffMemberName = $('.staff-member-name').text();
        await loadAddStaffTaskPage(uid, 'staff', staffMemberName, 'transition (talent)');
    });

    // Cancel staff task handler
    $staffMemberDetails.on('click', '#cancel-staff-member-task-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let uid =  $('.staff-member-details').data('uid');
                await getCancelStaffMemberTaskRequest(uid);
            }
        });
    });

    // Back to staff member handler
    $(".change-staff-name-container, .change-staff-pronoun-container, " +
        ".change-staff-appearance-container").on('click', '.back-to-staff-member-button', function () {
        playSoundEffect('success');
        // Reload graphic if coming back from 'change appearance' page
        if ($('.change-staff-appearance-container').is(':visible')) {
            let graphic = $('.staff-member-details').data('graphic');
            $('.staff-member-graphic').html('');
            let el = $staffMemberDetails.find('.staff-member-graphic');
            showStaffMemberPageGraphic(graphic, el);
        }
        $(".change-staff-name-container, .change-staff-pronoun-container, .change-staff-appearance-container").hide();
        $staffMemberDetails.fadeIn();
    });

    // Upgrade facility handler
    $('.company-facilities-container').on('click', '#upgrade-facility-button', async function () {
        let uid = parseInt($(this).closest('.facility-item').attr('data-uid'));
        let facilityItemElement = $(this).closest('.facility-item');
        await getUpgradeCompanyFacilityRequest(uid, facilityItemElement);
    });

    // Select year for yearly rankings history
    $('#yearly-rankings-container').on('change', '.yearly-rankings-year-select', async function () {
        let year = parseInt($(this).val());
        await loadViewYearlyRankingsHistoryPage(year);
    });

    // Select iteration for annual tournament history
    const $annualTournamentHistoryContainer = $('#annual-tournament-history-container');
    $annualTournamentHistoryContainer.on('change', '.annual-tournament-iteration-select', async function () {
        let iteration = parseInt($(this).val());
        await loadViewAnnualTournamentHistoryPage(iteration);
    });

    // View annual tournament stats
    $annualTournamentHistoryContainer.on('click', '.view-annual-tournament-stats-button', async function () {
        await loadViewAnnualTournamentStatsPage();
    });

    // Go back from annual tournament stats
    $('#annual-tournament-stats-container').on('click', '.annual-tournament-stats-back-button', function () {
        playSoundEffect('success');
        hideContent($());
        $("#annual-tournament-history-container").fadeIn('slow');
    });

    // View annual tournament poster
    $annualTournamentHistoryContainer.on('click', '.view-annual-tournament-poster-button', async function () {
        let annualTournamentUid = parseInt($(this).data('uid'));
        await loadViewEventPosterPage(null, annualTournamentUid);
    });

    // Go back from viewing poster
    $game.on('click', '.event-poster-back-button', function () {
        playSoundEffect('success');
        let elementToShow = $('#event-history-poster-container').data('previousElement');
        hideContent($());
        $(elementToShow).fadeIn('slow');
    });

    // View used special segment
    $('#special-segments-box').on('click', '.view-special-segment', async function () {
        let uid = parseInt($(this).attr('data-uid'));
        await loadViewUsedSpecialSegmentPage(uid);
    });

    // Back to special segments page
    $('#match').on('click', '#back-to-special-segments-button', function () {
        playSoundEffect('success');
        hideContent($());
        $('#special-segments-box').fadeIn('slow');
    });

    // Change run weekly shows option
    const $gameOptionsContainer = $('#game-options-container');
    $gameOptionsContainer.on('change', 'select[name="number-of-weekly-shows-option"]', async function () {
        let value = parseInt($(this).val());
        let $el = $(this);
        await changeNumberOfWeeklyShowsRequest(value, $el);
    });

    // Change user setting
    $gameOptionsContainer.on('change', 'input[value="show_event_preview"], ' +
        'input[value="load_favorite_community_segments"]', async function () {
        let settingName = $(this).attr('data-name');
        let settingValue = $(this).prop('checked');
        await changeUserSettingRequest(settingName, settingValue);
    });

    // Change game setting
    $gameOptionsContainer.on('change', 'input[name="competitor-difficulty-option"], ' +
        '.toggleable-game-setting', async function () {
        let settingName;
        let settingValue;
        if ($(this).hasClass('toggleable-game-setting')) {
            settingValue = $(this).prop('checked');
            settingName = $(this).val();
        }
        else {
            settingValue = $(this).val();
            settingName = 'competitor_difficulty';
        }
        await changeGameSettingRequest(settingName, settingValue);
    });

    // Save to cloud
    $gameOptionsContainer.on('click', '.save-to-cloud-button', async function () {
        await saveGameDataBaseToCloud(true, true);
    });

    // Download save
    $gameOptionsContainer.on('click', '.download-save-button', async function () {
        notie.confirm({
            text: 'Downloading your save allows you to back it up locally. However, importing downloaded saves isn\'t supported yet. Continue?',
            submitCallback: async function () {
                await downloadGameDatabase();
            },
            cancelText: 'No'
        });
    });

    let $eventHistoryContainer = $("#event-history-container");

    // View event company select
    $eventHistoryContainer.on('change', '.select-company-for-view-events', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewEventsPage(companyUid);
    });

    // Next event handler
    $eventHistoryContainer.on('click', '.event-history-previous-event-button', async function () {
        let eventUid = $("#event-details").data('previousEventId');
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr('data-uid'));
        await loadViewEventsPage(companyUid, eventUid);
    });

    // Previous event handler
    $eventHistoryContainer.on('click', '.event-history-next-event-button', async function () {
        let eventUid = $("#event-details").data('nextEventId');
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr('data-uid'));
        await loadViewEventsPage(companyUid, eventUid);
    });

    // Year select handler
    $eventHistoryContainer.on('change', '.select-year-for-view-events', async function () {
        let eventUid = parseInt($(this).find(":selected").attr('data-uid'));
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr('data-uid'));
        await loadViewEventsPage(companyUid, eventUid);
    });

    // View event calendar handler
    $eventHistoryContainer.on('click', '.event-history-calendar-button', async function () {
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr('data-uid'));
        await loadViewEventCalendarPage(companyUid);
    });

    // View event from calendar
    $('.event-calendar-box').on('click', async function () {
        // Get latest child event
        let eventUid = $(this).find(".event-calendar-name").data('latestChildEventUid');
        // If not held, get parent event
        if (!eventUid) {
            eventUid = $(this).find(".event-calendar-name").data('uid')
        }
        let companyUid = parseInt($(".select-company-for-view-events").find(":selected").attr('data-uid'));
        await loadViewEventsPage(companyUid, eventUid);
    });

    // View event poster
    $eventHistoryContainer.on('click', '.view-event-poster-button', async function () {
        let eventUid = $("#event-details").data('uid');
        await loadViewEventPosterPage(eventUid, null);
    });

    // Show rebrand event page
    $eventHistoryContainer.on('click', '#rebrand-event-menu-button', async function () {
        let element = $(".rebrand-event-container");
        let selectedEvent = $('#event-history-container .event-history-name').text();
        await loadRebrandEventPage(selectedEvent, element);
    });

    // Set brand dropdown upon changing rebrand event's event select
    $(".rebrand-event-container").on('change', '.rebrand-event-event-select', function () {
        let selected = $(this).find(':selected');
        let parent = $(this).closest('.rebrand-event-container');

        // Select brand
        if (globalUser.paid) {
            if (!selected.data('weekly-show')) {
                let brandName = selected.data('brand-name');
                parent.find('.rebrand-event-brand-select').val(brandName);
                parent.find('.rebrand-event-brand-select').parent().show();
            }
            // Don't show brand name input for weekly show
            else {
                parent.find('.rebrand-event-brand-select').parent().hide();
            }
        }
        else {
            parent.find('.rebrand-event-brand-select').parent().hide();
        }
    });

    // Rebrand event handler
    $game.on('click', '#rebrand-event-button', async function () {
        const $rebrandEventEventSelect = $('.rebrand-event-container .rebrand-event-event-select');
        let uid = $rebrandEventEventSelect.find(':selected').data('uid');
        let weeklyShow = $rebrandEventEventSelect.find(':selected').data('weekly-show');
        let name = $('.rebrand-event-container .rebrand-event-name-input').val();
        let brandName = $('.rebrand-event-container .rebrand-event-brand-select').val();
        await rebrandEventRequest(uid, name, weeklyShow, brandName);
    });

     // Go back to view events
    $game.on('click', '.back-to-view-events-button', function () {
        playSoundEffect('success');
        hideContent($());
        $("#event-history-container").fadeIn('slow');
    });

    // Event prestige effects button handler
    $('.event-prestige-effects-more').on('click', function () {
        if ($(this).find('i').hasClass('fa-angle-down')) {
            $('.event-prestige-effects-container').slideDown();
            $(this).find('i').removeClass('fa-angle-down');
            $(this).find('i').addClass('fa-angle-up');
        }
        else {
            $('.event-prestige-effects-container').slideUp();
            $(this).find('i').addClass('fa-angle-down');
            $(this).find('i').removeClass('fa-angle-up');
        }
    });

    // Show feud history
    const $feudHistoryContainer = $('#feud-history-container');
    $feudHistoryContainer.on('click', '.feud-history-item', async function () {
        let $el = $(this);
        // Deselect
        if ($el.hasClass('selected')) {
            // Show all feuds
            $('.feud-history').html('').hide();
            $('.current-feuds').children().show();
            $('.potential-feuds').children().show();
            $('.past-feuds').children().show();
            $el.removeClass('selected');
            $('.feuds-history-search-input').val('');

            // Tutorial action check
            checkTutorialStepAction('unselect_feud_history_item');
        }
        // Select
        else {
            let uid = parseInt($el.attr('data-uid'));
            await loadViewFeudHistoryPage(uid, $el);
        }
    });

    // End feud
    $feudHistoryContainer.on('click', '#end-feud-button', async function (e) {
        e.stopPropagation();
        let $el = $(this);
        notie.confirm({
            text: 'Are you sure you want to end this Feud?',
            submitCallback: async function () {
                let parentElement = $el.closest('.feud-history-item');
                let uid = parseInt(parentElement.attr('data-uid'));
                await getEndFeudRequest(uid);
            },
            cancelText: 'No'
        });
    });

    // Create feud button handler
    $game.on('click', '#create-feud-menu-button', async function () {
        // Load participants and feud items
        let defaultParticipantValue = 'singles';
        $('.create-feud-participant-type-select').val(defaultParticipantValue);
        if (!globalUser.paid) {
            $('.create-feud-participant-type-select option[value="faction"]').remove()
        }
        await loadCreateFeudPage(defaultParticipantValue, [], true, true);
    });

    // Get participants for create feud
    const $createFeud = $('#create-feud');
    $createFeud.on('change', '.create-feud-participant-type-select', async function () {
        let participantType = $(this).val();
        await loadCreateFeudPage(participantType, [], true);
    });

    // Get feud items for create feud
    $createFeud.on('change', '.create-feud-first-participant-select, ' +
        '.create-feud-second-participant-select', async function () {
        const $firstParticipantSelect = $('.create-feud-first-participant-select');
        const $secondParticipantSelect = $('.create-feud-second-participant-select');
        let firstParticipantUid = parseInt($firstParticipantSelect.find(':selected').attr('data-uid'));
        let secondParticipantUid = parseInt($secondParticipantSelect.find(':selected').attr('data-uid'));

        if (firstParticipantUid && secondParticipantUid) {
            let participantUids = [firstParticipantUid, secondParticipantUid];
            let participantType = $('.create-feud-participant-type-select').find(':selected').val();
            await loadCreateFeudPage(participantType, participantUids, false);
        }

        // Tutorial action check
        if ($firstParticipantSelect.val() === 'Johnny Knight') {
            checkTutorialStepAction('select_first_feud_superstar');
        }
        if ($secondParticipantSelect.val() === 'Joe Hammer') {
            checkTutorialStepAction('select_second_feud_superstar');
        }
    });

    // Select feud item for create feud
    $createFeud.on('click', '.feud-item-container', function () {
        // Don't run for disabled feud item
        if ($(this).hasClass('disabled')) {
            return false;
        }

        let $this = $(this);

        if ($this.hasClass('selected')) {
            // Deselect this feud item
            $this.removeClass('selected');

            // Show all feud items
            $("#create-feud .feud-item-container").show();
        }
        else {
            // Unselect other feud items
            $("#create-feud .feud-item-container.selected").removeClass('selected');

            // Select this feud item
            $this.addClass('selected');

            // Hide all other feud items
            $("#create-feud .feud-item-container:not(.selected)").hide();
        }

        // Tutorial action check
        checkTutorialStepAction('select_create_feud_item');
    });

    // Create feud button
    $createFeud.on('click', '#create-feud-button', async function () {
        let firstParticipantUid = parseInt($('.create-feud-first-participant-select').find(':selected').attr('data-uid'));
        let secondParticipantUid = parseInt($('.create-feud-second-participant-select').find(':selected').attr('data-uid'));
        let participantUids = [firstParticipantUid, secondParticipantUid];
        let participantType = $('.create-feud-participant-type-select').find(':selected').val();
        let feudItemSelected = $('#create-feud .feud-item-container.selected');
        let feudItemUid = parseInt(feudItemSelected.attr('data-uid'));
        let customFeudName = feudItemSelected.find('.feud-item-custom-name').val();

        // Validate
        if (feudItemSelected.length <= 0) {
            notie.alert({type: 3, text: 'Feud Item not selected.', stay: true});
            return;
        }
        if (!firstParticipantUid || !secondParticipantUid) {
            notie.alert({type: 3, text: 'Participants not selected.', stay: true});
            return;
        }

        await getCreateFeudRequest(feudItemUid, customFeudName, participantUids, participantType);
    });

    // Custom feud name click
    const $feudItemsContainerAndCreateFeud = $("#feud-items-container, #create-feud");
    $feudItemsContainerAndCreateFeud.on('click', '.feud-item-custom-name', function (e) {
        e.stopPropagation();
    });
    $createFeud.on('input', '#create-feud-custom-name', function () {
        // Tutorial action check
        checkTutorialStepAction('enter_feud_name');
    });

    // Generate feud name hover, remove parent hover
    $feudItemsContainerAndCreateFeud.on('mouseover', '.generate-feud-name-icon', function () {
        $(this).closest('.feud-item-container').addClass('not-hovered');
    }).on('mouseout', '.generate-feud-name-icon', function () {
        $(this).closest('.feud-item-container').removeClass('not-hovered');
    });

    // Generate Feud Name
    $feudItemsContainerAndCreateFeud.on('click', '.generate-feud-name-icon', function (e) {
        e.stopPropagation();
        let $el = $(this);
        let previousName;
        if ($el.closest('#feud-items-container').length > 0) {
            previousName = $('#feud-items-container-custom-name').val();
        }
        if ($el.closest('#create-feud').length > 0) {
            previousName = $('#create-feud-custom-name').val();
        }
        let feudName = generateRandomFeudItemName(previousName);
        $el.closest('.feud-item-container').find('.feud-item-custom-name').val(feudName).trigger('input');
    });

    // Custom feud name spacing
    $(function () {
        const $feudItemsContainerCustomNameHide = $('#feud-items-container-custom-name-hide');
        const $feudItemsContainerCustomName = $('#feud-items-container-custom-name');
        $feudItemsContainerCustomNameHide.text($feudItemsContainerCustomName.val());
        $feudItemsContainerCustomName.width($feudItemsContainerCustomNameHide.width());
    }).on('input', function () {
        const $feudItemsContainerCustomNameHide = $('#feud-items-container-custom-name-hide');
        const $feudItemsContainerCustomName = $('#feud-items-container-custom-name');
        $feudItemsContainerCustomNameHide.text($feudItemsContainerCustomName.val());
        $feudItemsContainerCustomName.width($feudItemsContainerCustomNameHide.width() + 12);
    });
    $(function () {
        const $createFeudCustomNameHide = $('#create-feud-custom-name-hide');
        const $createFeudCustomName = $('#create-feud-custom-name');
        $createFeudCustomNameHide.text($createFeudCustomName.val());
        $createFeudCustomName.width($createFeudCustomNameHide.width());
    }).on('input', function () {
        const $createFeudCustomNameHide = $('#create-feud-custom-name-hide');
        const $createFeudCustomName = $('#create-feud-custom-name');
        $createFeudCustomNameHide.text($createFeudCustomName.val());
        $createFeudCustomName.width($createFeudCustomNameHide.width() + 12);
    });

    // Go back to view feuds
    $createFeud.on('click', '#back-to-view-feuds-button', function () {
        $('#view-feuds-menu-button').trigger('click');
    });

     // Sort feuds
    $('.feuds-history-sort').on('change', function () {
        let value = $(this).val();
        applyFeudsHistorySort(value);
    });

    // Change feud sort order
    $('.feuds-history-sort-order').on('click', function() {
        let icon = $(this).find('i');
        let sortedElements = $('.feud-history-item').get().reverse();
        // Reverse superstar elements
        if (icon.hasClass('fa-sort-up')) {
            icon.removeClass('fa-sort-up').addClass('fa-sort-down');
        }
        else if (icon.hasClass('fa-sort-down')) {
            icon.removeClass('fa-sort-down').addClass('fa-sort-up');
        }
        sortedElements.forEach(function (e) {
            $(e).parent().append(e)
        });
    });

    // Search feuds
    $(".feuds-history-search-input").on('input', function(){
        runFeudHistorySearch();
    });

    // View stats company select
    const $companyStatsContainer = $('#company-stats-container');
    $companyStatsContainer.on('change', '.select-company-for-view-stats', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewStatsPage(companyUid);
    });

    // View stats brand select
    $companyStatsContainer.on('click', '.company-stats-brand-filter', async function(e){
        let parent = $(this).parent();
        let companyUid = parseInt($(".select-company-for-view-stats").find(":selected").attr('data-uid'));
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
            await loadViewStatsPage(companyUid);
        }
        else {
            parent.find('.company-stats-brand-filter').removeClass('selected');
            $(this).addClass('selected');
            await loadViewStatsPage(companyUid, $(this).text());
        }
    });

    // Load add gimmick match page
    const $addGimmickMatch = $("#add-gimmick-match");
    $('#view-gimmick-matches-container').on('click', '#add-gimmick-match-menu-button', function () {
        playSoundEffect('success');

        // Reset inputs
        $('#add-gimmick-match').find('input').val('');
        $addGimmickMatch.find('select[name="match-rating-boost"], ' +
            'select[name="match-popularity-boost"], select[name="match-injury-rate"]').val('1');
        $addGimmickMatch.find('select[name="match-rules"]').val('');
        $addGimmickMatch.find('select[name="match-consequence"]').val('').trigger('change');
        $addGimmickMatch.find('select[name="match-graphic"]').parent().show();
        $addGimmickMatch.find('select[name="match-add-random-weapons"]').parent().show();
        $addGimmickMatch.find('select[name="match-graphic"]').val('');
        $addGimmickMatch.find('select[name="match-add-random-weapons"]').val('0');

        hideContent($());
        $addGimmickMatch.fadeIn('slow').removeClass('display-none');

        // Tutorial action check
        checkTutorialStepAction('click_add_gimmick_match_menu_button');
    });

    // Load remove gimmick match page
    $game.on('click', '#remove-gimmick-match-menu-button', async function () {
        await loadRemoveGimmickMatchesPage();
    });

    // Go back to view gimmick matches
    $game.on('click', '.back-to-view-gimmick-matches-button', function () {
        $("#view-gimmick-matches-menu-button").trigger('click')
    });

    // Add gimmick match
    $('#add-gimmick-match').on('click', '#add-gimmick-match-button', async function () {
        await getAddGimmickMatchRequest();
    });

    // Remove gimmick match
    $('#remove-gimmick-match').on('click', '#remove-gimmick-match-button', async function () {
        let name = $("#remove-gimmick-match .select-gimmick-match").val();
        await getRemoveGimmickMatchRequest(name);
    });

    // Show gimmick match consequences
    $addGimmickMatch.on('change', "select[name='match-consequence']", function () {
        $(this).parent().siblings('.match-cashin-contract-name-container, ' +
            '.match-contract-name-container').addClass('display-none').removeClass('display-block');
        if ($(this).val() === "cashin_contract") {
            $(this).parent().siblings('.match-cashin-contract-name-container').addClass('display-block').removeClass('display-none');
        }
        else if ($(this).val() === "match_contract") {
            $(this).parent().siblings('.match-contract-name-container').addClass('display-block').removeClass('display-none');
        }

        // Tutorial action check
        if ($(this).val() === "match_contract") {
            checkTutorialStepAction('select_gimmick_match_consequence');
        }
    });

    // Add custom segment menu button
    $('#view-segments-container').on('click', '#add-custom-segment-menu-button', function () {
        playSoundEffect('success');
        hideContent($());

        const $addCustomSegmentContainer = $('.add-custom-segment-container');
        const $addCustomSegmentHelpTextContainer = $('.add-custom-segment-help-text-container');
        const $addCustomSegmentHelpButton = $(".add-custom-segment-help-button");
        customSegmentsData.addCustomSegmentChangesMade = false;
        $addCustomSegmentContainer.removeClass('scroll margin-top-20').fadeIn('slow');

        // Reset
        $(".add-custom-segment-template-button:contains('Basic')").trigger('click');
        $('.add-custom-segment-more-options').hide();
        let customSegmentMoreOptionsButton = $(".add-custom-segment-more-options-button");
        customSegmentMoreOptionsButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentMoreOptionsButton.find('span').text('Show Details');
        $('.import-community-segment-input').val('');

         $('.add-custom-segment-community-segments-container').hide();
        let customSegmentCommunitySegmentsButton = $(".add-custom-segment-show-community-segments-button");
        customSegmentCommunitySegmentsButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentCommunitySegmentsButton.find('span').text('Show Community Segments');

        // Show save options
        $('.add-custom-segment-save-to-game-container').show();
        $('.add-custom-segment-save-to-community-container').show();

        // Hide edit info
        $('.edit-custom-segment-button').hide();
        $('.add-custom-segment-button').show();
        $('.add-custom-segment-label').text('Add Custom Segment');

        $addCustomSegmentHelpTextContainer.hide();
        let customSegmentHelpButton = $addCustomSegmentHelpButton;
        customSegmentHelpButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentHelpButton.find('span').text('Show How It Works');

        // Disable if free user
        if (!globalUser.paid) {
            $addCustomSegmentContainer.addClass('disabled');
            $addCustomSegmentContainer.find('input, textarea').prop('disabled', true);
            $addCustomSegmentContainer.addClass('help-text');
            $addCustomSegmentContainer.attr('title', 'JoW Paid includes Custom Segments');

            $addCustomSegmentHelpTextContainer.hide();
            let customSegmentHelpButton = $addCustomSegmentHelpButton;
            customSegmentHelpButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
            customSegmentHelpButton.find('span').text('Show How It Works');
        }
        else {
            $addCustomSegmentContainer.removeClass('help-text');
            $addCustomSegmentContainer.removeAttr('title');
            $addCustomSegmentContainer.removeClass('disabled');
            $addCustomSegmentContainer.find('input, textarea').prop('disabled', false);
        }
    });

    // Edit custom segment menu button
    $game.on('click', '#edit-custom-segment-menu-button', async function () {
        await loadEditSegmentsPage();
    });

    // Load edit custom segment page
    const $editCustomSegmentContainer = $('.edit-custom-segment-container');
    $editCustomSegmentContainer.on('click', '#edit-custom-segment-container-button', async function (e) {
        let name = $(".edit-custom-segment-container .select-custom-segment").val();
        await loadEditSegmentPage(name);
    });

    // Remove custom segment
    $editCustomSegmentContainer.on('click', '#remove-custom-segment-button', async function (e) {
        let name = $(".edit-custom-segment-container .select-custom-segment").val();
        await getRemoveSegmentRequest(name);
    });

    // Add custom segment
    $(".add-custom-segment-button").on("click", async function () {
        await getAddCustomSegmentRequest();
    });

    // Edit custom segment
    $(".edit-custom-segment-button").on("click", async function () {
        await getEditCustomSegmentRequest();
    });

    // Go back to view segments
    $game.on('click', '.back-to-view-segments-button', function () {
        $('#view-segments-menu-button').trigger('click');
    });

    // Custom segment preview
    const $addCustomSegmentContainer = $(".add-custom-segment-container");
    $addCustomSegmentContainer.on("click", ".add-custom-segment-preview-singles-button, " +
        ".add-custom-segment-preview-tag-button",
        function () {

            // Disabled if add custom segment disabled
            if ($addCustomSegmentContainer.hasClass('disabled')) {
                return false;
            }

            $('.add-custom-segment-preview-buttons-container .button').removeClass('selected');
            $(this).addClass('selected');

            let name = $('.add-custom-segment-name-input').val();
            let startText = $('.add-custom-segment-start-text').val();
            let actionTextInputs = $('.add-custom-segment-action-text').filter(function () {
                return !!this.value;
            });
            let actionText = $(getRandomChoice(actionTextInputs)).val();
            let numberOfParticipants = parseInt($('.add-custom-segment-participants-input').val());

            // Validate
            if (!name) {
                notie.alert({type: 3, text: "Enter a name for the Segment"});
                return false;
            }
            if (!startText) {
                notie.alert({type: 3, text: "Enter a Start Text for the Segment"});
                return false;
            }
            if (!actionText) {
                notie.alert({type: 3, text: "Enter an Action Text for the Segment"});
                return false;
            }

            let dataType;
            let participants;
            if ($(this).hasClass('add-custom-segment-preview-tag-button')) {
                dataType = 'tag';
                participants = previewSegmentTagParticipants;
            } else {
                dataType = 'singles';
                participants = previewSegmentSinglesParticipants;
            }

            // Get tag inputs if entered
            if (dataType === 'tag') {
                let tagStartText = $('.add-custom-segment-tag-start-text').val();
                if (tagStartText) {
                    startText = tagStartText
                }

                let tagActionTextInputs = $('.add-custom-segment-tag-action-text').filter(function () {
                    return !!this.value;
                });
                let tagActionText = $(getRandomChoice(tagActionTextInputs)).val();
                if (tagActionText) {
                    actionText = tagActionText
                }
            }

            // Get random participant objects based on number of participants
            shuffle(participants);
            participants = participants.slice(0, numberOfParticipants);

            let chooseWinner = $('input[name="add-custom-segment-choose-winner-option"]:checked').val() === 'yes';
            let nameElement = $('.add-custom-segment-preview-name');
            let startTextElement = $('.add-custom-segment-preview-start-text');
            let actionTextElement = $('.add-custom-segment-preview-action-text');
            runCustomSegmentPreviewAnimation(name, startText, actionText, participants, chooseWinner, nameElement,
                startTextElement, actionTextElement);

            // Select winner
            $addCustomSegmentContainer.off('click', '.match-wrestler');
            $addCustomSegmentContainer.on('click', '.match-wrestler', function () {
                let name = $(this).text();

                // Put winner first in participants
                participants.sort(function (x, y) {
                    return x.name === name ? -1 : y.name === name ? 1 : 0;
                });

                // Show action text
                actionText = parseCustomSegmentText(actionText, participants);
                $('.add-custom-segment-preview-action-text').html(actionText).hide().fadeIn(500);
            });

        }
    );

    // Show more options
    $(".add-custom-segment-more-options-button").on("click", function () {

        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass('disabled')) {
            return false;
        }

        let el = $(this);
        if (el.find('i').hasClass('fa-angle-down')) {
            $('.add-custom-segment-more-options').slideDown(function () {
                el.find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
                el.find('span').text('Hide Details');
            });
        }
        else {
            $('.add-custom-segment-more-options').slideUp(function () {
                el.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
                el.find('span').text('Show Details');
            });
        }
    });

    // Show help
    $(".add-custom-segment-help-button").on("click", function () {

        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass('disabled')) {
            return false;
        }

        let el = $(this);
        if (el.find('i').hasClass('fa-angle-down')) {
            $('.add-custom-segment-help-text-container').slideDown(function () {
                el.find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
                el.find('span').text('Hide How It Works');
            });
        }
        else {
            $('.add-custom-segment-help-text-container').slideUp(function () {
                el.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
                el.find('span').text('See How It Works');
            });
        }
    });

    // Change cost if changing save to game option
    $("input[name='add-custom-segment-save-to-game-option']").on("change", function () {
            let value = $(this).val();
            if (value === 'yes') {
                $('.add-custom-segment-cost').text(30)
            }
            else {
                $('.add-custom-segment-cost').text(0)
            }
        }
    );

    // Add custom segment action text inputs
    $addCustomSegmentContainer.on("click", ".add-custom-segment-add-action-text-button, " +
        ".add-custom-segment-remove-action-text-button", function () {

        // Disabled if add custom segment disabled
        if ($addCustomSegmentContainer.hasClass('disabled')) {
            return false;
        }

        // Add input
        const $addCustomSegmentActionText = $('.add-custom-segment-action-text');
        if ($(this).hasClass('add-custom-segment-add-action-text-button')) {

            // Don't allow more than 8 inputs
            if ($addCustomSegmentActionText.length > 8) {
                notie.alert({type: 3, text: "You can't have more than 8 action texts"});
                return false;
            }

            $addCustomSegmentActionText.last().after(
                '<textarea class="add-custom-segment-action-text styled-input margin-top-7" ' +
                'autocomplete="off" maxlength="200"></textarea>'
            );
        }

        // Remove input
        else {
            // Don't allow less than 1 input
            if ($addCustomSegmentActionText.length <= 1) {
                notie.alert({type: 3, text: "You can't have less than 1 action text"});
                return false;
            }
            $addCustomSegmentActionText.last().remove()
        }
    });

    // Add custom segment tag action text inputs
    $addCustomSegmentContainer.on("click", ".add-custom-segment-tag-add-action-text-button, " +
        ".add-custom-segment-tag-remove-action-text-button", function () {

        // Disabled if add custom segment disabled
        if ($('.add-custom-segment-container').hasClass('disabled')) {
            return false;
        }

        // Add input
        const $addCustomSegmentTagActionText = $('.add-custom-segment-tag-action-text');
        if ($(this).hasClass('add-custom-segment-tag-add-action-text-button')) {

            // Don't allow more than 8 inputs
            if ($addCustomSegmentTagActionText.length > 8) {
                notie.alert({type: 3, text: "You can't have more than 8 action texts"});
                return false;
            }

            $addCustomSegmentTagActionText.last().after(
                '<textarea class="add-custom-segment-tag-action-text styled-input margin-top-7" ' +
                'autocomplete="off" maxlength="200"></textarea>'
            );
        }
        // Remove input
        else {
            // Don't allow less than 1 input
            if ($addCustomSegmentTagActionText.length <= 1) {
                notie.alert({type: 3, text: "You can't have less than 1 action text"});
                return false;
            }
            $addCustomSegmentTagActionText.last().remove()
        }
    });

    // Copy start/action texts to tag textareas
    $('.add-custom-segment-copy-start-text-button').on('click', function () {
        // Disabled if add custom segment disabled
        if ($('.add-custom-segment-container').hasClass('disabled')) {
            return false;
        }
        let startText = $('.add-custom-segment-start-text').val();
        $('.add-custom-segment-tag-start-text').val(startText);
    });
    $('.add-custom-segment-copy-action-text-button').on('click', function () {
        // Disabled if add custom segment disabled
        if ($('.add-custom-segment-container').hasClass('disabled')) {
            return false;
        }
        $('.add-custom-segment-tag-action-text').each(function (i, el) {
            let actionText = $('.add-custom-segment-action-text').eq(i).val();
            $(this).val(actionText);
        })
    });

    // Check for changes made
    $('.add-custom-segment-name-input, .add-custom-segment-participants-input, .add-custom-segment-start-text, ' +
        '.add-custom-segment-action-text, .add-custom-segment-tag-start-text, ' +
        '.add-custom-segment-tag-action-text').on('change', function() {
            customSegmentsData.addCustomSegmentChangesMade = true;
            // Deselect community segment result
            $('.community-segments-box').find('.community-segments-search-result-item.selected').removeClass('selected');
    });

    // Load templates
    $(".add-custom-segment-template-button").on("click", function () {
        // Disabled if add custom segment disabled
        if ($('.add-custom-segment-container').hasClass('disabled')) {
            return false;
        }
        let el = $(this);
        if (customSegmentsData.addCustomSegmentChangesMade) {
            notie.confirm({
                text: 'Are you sure? Any existing data will be overwritten.',
                submitCallback: function () {
                    loadCustomSegmentTemplate(el);
                }
            })
        } else {
            loadCustomSegmentTemplate(el);
        }
    });

    // Import segment
    $addCustomSegmentContainer.on('click', '.import-community-segment-button', function () {
        if (globals.requestRunning) {
            return;
        }

        // Disabled if add custom segment disabled
        if ($('.add-custom-segment-container').hasClass('disabled')) {
            return false;
        }

        let el = $(this);
        let uid = el.siblings('.import-community-segment-input').val();
        if (!uid) {
            notie.alert({type: 3, text: "Enter a code to import"});
            return false;
        }

        // Deselect community segment result
        $('.community-segments-box').find('.community-segments-search-result-item.selected').removeClass('selected');

        if (customSegmentsData.addCustomSegmentChangesMade) {
            notie.confirm({
                text: 'Are you sure? Any existing data will be overwritten.',
                submitCallback: function () {
                    loadCommunitySegment(el, uid);
                }
            })
        } else {
            loadCommunitySegment(el, uid);
        }
    });

    // Trigger import on enter key press
    $(".import-community-segment-input").keypress(function(e){
        if (e.which === 13) {
            $(".import-community-segment-button").trigger('click');
        }
    });

    // Show community segments
    $(".add-custom-segment-show-community-segments-button").on("click", function () {

        // Disabled if add custom segment disabled
        if ($('.add-custom-segment-container').hasClass('disabled')) {
            return false;
        }

        let el = $(this);
        if (el.find('i').hasClass('fa-angle-down')) {
            // Show 'new' segments
            $(".add-custom-segment-community-segments-container")
                .find('.community-segments-sort-button[data-value="new"]').trigger('click');
            $('.add-custom-segment-community-segments-container').slideDown(function () {
                el.find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
                el.find('span').text('Hide Community Segments');
            });
        }
        else {
            $('.add-custom-segment-community-segments-container').slideUp(function () {
                el.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
                el.find('span').text('Show Community Segments');
            });
        }
    });

    // Select community segment result
    $addCustomSegmentContainer.on('click', '.community-segments-search-result-item', function () {
        if (globals.requestRunning) {
            return;
        }

        let parent = $('.community-segments-box');

        // Select this element
        parent.find('.community-segments-search-result-item.selected').removeClass('selected');
        $(this).addClass('selected');

        let el = $(this);
        let uid = el.data('uid');
        if (customSegmentsData.addCustomSegmentChangesMade) {
            notie.confirm({
                text: 'Are you sure? Any existing data will be overwritten.',
                submitCallback: function () {
                    loadCommunitySegment(el, uid);
                }
            })
        } else {
            loadCommunitySegment(el, uid);
        }
    });

    // View titles company select
    $('#titles-box').on('change', '.select-company-for-view-titles', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewTitlesPage(companyUid);
    });

    // Show add championship page
    $game.on('click', '#add-championship-menu-button', async function () {
        await loadAddChampionshipPage();
    });

    // Populate talent select for add championship page
    $game.on('change', '.add-championship-division', async function () {
        // Populate champion select
        let value = $(this).val();
        if (value === 'tag-team') {
            value = 'tag'
        }
        let talentData = await getAllTalentData(value);
        let $championshipChampion = $('.add-championship-container select[name="championship-champion"]');
        let championNamesOptions = '<option value="">None</option>';
        talentData.forEach(function (talent) {
            championNamesOptions += '<option value="' + talent['uid'] + '">' + talent['name'] + '</option>'
        });
        $championshipChampion.html(championNamesOptions);
    });

    // Show retire championship page
    $game.on('click', '#retire-championship-menu-button', async function () {
        let $selectElement = $('#retire-championship .select-championship-all');
        let selectedChampionship = $('.company-championship-select').val();
        await loadRetireChampionshipPage($selectElement, selectedChampionship);
    });

    // Show vacate championship page
    $game.on('click', '#vacate-championship-menu-button', async function () {
        let $selectElement = $('#vacate-championship .select-championship-all');
        let selectedChampionship = $('.company-championship-select').val();
        await loadVacateChampionshipPage($selectElement, selectedChampionship);
    });

    // Show rebrand championship page
    $game.on('click', '#rebrand-championship-menu-button', async function () {
        let $element = $(".rebrand-championship-container");
        let selectedChampionship = $('.company-championship-select').val();
        await loadRebrandChampionshipPage($element, selectedChampionship);
    });

    // Show championship points cost
    const $addChampionshipContainer = $(".add-championship-container");
    $addChampionshipContainer.on('change', 'select[name=championship-rank]', function () {
        let cost = getAddChampionshipCost($('.add-championship-container'));
        $(this).closest('.add-championship-container').find('.add-championship-cost').text(cost);
    });

    // Show/hide championship graphic
    $addChampionshipContainer.on('change', 'select[name="championship-graphic-option"]', function () {
        if ($(this).val() === '0') {
            $('.championship-graphic-container').hide()
        }
        else if ($(this).val() === '1') {
            $('.championship-graphic-container').show()
        }
    });

    // Load title details upon changing title select
    const $rebrandChampionshipContainer = $(".rebrand-championship-container");
    $rebrandChampionshipContainer.on('change', '.rebrand-championship-championship-select', function () {
        let selected = $(this).find(':selected');
        let parent = $(this).closest('.rebrand-championship-container');

        // Get graphic using data attribute
        let graphic = selected.data('graphic');
        if (!graphic) {
            // Default title graphic
            graphic = {"centerPlate":{"object":0,"colors":["0xC59548"]},"strap":{"object":9,"colors":["0x1D1D1D"]},
                "sidePlates":{"object":9,"colors":["0xC59548"]},"centerGems":{"object":9,"colors":["0xC51616"]},
                "sideGems":{"object":9,"colors":["0xC51616"]}};
            parent.find('.rebrand-championship-change-label').text('Add');
        }
        else {
            parent.find('.rebrand-championship-change-label').text('Change');
        }
        $('#change-championship-graphic').data('key', JSON.stringify(graphic));

        // Load graphic using import code
        parent.find('.load-character-code-input').val(JSON.stringify(graphic));
        parent.find('.load-character-code-button').trigger('click');

        // Get gimmick restriction using data attribute
        let gimmickRestriction = selected.data('gimmickRestriction');
        let gimmickRestrictionType = (gimmickRestriction) ? (gimmickRestriction['type']) : 'none';

        // Add gimmick restriction value as default value
        if (gimmickRestrictionType === 'gimmick_match') {
            parent.find('.championship-gimmick-match-select').data('default-value', gimmickRestriction['value'])
        }
        else if (gimmickRestrictionType === 'minimum_age') {
            parent.find('.championship-minimum-age-input').data('default-value', gimmickRestriction['value'])
        }
        else if (gimmickRestrictionType === 'maximum_age') {
            parent.find('.championship-maximum-age-input').data('default-value', gimmickRestriction['value'])
        }

        // Select brand
        if (globalUser.paid) {
            let brandName = selected.data('brandName');
            parent.find('.rebrand-championship-brand-select').val(brandName);
        }
        else {
            parent.find('.rebrand-championship-brand-select').parent().hide();
        }

        // Trigger change on championship gimmick select
        parent.find('.championship-gimmick-select').val(gimmickRestrictionType).trigger('change');
    });

    // Show/hide championship graphic controls
    $rebrandChampionshipContainer.on('change', 'input[name="radio-change-championship-graphic-option"]', function () {
        let val = $(this).val();
        let parent = $(this).closest('.rebrand-championship-container');
        const $changeChampionshipGraphic = $('#change-championship-graphic');

        if (val === 'change') {
            // Load graphic
            let graphic = JSON.parse($changeChampionshipGraphic.data('key'));
            if (!graphic) {
                // Default title graphic
                graphic = {
                    "centerPlate": {"object": 0, "colors": ["0xC59548"]},
                    "strap": {"object": 9, "colors": ["0x1D1D1D"]},
                    "sidePlates": {"object": 9, "colors": ["0xC59548"]},
                    "centerGems": {"object": 9, "colors": ["0xC51616"]},
                    "sideGems": {"object": 9, "colors": ["0xC51616"]}
                };
                parent.find('.rebrand-championship-change-label').text('Add');
            }
            showAddChampionshipPageGraphic($changeChampionshipGraphic, [graphic]);
            // Show controls
            $changeChampionshipGraphic.next('.character-creator-controls').show();
            $('.sp-replacer').addClass('grey-background');
        }
        else {
            $changeChampionshipGraphic.html('');
            $changeChampionshipGraphic.next('.character-creator-controls').hide();
        }
    });

    // Go back to view titles
    $game.on('click', '.back-to-view-titles-button', function () {
        $('#view-titles-menu-button').trigger('click');
    });

    // Add championship
    $game.on('click', '#add-championship-button', async function () {
        await getAddChampionshipRequest();
    });

    // Retire championship
    $('#retire-championship').on('click', '#retire-championship-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let uid = parseInt($("#retire-championship .select-championship-all").find(':selected').data('uid'));
                await getRetireChampionshipRequest(uid);
            },
            cancelText: 'No'
        });
    });

    // Vacate championship
    $('#vacate-championship').on('click', '#vacate-championship-button', async function () {
        let uid = parseInt($("#vacate-championship .select-championship-all").find(':selected').data('uid'));
        await makeGameRequest(vacateChampionship, {uid}, showVacateChampionshipData, {}, false);
    });

    // Rebrand championship
    $game.on('click', '#rebrand-championship-button', async function () {
        await getRebrandChampionshipRequest();
    });

    // Rebrand company menu button
    $('#view-companies-container').on('click', '#rebrand-company-menu-button', async function () {
        playSoundEffect('success');
        let element = $(".rebrand-company-container");
        hideContent($());

        // Reset name input
        element.find('.rebrand-company-name-input').val('');

        element.fadeIn('slow').removeClass('display-none');
    });

    // Rebrand company
    $game.on('click', '#rebrand-company-button', async function () {
        await getRebrandCompanyRequest();
    });

    // Go back to view companies
    $game.on('click', '.back-to-view-companies-button', function () {
        playSoundEffect('success');
        hideContent($());
        $("#view-companies-container").fadeIn('slow');
    });

    // Buy powerup
    const $powerupsBox = $('#powerups-box');
    $powerupsBox.on('click', '.buy-powerup', async function () {
        let powerupContainer = $(this).closest('.powerup-container');
        let uid = parseInt(powerupContainer.attr('data-uid'));
        await makeGameRequest(buyPowerup, {uid}, showBuyPowerupData, {powerupContainer}, false);
    });

    // Use powerup
    $powerupsBox.on('click', '.use-powerup', async function () {
        let powerupContainer = $(this).closest('.powerup-container');
        let uid = parseInt(powerupContainer.attr('data-uid'));
        await makeGameRequest(usePowerup, {uid}, showUsePowerupData, {powerupContainer}, false);
    });

    // Cancel powerup
    $powerupsBox.on('click', '.powerup-cancel-button', function () {
        $('#powerups-inventory').children().show();
        let selectedPowerup = $('#powerups-inventory').find('.selected');
        selectedPowerup.removeClass('selected').find('.powerup-bottom').show();
        selectedPowerup.find('.powerup-cancel').hide();
        selectedPowerup.find('.powerup-description').hide();
        selectedPowerup.addClass('help-text');
        $('#powerups-selection').hide();
        $('.powerups-header').show();

    });

    // Apply powerup
    $powerupsBox.on('click', '.powerups-selection-item', async function () {
        let uid = parseInt($(this).closest('#powerups-selection').attr('data-uid'));
        let selectionUid = parseInt($(this).attr('data-uid'));
        await makeGameRequest(applyPowerup, {uid, selectionUid}, showApplyPowerupData, {}, false);
    });

    // Buyout button in view companies
    $('#view-companies-container').on('click', '.buyout-competitor-button', async function () {
        let element = $(".buyout-competitor-box");
        let uid = parseInt($(this).parent().parent().attr('data-uid'));
        await makeGameRequest(getBuyoutInformation, {uid}, showBuyoutInformationData, {element, uid});
    });

    // Make buyout offer button
    $(".buyout-competitor-box").on('click', '#make-buyout-offer', async function () {
        let $parent = $(this).closest('.buyout-competitor-box');
        let uid = $parent.data('uid');
        let talentManagerUid = $parent.find('.buyout-competitor-talent-manager-select').find(':selected').val();
        await makeGameRequest(makeBuyoutOffer, {uid, talentManagerUid}, showMakeBuyoutOfferData, {uid}, false);
    });

    // Form new company menu button
    $('#view-companies-container').on('click', '#form-new-company-menu-button', async function () {
        if (!globalUser.paid) {
            notie.alert({type: 3, text: "You can only form a new company in JoW Paid."});
            return;
        }
        if (globals.game.controlMultipleCompanies) {
            notie.alert({type: 3, text: "You cannot form new a new comany in Local Multiplayer."});
            return;
        }
        if (globals.game.story) {
            notie.alert({type: 3, text: "You cannot form new a new comany in story modes."});
            return;
        }
        await makeGameRequest(getFormNewCompanyInformation, {}, showFormNewCompanyInformationData, {});
    });

    // Form new company button
    $('.form-new-company-box').on('click', '#form-new-company-button', async function () {
        notie.confirm({
            text: 'Are you sure? <span class="red">This decision is irreversible and you will only be able to book your new company.</span>',
            submitCallback: async function () {
                notie.confirm({
                    text: 'Are you really sure?',
                    submitCallback: async function () {
                        await makeGameRequest(startFormingNewCompany, {}, showFormNewCompanyData, {});
                    }
                });
            }
        });
    });
});

async function loadViewCompaniesPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view companies data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewCompaniesData = await getViewCompaniesData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view companies data
    hideContent($());
    showViewCompaniesPageData(viewCompaniesData);
}

function showViewCompaniesPageData(data) {
    let element = $("#view-companies-container");
    element.html('');

    let formNewCompanyHtml = '<button type="button" id="form-new-company-menu-button" class="button retro-button condensed ' +
        'grey-button-background float-right">Form New Company</button>';
    if (data['formingNewCompany']) {
        formNewCompanyHtml = '<span class="float-right faded-orange top-1px">Forming new company</span>'
    }

    // Add header
    element.append(
        '<div class="margin-bottom-30">' +
        '<span class="font-mukta-mahee font-1p325em menu-header-color">Companies</span>' +
        formNewCompanyHtml +
        '</div>'
    );

    // Add html for each company
    let companiesHtml = '';
    data['companies'].forEach(function (company) {
        companiesHtml += getViewCompaniesPageCompanyHtml(company)
    });

    // Add companies html
    element.append(
        '<div class="view-companies-list-container">' + companiesHtml + '</div>'
    );

    element.fadeIn('slow').removeClass('display-none');
    $('.view-companies-list-container').scrollTop(0);
}

function getViewCompaniesPageCompanyHtml(company) {

    // Get overness name class
    let companyOvernessClass = '';
    if (company['hot']) {
        companyOvernessClass = ' hot-color'
    }
    else if (company['stale']) {
        companyOvernessClass = ' stale-color'
    }

    // Get company name
    let companyNameHtml = '<span class="margin-right-8 line-height-24px">' + company['name'] + '</span>';

    // Get owner name
    let ownerHtml = '';
    if (company['ownerName']) {
        ownerHtml = '<div class="grey margin-top-5 line-height-24px">' + company['ownerName'] + '</div>'
    }

    // Get player name
    let playerNameHtml = '';
    if (company['playerName']) {
        playerNameHtml = '<div class="grey">{0}</div>'.format(company['playerName']);
    }

    // Show rebrand button if user company
    let rebrandCompanyButton = '';
    if (company['isUserCompany']) {
        rebrandCompanyButton = '<button type="button" id="rebrand-company-menu-button" ' +
            'class="button retro-button condensed grey-button-background margin-top-8 display-block">Rebrand</button>';
    }

    // Show buyout button if available
    let buyoutButton = '';
    if (company['availableForBuyout']) {
        buyoutButton = '<button type="button" class="button retro-button condensed blue-button-background ' +
                'buyout-competitor-button margin-top-8 display-block">Buyout</button>'
    }

    return '<div class="view-companies-list-item dark-grey" data-uid="' + company['uid'] + '">' +
            '<div class="col1">' +
                companyNameHtml +
                ownerHtml +
                playerNameHtml +
                buyoutButton +
                rebrandCompanyButton +
            '</div>' +
            '<div class="col2">' +

                // Fans
                '<div>' +
                    '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small margin-right-8"/>' +
                    '<span class="font-mukta-mahee font-1p125em top--1px">' +
                        '<span class="red">' + getFansHtml(company['fans']) + '</span>' +
                    '</span>' +
                '</div>' +

                // REP
                '<div class="medium-grey margin-top-2 help-text" title="Company Reputation, ranging from 1 to 10, affects Roster size.">' +
                    '<span>REP ' + company['reputation'] + '</span>' +
                    '<span class="grey margin-left-8">' + 'Highest ' + company['highestReputation'] + '</span>' +
                '</div>' +

                // Overness
                '<div class="medium-grey help-text" title="Company Overness, ranging from Stale to Hot, affects Event Hype for their shows.">' +
                '<span class="' + companyOvernessClass + '">' + getCompanyOvernessLevelText(company['overness']) + '</span>' +
                    '<span class="grey margin-left-8">' + company['overness'] + '%</span>' +
                '</div>' +

                // Style
                '<div class="medium-grey help-text" title="Company Style can be Entertainment or Pure. Entertainment rewards Gimmicks while ' +
                'Pure rewards Match Quality.">' +
                    '<span class="">' + toTitleCase(company['style']) + '</span>' +
                '</div>' +

            '</div>' +
            '<div class="clear"></div>' +
        '</div>';
}

function getCompanyOvernessLevelText(overness) {
    let text;
    if (overness >= 80) {
        text = 'Hot'
    }
    else if (overness >= 60) {
        text = 'Popular';
    }
    else if (overness >= 40) {
        text = 'Average';
    }
    else if (overness >= 20) {
        text = 'Not Popular';
    }
    else if (overness >= 0) {
        text = 'Stale'
    }
    return text;
}

async function loadViewObjectivesPage() {  // Previously get_objectives

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view objectives data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewObjectivesData = await getViewObjectivesData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view objectives data
    hideContent($());
    showViewObjectivesPageData(viewObjectivesData);
}

function showViewObjectivesPageData(data) {

    let element = $("#objectives-list");
    element.html('');

    // Add objectives
    element.append(
        '<div class="margin-bottom-30">' +
        '<span class="font-mukta-mahee font-1p325em menu-header-color">Goals</span>' +
        '</div>'
    );
    let objectivesHtml = '';
    data['objectives'].forEach(function (objective) {
        objectivesHtml += getViewObjectivesPageObjectiveHtml(objective)
    });
    element.append(
        '<div class="objectives-container">' + objectivesHtml + '</div>'
    );

    element.fadeIn('slow').removeClass('display-none');

    // Tutorial action check
    if (data['nextTutorialState']) {
        globals.game.tutorialState = data['nextTutorialState']
    }

    // Tutorial action check
    checkTutorialStepAction('click_view_objectives');
}

function getViewObjectivesPageObjectiveHtml(objective) {

    // Get status
    let statusHtml;
    if (objective['completed']) {
        statusHtml = '<span class="col2 light-green"><i class="fa fa-check-square-o margin-right-5 ' +
            'font-0p825em"></i>Completed</span>';
    }
    else if (objective['failed']) {
        statusHtml = '<span class="col2 light-red"><i class="fa fa-cross-square-o margin-right-5 ' +
            'font-0p825em"></i>Failed</span>';
    }
    else {
        let left = '';
        if (objective['activationValue'] > 1) {
            left = ' (' + (objective['activationValue'] - objective['value']) + ' left)';
        }
        statusHtml = '<span class="col2 grey"><i class="fa fa-square-o margin-right-5 font-0p825em">' +
            '</i>Incomplete ' + left + '</span>';
    }

    // Get name
    let name = parseObjectiveName(objective['name'], '');

    // Get help text
    let helpTextHtml = '';
    if (objective['helpText']) {
        helpTextHtml = ' help-text"' + ' title="' + objective['helpText']
    }

    return '<div class="margin-bottom-15 objective-item-container">' +
        '<span class="col1' + helpTextHtml + '">' +
        name + '</span>' + statusHtml +
        '<div class="clear"></div>' +
        '</div>';
}

async function loadManagementActivityPage() {  // Previously get_management_activity

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view management activity data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewManagementActivityData = await getViewManagementActivityData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view management activity data
    hideContent($());
    showViewManagementActivityPageData(viewManagementActivityData);
}

function showViewManagementActivityPageData(data) {

    let element = $(".management-activity-container");
    element.html('');

    let div = '';

    // Signings
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Signings</span>';
    data['signings'].forEach(function (signing) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + signing['name'] +
            '<span class="margin-left-8 grey">' + signing['date'] + '</span>' +
            '<span class="blue">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-10 margin-right-5"/>' + signing['value'] +
            '</span>';
    });
    if (data['signings'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Callups
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Callups</span>';
    data['callups'].forEach(function (callup) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + callup['name'] +
            '<span class="margin-left-8 grey">' + callup['date'] + '</span>' +
        '</span>';
    });
    if (data['callups'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Releases
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Releases</span>';
    data['releases'].forEach(function (release) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + release['name'] +
            '<span class="margin-left-8 grey">' + release['date'] + '</span>' +
        '</span>';
    });
    if (data['releases'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Trade Deals
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Trade Deals</span>';
    data['tradeDeals'].forEach(function (tradeDeal) {
        let durationText = tradeDeal['value'];
        if (durationText) {
            durationText = '{0} {1}'.format(durationText, getMonthsWord(durationText))
        } else {
            durationText = 'Permanent'
        }
        div += '<span class="display-block dark-grey margin-bottom-3">' + tradeDeal['name'] +
            ' (' + durationText + ')' +
            '<span class="margin-left-8 grey">' + tradeDeal['date'] + '</span>' +
        '</span>';
    });
    if (data['tradeDeals'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // On Trade Talent
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">On Trade</span>';
    data['onTradeTalent'].forEach(function (superstar) {
        let companyName = (superstar['company']) ? superstar['company'] : '';
        let appearancesWord = getMonthsWord(superstar['appearances']);
        div += '<span class="display-block dark-grey margin-bottom-3">' + superstar['name'] +
            '<span class="margin-left-8 bright-blue">' + companyName + '</span>' +
            '<span class="margin-left-8 grey">' + superstar['appearances'] + ' ' + appearancesWord + '</span>' +
        '</span>';
    });
    if (data['onTradeTalent'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Events Rebranded
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Events Rebranded</span>';
    data['eventsRebranded'].forEach(function (eventData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + eventData['name'] +
            '<span class="margin-left-8 grey">' + eventData['date'] + '</span>' +
            '</span>';
    });
    if (data['eventsRebranded'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Championships Rebranded
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Championships Rebranded</span>';
    data['championshipsRebranded'].forEach(function (championshipData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + championshipData['name'] +
            '<span class="margin-left-8 grey">' + championshipData['date'] + '</span>' +
            '</span>';
    });
    if (data['championshipsRebranded'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Company Rebranded
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Company Rebranded</span>';
    data['companyRebranded'].forEach(function (companyData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + companyData['name'] +
            '<span class="margin-left-8 grey">' + companyData['date'] + '</span>' +
            '</span>';
    });
    if (data['companyRebranded'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Brands created
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Brands Added</span>';
    data['brandsCreated'].forEach(function (companyData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + companyData['name'] +
            '<span class="margin-left-8 grey">' + companyData['date'] + '</span>' +
            '</span>';
    });
    if (data['brandsCreated'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Brands removed
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Brands Removed</span>';
    data['brandsRemoved'].forEach(function (companyData) {
        div += '<span class="display-block dark-grey margin-bottom-3">' + companyData['name'] +
            '<span class="margin-left-8 grey">' + companyData['date'] + '</span>' +
            '</span>';
    });
    if (data['brandsRemoved'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    // Superstars Suspended
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Superstars Suspended</span>';
    data['superstarsSuspended'].forEach(function (suspensionData) {
        let monthsWord = getMonthsWord(suspensionData['value']);
        div += '<span class="display-block dark-grey margin-bottom-3">' + suspensionData['name'] +
            '<span class="margin-left-8 grey">' + suspensionData['date'] + '</span>' +
            '<span class="margin-left-8 grey">' + suspensionData['value'] + ' ' + monthsWord + '</span>' +
            '</span>';
    });
    if (data['superstarsSuspended'].length < 1) {
        div += '<span class="display-block grey">None</span>';
    }
    div += '</div>';

    element.append(
        '<div class="margin-bottom-30">' +
        '<span class="font-mukta-mahee font-1p325em menu-header-color">Activity</span>' +
        '</div>' +
        '<div class="management-activity-box">' +
        div +
        '</div>'
    );

    element.fadeIn('slow').removeClass('display-none');
    $('.management-activity-box').scrollTop(0);
}

async function loadFanHistoryPage(graphType, timePeriod) {

    if (globals.requestRunning) {
        return;
    }

    const $viewershipHistoryGraphBrandOption = $('.viewership-history-graph-brand-option');

    // Set values upon first load of fan history
    if (!graphType) {
        // Disable ratings war options if no market size
        let graphTypeSelector = $('.viewership-history-graph-type-select');
        if (!globals.game.marketSize) {
            graphTypeSelector.find('option[value="fans"]').attr('disabled', 'disabled');
            graphTypeSelector.find('option[value="viewers"]').attr('disabled', 'disabled');
            graphTypeSelector.find('option[value="buys"]').attr('disabled', 'disabled');
        } else {
            graphTypeSelector.find('option[value="fans"]').attr('disabled', false);
            graphTypeSelector.find('option[value="viewers"]').attr('disabled', false);
            graphTypeSelector.find('option[value="buys"]').attr('disabled', false);
        }
        graphType = (globals.game.marketSize) ? 'fans' : 'fan-change';
        timePeriod = 'all';
        $viewershipHistoryGraphBrandOption.parent().parent().hide();
    }

    // Get showBrandsSeparately option if visible
    let showBrandsSeparately;
    if ($viewershipHistoryGraphBrandOption.parent().parent().is(':visible')) {
        showBrandsSeparately = $viewershipHistoryGraphBrandOption.prop('checked');
    }

    // Get fan history data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let fanHistoryData = await getFanHistoryData(graphType, timePeriod, showBrandsSeparately);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show fan history data
    hideContent($());
    showFanHistoryPageData(fanHistoryData, graphType, timePeriod);
}

function showFanHistoryPageData(data, graphType, timePeriod) {
    if (!data['error']) {
        playSoundEffect('success');
        displayFanHistoryGraph(data['fanHistoryData'], graphType);
        $('.viewership-history-graph-type-select').val(graphType);
        $('.viewership-history-graph-period-select').val(timePeriod);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: 'Fan History is only available in JoW Paid'})
        }
    }
}

function displayFanHistoryGraph(data, graphType) {

    const $viewershipHistoryContainer = $(".viewership-history-container");

    // Destroy previous chart if found
    if (fanHistoryChart) {
        fanHistoryChart.destroy();
    }

    // Get series data
    let seriesData = [];
    let colors = [];
    data.forEach(function (d) {
        let obj = {name: d['name'], data: d['data'], companyId: d['companyId'], userControlled: d['userControlled']};
        seriesData.push(obj);
        colors.push(d['color']);
    });

    // Set theme variables
    let foreColor = '#474747';
    let axisBorderColor = '#bfbfbf';
    let gridColor = '#d1d1d1';
    if (characterBackgroundImage) {
        foreColor = '#9e9e9e';
        axisBorderColor = '#6b6b6b';
        gridColor = '#444444';
    }

    // Set options
    let dataLabelsEnabled = false;
    if (globalUser.settings.colorblindMode) {
        dataLabelsEnabled = true;
        $('.viewership-history-graph-labels-option').parent().parent().show();
        $('.viewership-history-graph-labels-option').prop('checked', true);
    }
    else {
        $('.viewership-history-graph-labels-option').parent().parent().hide();
        $('.viewership-history-graph-labels-option').prop('checked', false);
    }

    // Show/hide users button
    if (data.filter(x => x.userControlled).length > 1) {
        $('.viewership-history-show-users-button').show();
    }
    else {
        $('.viewership-history-show-users-button').hide();
    }

    let options = {
        series: seriesData,
        chart: {
            height: 300,
            type: 'line',
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: true,
                    zoom: '<i class="fa fa-search-plus"></i>',
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: '<i class="fa fa-search-minus"></i>',
                    customIcons: []
                },
                autoSelected: 'zoom',
                offsetY: 4,
                offsetX: -4
            },
            foreColor: foreColor,
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                    enabled: false,
                    delay: 150
                }
            },
            offsetX: -5
        },
        colors: colors,
        noData: {
            text: 'No data available',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: -7,
            style: {
                color: undefined,
                fontSize: '14px',
                fontFamily: undefined
            }
        },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return getViewershipText(value);
                },
                style: {
                    fontWeight: 700,
                    fontSize: '15px'
                },
                offsetX: 7
            },
            showForNullSeries: false
        },
        xaxis: {
            labels: {
                style: {
                    fontWeight: 700
                }
            },
            axisTicks: {
                show: false
            },
            type: 'datetime',
            tooltip: {
                style: {
                    fontSize: '12px'
                },
                offsetY: 3
            },
            axisBorder: {
                show: true,
                color: axisBorderColor,
                height: 1
            }
        },
        stroke: {
            width: 2
        },
        legend: {
            position: 'bottom',
            fontSize: '15px',
            fontWeight: 700,
            itemMargin: {
                horizontal: 8,
                vertical: 5
            },
            markers: {
                width: 10,
                height: 10,
                strokeWidth: 0,
                strokeColor: '#000000',
                radius: 0,
                offsetX: -3,
                offsetY: 0
            },
            offsetY: 10
        },
        tooltip: {
            style: {
                fontSize: '12px'
            },
            x: {
                show: false
            },
            y: {
                formatter: function (value, opts) {
                    if (value !== undefined) {
                        let yTooltipValue = opts.series[opts.seriesIndex][opts.dataPointIndex];
                        let yToolTipText = getViewershipText(yTooltipValue);
                        return (
                            opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].description +
                            ': ' +
                            yToolTipText
                        )
                    }
                },
                title: {
                    formatter: function () {
                        return ''
                    }
                }
            }
        },
        markers: {
            size: 0,
            strokeColors: undefined,
            strokeWidth: 0,
            strokeOpacity: 0,
            strokeDashArray: 0,
            fillOpacity: 0,
            hover: {
                size: undefined,
                sizeOffset: 2
            },
            shape: 'square',
            radius: 0
        },
        grid: {
            show: true,
            borderColor: gridColor
        },
        dataLabels: {
            enabled: dataLabelsEnabled,
            textAnchor: 'start',
            formatter: function (val, opts) {
                let allSeriesData = opts.w.config.series;
                let name = allSeriesData[opts.seriesIndex].name;
                let otherSeriesData = allSeriesData.filter(x => x !== allSeriesData[opts.seriesIndex]);
                let firstLetter = name[0];
                // If first letter exists in other series data, use first 3 letters, unless those 3 letters exist too
                if (otherSeriesData.map(x => x.name[0]).filter(x => x === firstLetter).length) {
                    if (!otherSeriesData.map(x => x.name.slice(0, 3)).filter(x => x === name.slice(0, 3)).length) {
                        return name.slice(0, 3)
                    }
                }
                return firstLetter;
            },
            offsetX: 0,
            style: {
                fontSize: '10px'
            },
            background: {
                enabled: true,
                foreColor: '#fff',
                padding: 2,
                borderRadius: 0,
                borderWidth: 0,
                borderColor: '#fff',
                opacity: 1
            }
        }
    };

    if (graphType === 'star-rating') {
        options.yaxis.min = 0;
        options.yaxis.forceNiceScale = true;
    }

    // Render graph
    fanHistoryChart = new ApexCharts(document.querySelector(".viewership-history-graph"), options);
    fanHistoryChart.render();

    if ($viewershipHistoryContainer.is(':visible')) {
        $viewershipHistoryContainer.show();
    }
    else {
        $viewershipHistoryContainer.fadeIn('slow')
    }
    hideContent($viewershipHistoryContainer);

    setTimeout(function () {
        // Tutorial action check
        checkTutorialStepAction('click_view_fan_history');
    }, 300);
}

async function loadViewCompanyStaffPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view company staff data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewCompanyStaffData = await getViewCompanyStaffData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view company staff data
    hideContent($());
    showViewCompanyStaffPageData(viewCompanyStaffData);
}

function showViewCompanyStaffPageData(data) {
    const $companyStaffMember = $('.company-staff-member');
    const $companyStaffRoleNumbers = $('.company-staff-role-numbers');
    const $companyStaffContainer = $('.company-staff-container');

    // Add staff members
    $companyStaffMember.html('');
    data['activeStaffMembers'].forEach(function (staffMember) {
        let staffMemberHtml = getCompanyStaffMemberHtml(staffMember);

        let elementToAddTo;
        switch (staffMember['role']) {
            case 'doctor':
                elementToAddTo = $('.company-staff-doctor .company-staff-member');
                break;
            case 'producer':
                elementToAddTo = $('.company-staff-producer .company-staff-member');
                break;
            case 'scout':
                elementToAddTo = $('.company-staff-scout .company-staff-member');
                break;
            case 'trainer':
                elementToAddTo = $('.company-staff-trainer .company-staff-member');
                break;
            case 'talent_manager':
                elementToAddTo = $('.company-staff-talent-manager .company-staff-member');
                break;
            default:
                elementToAddTo = $('.company-staff-other .company-staff-member');
        }

        elementToAddTo.append(staffMemberHtml);
    });

    // Add retired staff members
    $('.company-staff-retired-container').html('');
    data['retiredStaffMembers'].forEach(function (staffMember) {
        let staffMemberHtml = getCompanyStaffMemberHtml(staffMember);
        $('.company-staff-retired-container').append(staffMemberHtml);
    });
    if (data['retiredStaffMembers'].length <= 0) {
        $('.company-staff-retired').hide();
    } else {
        $('.company-staff-retired').show();
    }

    // Add empty staff role
    $companyStaffMember.each(function (i, e) {
        if ($(this).html() === '') {
            let staffRoleEmptyHtml = getStaffRoleEmptyHtml($(e));
            $(e).append(staffRoleEmptyHtml);
            $(e).parent().find('.company-staff-role-name').removeClass('help-text').attr('title', '');
        }
        else {
            $(e).parent().find('.company-staff-role-name').addClass('help-text')
                .attr('title', getStaffMemberDescription($(e).parent().attr('data-role')));
        }
    });

    // Show role numbers
    $companyStaffRoleNumbers.each(function (i, e) {
        let roleName = $(e).attr('data-name');
        let roleNumbers = data['staffRoleNumbers'][roleName];
        let roleNumberHtml = ('<span class="company-staff-role-number-hired">{0}</span><span class="margin-left-2">/</span><span class="margin-left-2">{1}</span>').format(roleNumbers['numberHired'], roleNumbers['numberAvailable']);
        $(e).html(roleNumberHtml);
    });
    $companyStaffRoleNumbers.show();

    // Show staff list container
    $companyStaffContainer.fadeIn('slow');
    $('.company-staff-list-container').scrollTop(0);

    // Staff member click handler
    $companyStaffContainer.off('click', '.staff-member-container');
    $companyStaffContainer.on('click', '.staff-member-container', function (event) {
        showCompanyStaffMemberPage($(event.target), data)
    });

    // Tutorial action check
    checkTutorialStepAction('click_view_company_staff_menu_button');
}

function getCompanyStaffMemberHtml(staffMember) {
    let uid = staffMember['uid'];

    // Level progress
    let levelProgressData = getStaffMemberLevelProgress(staffMember['level'], Math.round(staffMember['xp']));
    let levelProgressHtml =
        '<div class="progress-under help-text" title="' + levelProgressData['xpToLevel'] + '">' +
        '<div class="progress" style="width:' + levelProgressData['progress'] + '%">' + '</div></div>';

    let staffLevelHtml = '<span class="gold margin-left-5">' + ' Lvl ' + staffMember['level'] + '</span>';
    let unavailable = '';
    if (staffMember['unavailableMonths']) {
        unavailable = '<div class="dark-red line-height-21px margin-top-2">Unavailable</div>';
    }

    // Get current task
    let currentTaskHtml = '';
    if (staffMember['currentTask']) {
        currentTaskHtml =
            '<div class="light-grey line-height-21px margin-top-2">' + staffMember['currentTask'] + '</div>';
    }

    return '<div class="inside-box light-background staff-member-container margin-bottom-10" data-uid="' + uid + '">' +
        '<div class="medium-dark-grey column-left-70">' +
        staffMember['name'] + staffLevelHtml +
        unavailable + currentTaskHtml +
        '</div>' +
        '<div class="column-right-30">' +
        '<div class="staff-member-progress">' +
        levelProgressHtml +
        '</div>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

function getStaffMemberLevelProgress(level, xp) {
    let baseXp;
    let nextXp;

    switch (level) {
        case 1:
            baseXp = 0;
            nextXp = 100;
            break;
        case 2:
            baseXp = 100;
            nextXp = 300;
            break;
    }

    let xpToLevel = '';
    let progress = 100;
    if (level < 3) {
        progress = ((xp - baseXp) / (nextXp - baseXp)) * 100;
        xpToLevel = '{0} XP to Level {1}'.format(nextXp - xp, level + 1);
    }
    else {
        xpToLevel = 'Max Level'
    }
    if (progress > 100) {
        progress = 100
    }
    else if (progress <= 0) {
        progress = 1
    }

    return {'progress': progress, 'xpToLevel': xpToLevel};
}

function getStaffRoleEmptyHtml(element) {
    let staffMemberInfo = getStaffMemberDescription(element.parent().attr('data-role'));
    return '<div class="inside-box light-background">' +
        '<div class="medium-grey margin-bottom-3">Not Hired</div>' +
        '<div class="grey font-0p875em line-height-1p4">' + staffMemberInfo + '</div>' +
        '</div>';
}

function getStaffMemberDescription(role) {
    if (role === 'doctor') {
        return 'Doctors can provide better injury diagnoses and offer rehab services to bring injured superstars ' +
            'back faster.'
    }
    else if (role === 'scout') {
        return 'Scouts can produce scouting reports, recruit indie talent to make them available to ' +
            'sign and get them interested in joining your company.'
    }
    else if (role === 'producer') {
        return 'Producers can create production packages to boost Popularity and Hype, improve segment results by ' +
            'focusing on them and boost new Gimmick debuts.'
    }
    else if (role === 'trainer') {
        return 'Trainers can train talent to increase their skills, make particular ' +
            'talent available for callups and easily bring new signings to the main roster.'
    }
    else if (role === 'talent-manager') {
        return 'Talent Managers can try to reassure talent, negotiate appearances with ' +
            'part timers and get talent to join your company in company buyouts.'
    }
}

function showCompanyStaffMemberPage($el, staffMembersData) {
    const $staffMemberDetails = $('.staff-member-details');
    const $staffMemberAge = $('.staff-member-age');
    const $staffMemberTask = $('.staff-member-task');
    $('.company-staff-container').hide();
    $staffMemberDetails.hide();

    let uid = parseInt($el.closest('.staff-member-container').attr('data-uid'));
    let staffMember = staffMembersData['activeStaffMembers']
        .concat(staffMembersData['retiredStaffMembers']).filter(function (s) {
        return s['uid'] === uid;
    })[0];

    // Staff member details
    $staffMemberDetails.data('uid', staffMember['uid']);
    $staffMemberDetails.data('element', '.company-staff-container');
    $staffMemberDetails.data('graphic', staffMember['graphic']);

    $('.staff-member-name').text(staffMember['name']);
    $('.staff-member-pronoun').text(toTitleCase(staffMember['pronoun']));
    $staffMemberAge.text(staffMember['age']);

    // Add age multiplier
    let ageBoost = getStaffMemberAgeBoost(staffMember['age']);
    $staffMemberAge.attr('title', ageBoost + 'x XP Multiplier. Age affects progression of Skill Level.');
    if (!$staffMemberAge.hasClass('help-text')) {
        $staffMemberAge.addClass('help-text')
    }
    $staffMemberAge.parent().removeClass('help-text').attr('title', null);

    let maxHtml = '';
    if (staffMember['level'] === 3) {
        maxHtml = '<span class="medium-light-grey margin-left-6">Max</span>'
    }
    $('.staff-member-role').html(
        '<span class="grey">' +
        toTitleCase(staffMember['role'].replace(/_/g, " ")) +
        '</span>' +
        '<span class="gold margin-left-8">' +
        'Level ' + staffMember['level'] + maxHtml +
        '</span>'
    );

    // Hide cost
    $('.staff-member-cost').parent().hide();

    // Show task
    let task = staffMember['currentTask'] || 'None';
    if (staffMember['monthsLeftForTask']) {
        let monthWord = (staffMember['monthsLeftForTask'] === 1) ? 'month' : 'months';
        task += ' ({0} {1} left)'.format(staffMember['monthsLeftForTask'], monthWord);
    }
    $staffMemberTask.text(task);
    $staffMemberTask.parent().show();

    // Show retired
    if (staffMember['retired']) {
        $('.staff-member-information').text('Retired').show();
    }
    else {
        $('.staff-member-information').hide();
    }

    $('.staff-member-graphic').html('');
    let el = $staffMemberDetails.find('.staff-member-graphic');
    if (staffMember['graphic']) {
        showStaffMemberPageGraphic(staffMember['graphic'], el);
    }
    $('#fire-staff-member-button').show();
    $('#hire-staff-member-button').hide();
    $('#change-staff-name-menu-button').show();
    $('#change-staff-pronoun-menu-button').show();
    $('#change-staff-appearance-menu-button').show();
    if (staffMember['superstarObjectPresent']) {
        $('#transition-staff-to-talent-button').show()
    }
    else {
        $('#transition-staff-to-talent-button').hide()
    }
    if (staffMember['currentTask']) {
        $('#cancel-staff-member-task-button').show()
    }
    else {
        $('#cancel-staff-member-task-button').hide()
    }

    $staffMemberDetails.fadeIn();

    // Tutorial action check
    checkTutorialStepAction('click_staff_member');
}


function getStaffMemberAgeBoost(age) {
    if (30 > age) {
        return '1.5'
    }
    else if (45 > age) {
        return '1'
    }
    else {
        return '0.75'
    }
}

async function loadViewIndieStaffPage() {

    if (globals.requestRunning) {
        return;
    }
    if (!globalUser.paid) {
        notie.alert({type: 3, text: "You can only hire Staff Members in JoW Paid."});
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewIndieStaffData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewIndieStaffPageData(data);
}

function showViewIndieStaffPageData(data) {
    const $indieStaffListContainer = $('.indie-staff-list-container');
    const $indieStaffContainer = $('.indie-staff-container');

    // Add staff members
    $indieStaffListContainer.html('');
    data.forEach(function (staffMember) {
        $indieStaffListContainer.append(getIndieStaffMemberHtml(staffMember));
    });

    $indieStaffContainer.fadeIn('slow');
    $indieStaffListContainer.scrollTop(0);

    // Staff member click handler
    $indieStaffContainer.off('click', '.staff-member-container');
    $indieStaffContainer.on('click', '.staff-member-container', function (event) {
        showIndieStaffMemberPage($(event.target), data)
    });
}

function getIndieStaffMemberHtml(staffMember) {
    let points = staffMember['cost'].toLocaleString('en');
    let price = '<span class="cursor-pointer">' + points + '</span>';
    let uid = staffMember['uid'];
    let retired = '';
    let retiredClass = '';
    if (staffMember['retired']) {
        retired = ' <span class="light-grey">(Retired)</span>';
    }
    return '<div class="inner-box-item staff-member-container' + retiredClass + '" data-uid="' + uid + '">' +
        '<div class="margin-bottom-3 medium-dark-grey">' +
        staffMember['name'] + retired +
        '<span class="float-right blue">' +
        '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-3"/> ' + price +
        '</span>' +
        '</div>' +
        '<div class="light-grey">' +
        toTitleCase(staffMember['role'].replace(/_/g, " ")) +
        '</div>' +
        '<div class="gold">' +
        'Level ' + staffMember['level'] +
        '</div>' +
        '</div>';
}

function showIndieStaffMemberPage($el, data) {
    const $indieStaffContainer = $('.indie-staff-container');
    const $staffMemberDetails = $('.staff-member-details');
    const $staffMemberAge = $('.staff-member-age');
    const $staffMemberCost = $('.staff-member-cost');
    const $staffMemberInformation = $('.staff-member-information');
    $indieStaffContainer.hide();
    $staffMemberDetails.hide();

    let uid = parseInt($el.closest('.staff-member-container').attr('data-uid'));
    let staffMember = data.filter(function (s) {
        return s['uid'] === uid;
    })[0];

    // Staff member details
    $staffMemberDetails.data('uid', staffMember['uid']);
    $staffMemberDetails.data('element', '.indie-staff-container');
    $('.staff-member-name').text(staffMember['name']);
    $('.staff-member-pronoun').text(toTitleCase(staffMember['pronoun']));
    $staffMemberAge.text(staffMember['age']);

    // Add age help text
    $staffMemberAge.attr('title', null);
    $staffMemberAge.removeClass('help-text');
    if (!$staffMemberAge.parent().hasClass('help-text')) {
        $staffMemberAge.parent().addClass('help-text').attr('title', 'Age affects progression of ' +
            'Skill Level. Younger staff members gain XP faster than older ones.')
    }

    $('.staff-member-role').html(
        '<span class="light-grey">' +
        toTitleCase(staffMember['role'].replace(/_/g, " ")) +
        '</span>' +
        '<span class="gold margin-left-8">' +
        'Level ' + staffMember['level'] +
        '</span>'
    );

    // Show cost
    $staffMemberCost.html(
        '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/> ' +
        staffMember['cost'].toLocaleString('en')
    );
    $staffMemberCost.parent().show();

    // Hide task
    $('.staff-member-task').parent().hide();

    // Show retired
    if (staffMember['retired']) {
        $staffMemberInformation.text('Retired');
        $staffMemberInformation.show();
    } else {
        $staffMemberInformation.hide();
    }

    // Show graphic
    $('.staff-member-graphic').html('');
    let el = $staffMemberDetails.find('.staff-member-graphic');
    if (staffMember['graphic']) {
        showStaffMemberPageGraphic(staffMember['graphic'], el);
    }

    // Show appropriate buttons
    $('#fire-staff-member-button').hide();
    $('#hire-staff-member-button').show();
    $('#change-staff-name-menu-button').hide();
    $('#change-staff-pronoun-menu-button').hide();
    $('#change-staff-appearance-menu-button').hide();
    $('#transition-staff-to-talent-button').hide();
    $('#cancel-staff-member-task-button').hide();

    $staffMemberDetails.fadeIn();
}

async function loadChangeStaffMemberNamePage(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEditStaffMemberData(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showChangeStaffMemberNamePageData(data, uid);
}

function showChangeStaffMemberNamePageData(data, uid) {
    let parent = $('.change-staff-name-container');
    parent.find('.change-staff-name-text').text(data['name']);
    parent.find('.change-staff-name-input').val(data['name']);
    parent.data('uid', uid);
    parent.fadeIn();
}

async function loadChangeStaffMemberPronounPage(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEditStaffMemberData(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showChangeStaffMemberPronounPageData(data, uid);
}

function showChangeStaffMemberPronounPageData(data, uid) {
    let parent = $('.change-staff-pronoun-container');
    parent.find('.change-staff-pronoun-text').text(data['name']);
    parent.find('.change-staff-pronoun-select').val(data['pronoun']);
    parent.data('uid', uid);
    parent.fadeIn();
}

async function loadChangeStaffMemberAppearancePage(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEditStaffMemberData(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showChangeStaffMemberAppearancePageData(data, uid);
}

function showChangeStaffMemberAppearancePageData(data, uid) {
    let parent = $('.change-staff-appearance-container');
    parent.find('.change-staff-appearance-text').text(data['name']);
    parent.find('#change-staff-appearance-graphic').data('key', JSON.stringify(data['graphic']));
    parent.data('uid', uid);
    parent.fadeIn();
    showChangeAppearancePageGraphic($('#change-staff-appearance-graphic'));
}

async function loadViewCompanyFacilitiesPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view company facilities data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewCompanyFacilitiesData = await getViewCompanyFacilitiesData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view company facilities data
    hideContent($());
    showViewCompanyFacilitiesPageData(viewCompanyFacilitiesData);
}

function showViewCompanyFacilitiesPageData(data) {
    // Add Facilities
    $('.company-facilities-list-container').html('');
    data['facilities'].forEach(function (facility) {
        let facilityItemHtml = getFacilityItemHtml(facility);
        $('.company-facilities-list-container').append(facilityItemHtml);
    });

    $('.company-facilities-container').hide().fadeIn('slow');
    $(".company-facilities-list-container").scrollTop(0);

    // Tutorial action check
    if (data['nextTutorialState']) {
        globals.game.tutorialState = data['nextTutorialState']
    }

    // Tutorial action check
    checkTutorialStepAction('click_view_company_facilities_menu_button');
}

function getFacilityItemHtml(facility) {
    let uid = facility['uid'];

    // Level
    let levelHtml = '<i class="fa fa-star gold-bright"></i>'.repeat(facility['level']);
    if (facility['level'] < 3) {
        levelHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - facility['level']);
    }

    // Actions for next level
    let actionsToNextLevel = '';
    let actionsClass = '';
    if (facility['actionsToNextLevel']) {
        actionsClass = 'red';
        if (facility['actionsCompleted'] >= facility['actionsToNextLevel']) {
            actionsClass = 'green'
        }
        actionsToNextLevel = '/' + facility['actionsToNextLevel'];
    }
    let actionWord = facility['actionName'];

    // Next level info
    let facilityUpgradeInfo = facility['nextLevelInfo'];
    let nextLevelHtml;
    if (facility['level'] < 3) {
        nextLevelHtml = ' for <span class="gold">Level ' + (facility['level'] + 1) + '</span>';
    }
    else {
        nextLevelHtml = ' <span class="medium-light-grey margin-left-3">Max Level</span>';
    }

    // Cost
    let cost = '';
    if (facility['nextLevelCost']) {
        cost =
            '<div class="blue margin-bottom-12">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px margin-right-5"/>' +
            facility['nextLevelCost'] +
            '</div>';
    }

    // Upgrade
    let upgradeButton = '';
    if (facility['level'] < 3) {
        upgradeButton =
            '<div>' +
            '<button type="button" id="upgrade-facility-button" ' +
            'class="button retro-button condensed blue-button-background">Upgrade</button>' +
            '</div>'
    }

    // Last/current level info
    let lastLevelInfo = '';
    if (facility['lastLevelInfo']) {
        lastLevelInfo = '<div class="margin-top-12 high-light-grey">' + facility['lastLevelInfo'] + '</div>'
    }

    let backgroundClass = 'light-background';
    if (!globalUser.paid) {
        backgroundClass = 'disabled-background'
    }

    return '<div class="inside-box ' + backgroundClass + ' margin-bottom-25 facility-item" data-uid="' + uid + '">' +
        '<div class="medium-dark-grey margin-bottom-10 font-1p125em">' +
        facility['name'] +
        '<div class="float-right facility-level">' + levelHtml + '</div>' +
        '</div>' +
        '<div class="medium-grey margin-bottom-8">' +
        '<span class="' + actionsClass + '">' +
        facility['actionsCompleted'] + actionsToNextLevel +
        '</span> ' +
        actionWord + nextLevelHtml +
        '</div>' +
        '<div class="light-grey margin-bottom-8">' +
        facilityUpgradeInfo +
        '</div>' +
        cost +
        upgradeButton +
        lastLevelInfo +
        '</div>';
}

async function getHireStaffMemberRequest(uid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await hireStaffMember(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showHireStaffMemberData(data);
}

function showHireStaffMemberData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        notie.alert({
            type: 4,
            text: '<span class="display-block">' + data['name'] + ' has been added to your ' +
            '<span class="staff-color">Staff</span></span>',
            stay: true
        });

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view staff
        setTimeout(function () {
            // Remove staff member from view staff
            let staffMemberElement = $('.staff-member-container:contains(' + data['name'] + ')')[0];
            staffMemberElement.remove();
            $('.staff-member-details').hide();
            $('.indie-staff-container').fadeIn();
        }, 600);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to hire this Staff Member"
            });
        }
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "The Staff Member could not be found. Please try again."});
        }
        if (data['error'] === 'role-present') {
            notie.alert({
                type: 3, text: "You already have a " + toTitleCase(data['role'].replace(/_/g, " ")) + " in your Staff. " +
                "You need to release them before hiring someone else."
            });
        }
        if (data['error'] === 'max-roles') {
            notie.alert({
                type: 3, text: "Your {0} Facility only allows a maximum of {1} {2}s (including transitioning superstars).".format(data['facilityName'], data['numberOfRoles'], toTitleCase(data['role'].replace(/_/g, " ")))
            });
        }
        if (data['error'] === 'retired') {
            notie.alert({type: 3, text: "This Staff Member is retired and not looking to be hired."});
        }
        if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: "You can only hire Staff Members in JoW Paid."});
        }
        if (data['error'] === 'facility-level') {
            notie.alert({
                type: 3,
                text: "Your {0} Facility only allows Level {1} {2}s to be hired.".format(data['facilityName'],
                    data['facilityLevel'], toTitleCase(data['role'].replace(/_/g, " ")))
            });
        }
    }
}

async function getFireStaffMemberRequest(uid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await fireStaffMember(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showFireStaffMemberData(data);
}

function showFireStaffMemberData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        notie.alert({
            type: 4,
            text: '<span class="display-block">' + data['name'] + ' has been fired from your ' +
            '<span class="staff-color">Staff</span></span>',
            stay: true
        });

        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view staff
        setTimeout(function () {
            $("#view-company-staff-menu-button").trigger('click');
        }, 1200);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "That Staff Member could not be found. Please try again."});
        }
    }
}

async function getChangeStaffMemberNameRequest(uid, name) {

    if (globals.requestRunning) {
        return;
    }

    // Validate inputs
    if (name.length <= 0) {
        notie.alert({type: 3, text: 'Enter a name for the Staff Member.', stay: true});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await changeStaffMemberName(uid, name);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showChangeStaffMemberNameData(data);
}

function showChangeStaffMemberNameData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Go back to company staff
        setTimeout(function () {
            $("#view-company-staff-menu-button").trigger('click');
        }, 800);

        notie.alert({type: 4, text: "Name changed"});
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'staff-not-found') {
            notie.alert({
                type: 3,
                text: 'The selected staff could not be found. Please try again.'
            });
        }
        else if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to change this Staff Member's Name"
            });
        }
        else if (data['error'] === 'same-name') {
            notie.alert({
                type: 3,
                text: "Enter a different Name from the Staff Member's current Name"
            });
        }
        else if (data['error'] === 'name-exists') {
            notie.alert({type: 3, text: "A Staff Member with that name already exists in your Company"});
        }
    }
}

async function getChangeStaffMemberPronounRequest(uid, pronoun) {

    if (globals.requestRunning) {
        return;
    }

    // Validate inputs
    if (!pronoun) {
        notie.alert({type: 3, text: 'Select a pronoun for the Staff Member.', stay: true});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await changeStaffMemberPronoun(uid, pronoun);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showChangeStaffMemberPronounData(data);
}

function showChangeStaffMemberPronounData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Go back to company staff
        setTimeout(function () {
            $("#view-company-staff-menu-button").trigger('click');
        }, 800);

        notie.alert({type: 4, text: "Pronoun changed"});
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'staff-not-found') {
            notie.alert({
                type: 3,
                text: 'The selected staff could not be found. Please try again.'
            });
        }
    }
}

async function getChangeStaffMemberGraphicRequest(uid, graphic) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await changeStaffMemberGraphic(uid, graphic);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showChangeStaffMemberGraphicData(data);
}

function showChangeStaffMemberGraphicData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Go back to company staff
        setTimeout(function () {
            $("#view-company-staff-menu-button").trigger('click');
        }, 800);

        notie.alert({type: 4, text: "Appearance changed"});
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'staff-not-found') {
            notie.alert({
                type: 3,
                text: 'The selected staff could not be found. Please try again.'
            });
        }
        else if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to change this Staff Member's Appearance"
            });
        }
    }
}

async function getCancelStaffMemberTaskRequest(uid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await cancelStaffMemberTask(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showCancelStaffMemberTaskData(data);
}

function showCancelStaffMemberTaskData (data) {
    if (!data['error']) {
        playSoundEffect('success');

        notie.alert({
            type: 4,
            text: '<span class="display-block">Task cancelled</span>',
            stay: true
        });

        // Go back to view staff
        setTimeout(function () {
            $("#view-company-staff-menu-button").trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "That Staff Member could not be found. Please try again."});
        }
        else if (data['error'] === 'negotiating-buyout') {
            notie.alert({type: 3, text: "This Buyout is already in progress and cannot be cancelled."});
        }
    }
}

async function getUpgradeCompanyFacilityRequest(uid, facilityItemElement) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await upgradeCompanyFacility(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showUpgradeCompanyFacilityData(data, facilityItemElement);
}

function showUpgradeCompanyFacilityData(data, facilityItemElement) {
    if (!data['error']) {
        playSoundEffect('success');
        let facility = data['facility'];

        notie.alert({
            type: 4,
            text: '<span class="display-block"><span class="facility-color">' + facility['name'] + ' Facility</span>' +
                ' has been upgraded to ' + facility['levelPhrase'] +
                ' <span class="gold">Level ' + facility['level'] + '</span> Facility</span>',
            stay: true
        });

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update facility item
        let facilityItemHtml = getFacilityItemHtml(facility);
        $(facilityItemElement).replaceWith(function () {
            return $(facilityItemHtml).hide().fadeIn('slow');
        });

    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to upgrade this Facility"});
        }
        else if (data['error'] === 'requirements-failed') {
            notie.alert({
                type: 3,
                text: "You have not fulfilled the requirements to upgrade this Facility"
            });
        }
        else if (data['error'] === 'max-level') {
            notie.alert({type: 3, text: "This Facility is already at the maximum Level"});
        }
        else if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: "You can only upgrade Facilities in JoW Paid."});
        }
    }
}


async function loadViewYearlyRankingsHistoryPage(year) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewCompanyFacilitiesData = await getYearlyRankingsHistoryData(year);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showViewYearlyRankingsHistoryPageData(viewCompanyFacilitiesData);
}

function showViewYearlyRankingsHistoryPageData(data) {
    if (!data['error']) {
        hideContent($());
        playSoundEffect('success');
        const $yearlyRankingsYearSelect = $('.yearly-rankings-year-select');

        // Add yearly rankings data
        displayYearlyRankingsData(data['ranking'], true);

        // Add years options
        let yearsHtml = '';
        data['years'].forEach(function(year) {
            yearsHtml += '<option>' + year + '</option>'
        });
        $yearlyRankingsYearSelect.html(yearsHtml);

        // Select year
        $yearlyRankingsYearSelect.val(data['ranking']['year']);

    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'no-rankings-present') {
            notie.alert({type: 3, text: 'No Top 50 Rankings are currently present. They are published in January of each year.'});
        }
        else if (data['error'] === 'ranking-not-found') {
            notie.alert({type: 3, text: 'The Top 50 Rankings for that year could not be found.'});
        }
        else if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: 'Top 50 Rankings are only available in JoW Paid.'});
        }
    }
}

function displayYearlyRankingsData(data, history) {
    let parent = $("#yearly-rankings-container");
    let yearlyRankingsDataElement = $('.yearly-rankings-data-container');

    // Add ranking items
    let rankingsHtml = '';
    data['rankingData']?.forEach(function (ranking, i) {

        // Add headers
        if (i === 0) {
            rankingsHtml += '<div class="yearly-rankings-list-header font-abril-fatface">Top 10</div>'
        }
        if (i === 10) {
            rankingsHtml += '<div class="yearly-rankings-list-subheader font-abril-fatface">The Rest</div>'
        }

        // Get details
        let numberHtml = '<span class="display-inline-block yearly-rankings-number">' + (i + 1) + '.</span>';
        let pointsHtml = '<span class="display-inline-block">{0} pts</span>'.format(Math.round(ranking['points']));
        let highlightHtml = '';
        if (ranking['highlight']) {
            highlightHtml = '<div class="margin-top-3 font-normal dark-grey">' + ranking['highlight'] + '</div>';
        }
        let companyNameHtml = '<span class="medium-dark-grey margin-left-8 font-14px">(' + ranking['company'] + ')</span>';

        // Get classes
        let trophyHtml = '';
        let rankingItemClass = '';
        if (i === 0) {
            trophyHtml = '<img alt="Trophy" src="static/www/static/trophy_icon_gold.png" class="trophy-image margin-right-8"/>';
            rankingItemClass += ' first';
        }
        if (i === 9) {
            rankingItemClass += ' tenth'
        }
        if (i <= 9) {
            rankingItemClass += ' highlighted'
        }

        // Add html
        let div =
            '<div class="yearly-rankings-item' + rankingItemClass + '">' +
            '<div>' +
            '<div class="yearly-rankings-column-number">' + numberHtml + '</div>' +
            '<div class="yearly-rankings-column-name">' +
            '<div class="line-height-1p4">' + trophyHtml + ranking['name'] + companyNameHtml + '</div>' +
            '<div class="line-height-1p4">' + highlightHtml + '</div>' +
            '</div>' +
            '<div class="yearly-rankings-column-data">' + pointsHtml + '</div>' +
            '<div class="clear"></div>' +
            '</div>' +
            '</div>';

        rankingsHtml += div;
    });
    if (!data['rankingData']) {
        rankingsHtml += '<div>No rankings present for this year.</div>';
    }

    // Add year and editor
    parent.find('.yearly-rankings-subheader').text(data['year']);
    parent.find('.yearly-rankings-editor').text(data['editor']);

    // Show/hide year select
    if (history) {
        parent.find('.yearly-rankings-subheader').hide();
        parent.find('.yearly-rankings-year-select').show();
    }
    else {
        parent.find('.yearly-rankings-subheader').show();
        parent.find('.yearly-rankings-year-select').hide();
    }

    parent.fadeIn('slow');
    yearlyRankingsDataElement.html(rankingsHtml);
    yearlyRankingsDataElement.scrollTop(0);
}

async function loadViewAnnualTournamentHistoryPage(iteration) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getAnnualTournamentHistoryData(iteration);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showViewAnnualTournamentHistoryPageData(data);
}

function showViewAnnualTournamentHistoryPageData(data) {
    if (!data['error']) {
        hideContent($());
        playSoundEffect('success');
        const $annualTournamentIterationSelect = $('.annual-tournament-iteration-select');

        // Add annual tournament data
        displayAnnualTournamentHistoryData(data['annualTournament']);

        // Add iterations options
        let iterationsHtml = '';
        data['iterations'].forEach(function(iteration, i) {
            iterationsHtml += '<option value="' + (i + 1) + '">' + iteration + '</option>'
        });
        $annualTournamentIterationSelect.html(iterationsHtml);

        // Select shown iteration
        $annualTournamentIterationSelect.val(data['iteration']);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'no-annual-tournament-present') {
            notie.alert({type: 3, text: 'The Grand Invitational has not been held yet.'});
        }
        else if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: 'The Grand Invitational is only available in JoW Paid.'});
        }
    }
}

function displayAnnualTournamentHistoryData(data) {
    let parent = $("#annual-tournament-history-container");
    const $annualTournamentHistoryDataContainer = $('.annual-tournament-history-data-container');
    let tournamentInfoHtml = '';

    // Add year
    let yearHtml = (data['year']) ? data['year'] : '';
    tournamentInfoHtml += '<div class="grey text-center margin-top-8">' + yearHtml + '</div>';

    // Add winner name
    let winnerHtml = '{0} ({1})'.format(data['winner'], data['winnerOrganizationName']);
    tournamentInfoHtml += '<div class="medium-dark-grey text-center margin-top-12">Winner</div>' +
        '<div class="annual-tournament-yellow text-center">' + winnerHtml + '</div>';

    // Add uid to poster button
    $('.view-annual-tournament-poster-button').data('uid', data['uid']);

    // Add bracket
    let tournamentRound = 1;
    let tournamentRounds = Object.keys(data['bracket']).length;
    let bracketHtml = getTournamentBracketHtml(data['bracket'][tournamentRound], tournamentRound, tournamentRounds);
    tournamentInfoHtml += '<div class="annual-tournament-bracket-container history margin-top-20 margin-bottom-15" ' +
        'data-round="' + tournamentRound + '" data-rounds="' + tournamentRounds + '">' +
        bracketHtml +
        '</div>';

    $annualTournamentHistoryDataContainer.html(tournamentInfoHtml);

    // Navigate bracket rounds
    parent.off('click', '.tournament-bracket-next, .tournament-bracket-prev');
    parent.on('click', '.tournament-bracket-next, .tournament-bracket-prev', function () {
        let bracketContainer = parent.find('.annual-tournament-bracket-container');
        let round = bracketContainer.attr('data-round');
        let rounds = bracketContainer.attr('data-rounds');

        // Go to next/prev round
        if ($(this).hasClass('tournament-bracket-next')) {
            round++
        }
        else {
            round--
        }
        let bracket = data['bracket'][round];
        if (!bracket) {
            return false;
        }
        bracketContainer.attr('data-round', round);

        // Show new bracket
        let bracketHtml = getTournamentBracketHtml(bracket, round, rounds);
        $('.annual-tournament-bracket-container').html(bracketHtml).hide().fadeIn('fast');
    });

    parent.fadeIn('slow');
    $annualTournamentHistoryDataContainer.scrollTop(0);
}

function getTournamentBracketHtml(bracket, tournamentRound, tournamentRounds, edit, tournamentStartRound) {
    if (typeof(edit) === 'undefined') edit = false;
    if (typeof(tournamentStartRound) === 'undefined') tournamentStartRound = 0;

    let html = '';

    // Get header text
    let round;
    let participants = bracket.length * 2;
    switch (participants) {
        case 2:
            round = 'Final';
            break;
        case 4:
            round = 'Semi Finals';
            break;
        case 8:
            round = 'Quarter Finals';
            break;
        case 16:
            round = 'Round of 16';
            break;

        default:
            round = 'Round ' + tournamentRound
    }

    let bracketClass = '';
    if (participants >= 32) {
        bracketClass = 'mini'
    }
    else if (participants >= 16) {
        bracketClass = 'compact'
    }

    let prev = '<i class="fa fa-chevron-left font-0p825em margin-right-10 tournament-bracket-prev cursor-pointer visibility-hidden"></i>';
    let next = '<i class="fa fa-chevron-right font-0p825em margin-left-8 tournament-bracket-next cursor-pointer visibility-hidden"></i>';

    if (!edit) {
        // Check for next and previous rounds
        if (tournamentRound < tournamentRounds) {
            next = '<i class="fa fa-chevron-right font-0p825em margin-left-8 tournament-bracket-next cursor-pointer"></i>'
        }
        if (tournamentRound > tournamentStartRound + 1) {
            prev = '<i class="fa fa-chevron-left font-0p825em margin-right-10 tournament-bracket-prev cursor-pointer"></i>'
        }
    }

    html +=
        '<span class="display-block margin-bottom-15 text-center medium-dark-grey">' +
        prev +
        '<span class="tournament-round-name" data-round-number="' + tournamentRound + '">' + round + '</span>' +
        next +
        '</span>';

    bracket.forEach(function (match, i) {
        html += '<div class="tournament-bracket-match ' + bracketClass + '">';

        match['participants'].forEach(function (participant, j) {
            let participantSeed = participant[1];
            let participantName = participant[0];
            let participantClass = '';

            if (!participantSeed) {
                participantSeed = ' '
            }

            if (!participantName) {
                participantSeed = '—';
                participantName = '???';
            }
            else {
                if (match['winner']) {
                    if (participantName !== match['winner']) {
                        participantClass = 'opaque'
                    }
                }
            }

            let formattedName = getShortenedName(participantName, 30);

            let helpClass = '';
            let titleHtml = '';
            if (formattedName !== participantName) {
                helpClass = ' help-text';
                titleHtml = ' title="' + participantName.replace(/"/g, "&quot;") + '"';
            }

            let editClass = '';
            if (edit) {
                editClass = 'edit'
            }

            // Get organization name
            let organizationName = '';
            if (participant[2]) {
                organizationName = '<span class="grey margin-left-8 font-14px">' + participant[2] + '</span>';
            }

            html +=
                '<div class="tournament-participant ' + editClass + participantClass + '">' +
                '<span class="tournament-participant-seed margin-right-5 light-grey">' + participantSeed + '</span>' +
                '<span class="tournament-participant-name' + helpClass + '" data-name="' + participantName.replace(/"/g, "&quot;") + '"' + titleHtml + '>' +
                    formattedName +
                organizationName +
                '</span>' +
                '</div>';

            if (j === 0) {
                html += '<div class="tournament-participant-separator"></div>'
            }
        });

        html += '</div>';
    });

    return html
}


function getTournamentGroupTableHtml(groups, advancingPositions, history) {

    // Get maximum win/loss/draw items
    let historyArrays = groups.map(function (group) {
        return group.map(function (x) {
            return x['history'].length;
        });
    });
    let histories = [].concat.apply([], historyArrays);
    let maxHistory = Math.max.apply(null, histories);

    let html = '';
    let tableClass = '';
    let recordClass = '';

    if (history) {
        tableClass = 'in-table'
    }
    if (maxHistory >= 7) {
        recordClass = 'compact';
        tableClass += ' compact-table';
    }

    groups.forEach(function (group, i) {

        html += '<div class="tournament-group-container">';

        // Add group name
        let groupName = '';
        switch (i) {
            case 0:
                groupName = 'A';
                break;
            case 1:
                groupName = 'B';
                break;
            case 2:
                groupName = 'C';
                break;
            case 3:
                groupName = 'D';
                break;
        }
        html +=
            '<span class="display-block margin-bottom-15 text-center medium-dark-grey">' +
            '<span class="tournament-group-name">Group ' + groupName + '</span>' +
            '</span>';

        // Add group participants
        html += '<div class="tournament-bracket-match ' + tableClass + '">';

        group.forEach(function (participant, j, arr) {

            let historyHtml = '';
            participant['history'].forEach(function (record) {
                switch (record) {
                    case 'W':
                        historyHtml += '<span class="tournament-table-record-item win ' + recordClass + '">W</span>';
                        break;
                    case 'L':
                        historyHtml += '<span class="tournament-table-record-item loss ' + recordClass + '">L</span>';
                        break;
                    case 'D':
                        historyHtml += '<span class="tournament-table-record-item draw ' + recordClass + '">D</span>';
                        break;
                }
            });

            let maxLength = 14;
            if (history) {
                maxLength = 11;
            }
            let name = participant['name'];
            if (name.length > maxLength) {
                name = name.slice(0, maxLength) + '.'
            }

            // Highlight top position if no knockout round
            if (advancingPositions === 0) {
                advancingPositions = 1
            }

            let participantClass = '';
            if (j < advancingPositions) {
                participantClass = ' highlight'
            }

            html +=
                '<div class="tournament-participant table' + participantClass + '">' +
                '<span class="tournament-table-rank margin-right-5 light-grey">' + (j + 1) + '</span>' +
                '<span class="tournament-table-name">' + name + '</span>' +
                '<span class="tournament-table-record">' + historyHtml + '</span>' +
                '<span class="tournament-table-points">' + participant['points'] + ' pts</span>' +
                '</div>';

            if (j !== arr.length - 1) {
                html += '<div class="tournament-participant-separator"></div>'
            }
        });

        html += '</div></div>';
    });

    return html
}

async function loadViewAnnualTournamentStatsPage(iteration) {  // Previously get_annual_tournament_stats_view

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getAnnualTournamentStatsData(iteration);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showViewAnnualTournamentStatsPageData(data);
}

function showViewAnnualTournamentStatsPageData(data) {
    if (!data['error']) {
        hideContent($());
        playSoundEffect('success');
        const $annualTournamentStatsDataContainer = $('.annual-tournament-stats-data-container');

        let annualTournamentStatsHtml = getAnnualTournamentStatsHtml(data);
        $annualTournamentStatsDataContainer.html(annualTournamentStatsHtml);
        $("#annual-tournament-stats-container").fadeIn('slow');
        $annualTournamentStatsDataContainer.scrollTop(0);
    }
    else {
        playSoundEffect('error');
        notie.alert({type: 3, text: 'There was a problem loading The Grand Invitational stats.'});
    }
}

function getAnnualTournamentStatsHtml(data) {
    let html = '';

    html += '<div class="margin-bottom-20">';
    html += '<span class="display-block blue margin-bottom-2">Most Times Won (Talent)</span>';
    data['mostWins'].forEach(function (statData) {
        html += '<span class="display-block dark-grey">' + statData['name'] +
            '<span class="margin-left-5 light-grey">' + statData['number'] + '</span>' +
            '</span>';
    });
    html += '</div>';

    html += '<div class="margin-bottom-20">';
    html += '<span class="display-block blue margin-bottom-2">Most Times Won (Company)</span>';
    data['mostOrganizationWins'].forEach(function (statData) {
        html += '<span class="display-block dark-grey">' + statData['name'] +
            '<span class="margin-left-5 light-grey">' + statData['number'] + '</span>' +
            '</span>';
    });
    html += '</div>';

    html += '<div class="margin-bottom-20">';
    html += '<span class="display-block blue margin-bottom-2">Best Matches</span>';
    data['bestMatches'].forEach(function (statData) {
        let rating = setRating(statData['rating']);
        let text = '{0} <span class="light-grey">def.</span> {1}<span class="light-grey margin-left-8">{2}</span>'.format(statData['winner'],
            statData['loser'], statData['tournamentName']);
        html += '<span class="display-block dark-grey margin-bottom-8">' + text +
            '<span class="margin-left-10 display-inline-block">' + rating + '</span>' +
            '</span>';
    });
    html += '</div>';

    html += '<div>';
    html += '<span class="display-block blue margin-bottom-2">Most Entries</span>';
    data['mostEntries'].forEach(function (statData) {
        html += '<span class="display-block dark-grey">' + statData['name'] +
            '<span class="margin-left-5 light-grey">' + statData['number'] + '</span>' +
            '</span>';
    });
    html += '</div>';

    return html;
}

async function loadViewEventPosterPage(eventUid, annualTournamentUid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEventPosterData(eventUid, annualTournamentUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showViewEventPosterPageData(data, eventUid);
}

function showViewEventPosterPageData(data, eventUid) {
    if (!data['error']) {
        playSoundEffect('success');
        const $eventHistoryPosterContainer = $('#event-history-poster-container');

        // Show poster
        showEventPosterPageGraphic(data['eventPosterGraphicData'], $eventHistoryPosterContainer);
        $('#event-history-container').hide();
        $('#annual-tournament-history-container').hide();

        // Set element to go back to
        if (eventUid) {
            $eventHistoryPosterContainer.data('previousElement', '#event-history-container')
        }
        else {
            $eventHistoryPosterContainer.data('previousElement', '#annual-tournament-history-container')
        }
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'event-not-found') {
            notie.alert({type: 3, text: 'That event could not be found. Please try again.'});
        }
        if (data['error'] === 'poster-not-present') {
            notie.alert({type: 3, text: 'Poster not present for event.'});
        }
        if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: 'Past event posters can only be viewed in JoW Paid.'});
        }
    }
}

async function loadViewSpecialSegmentsPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getSpecialSegmentsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewSpecialSegmentsPageData(data);
}

async function loadViewUsedSpecialSegmentPage(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getSpecialSegmentHistoryData(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    viewSpecialSegmentStart(data);
}

async function loadViewPowerupsPage() {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getPowerupsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewPowerupsPageData(data);
}

function showViewPowerupsPageData(data) {
    const $powerupsInventory = $("#powerups-inventory");
    $powerupsInventory.html('');
    $("#powerups-selection").html('');

    // Add header
    let headerHtml = '<img class="pulse" alt="Artifact" src="static/www/static/' + globals.game.powerupLevel1 + '_large.png"/>' +
        '<img class="pulse" alt="Artifact" src="static/www/static/' + globals.game.powerupLevel2 + '_large.png"/>' +
        '<img class="pulse" alt="Artifact" src="static/www/static/' + globals.game.powerupLevel3 + '_large.png"/>';
    if (globals.game.story === 'mars') {
        headerHtml = '<img alt="Experiment" src="static/www/static/' + globals.game.powerupLevel1 + '_large.png"/>' +
            '<img alt="Experiment" src="static/www/static/' + globals.game.powerupLevel2 + '_large.png"/>';
    }
    $('.powerups-header').html(headerHtml).show();

    // Add powerups
    data.forEach(function (powerup) {
        const powerupItemHtml = getViewPowerupsItemHtml(powerup);
        $powerupsInventory.append(powerupItemHtml);
    });

    $("#powerups-box").fadeIn('slow').removeClass('display-none');
    $powerupsInventory.scrollTop(0);
}

function getViewPowerupsItemHtml(powerup) {
    let div;
    let image = getPowerupImage(powerup);

    // Show use button if in stock
    let useButton = '';
    if (powerup['stock'] > 0) {
        useButton = '<button type="button" class="button retro-button condensed margin-left-5 blue-button-background ' +
            'use-powerup">Use</button>';
    }

    // Set name and description
    let name = powerup['name'];
    let description = powerup['description'];
    if (powerup['hidden']) {
        description = 'The effects of this ' + globals.game.powerupWord + ' are not fully known.';
    }

    if (powerup['unlocked']) {
        div =
            '<div class="powerup-container help-text" title="' + description + '" data-uid="' + powerup['uid'] + '">' +
            '<div class="font-1p125em margin-bottom-10 font-bold">' +
            '<span class="powerup-name">' + name + '</span>' +
            '<span class="blue float-right top--4px">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' + powerup['cost'] +
            '</span>' +
            '</div>' +

            '<div class="font-1p125em margin-bottom-10 powerup-description display-none grey font-bold">' +
            description +
            '</div>' +

            '<span class="font-1p125em margin-bottom-10">' +
            '<span class="font-bold top-5px powerup-image">' +
            image +
            '<span class="powerup-stock-number">' + powerup['stock'] + '</span>' +
            '</span>' +
            '<span class="blue float-right powerup-bottom">' +
            '<button type="button" class="button retro-button condensed dark-grey-button-background buy-powerup">Buy</button>' +
            useButton +
            '</span>' +
            '</span>' +
            '<span class="powerup-cancel display-none float-right">' +
            '<button type="button" class="button retro-button condensed dark-grey-button-background powerup-cancel-button">Cancel</button>' +
            '</span>' +
        '</div>';
    }
    // Hide powerup information if locked
    else {
        let divHtml = '<div class="powerup-container locked help-text" title="' + description + '">';

        // Show unavailable powerups
        if (powerup['storyName'] === 'mars' && powerup['unavailable']) {
            divHtml = '<div class="powerup-container unavailable help-text" ' +
                'title="Available after completing Wrestling on Mars (JoW Paid)">';
        }

        div =
            divHtml +
            '<div class="font-1p125em margin-bottom-10 font-bold">' +
            '<span class="powerup-name">' + name + '</span>' +
            '<span class="blue float-right top--4px">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ??? ' +
            '</span>' +
            '</div>' +
            '<span class="font-1p125em margin-bottom-10">' +
            '<span class="font-bold top-5px powerup-image">' +
            image +
            '<span class="powerup-stock-number">' + powerup['stock'] + '</span>' +
            '</span>' +

            '<span class="font-1p125em margin-bottom-10">' +
            '<span class="blue float-right powerup-bottom">' +
            '<button type="button" class="button retro-button condensed dark-grey-button-background disabled">Buy</button>' +
            '</span>' +
            '</span>' +
            '<span class="powerup-cancel display-none float-right">' +
            '<button type="button" class="button retro-button condensed dark-grey-button-background powerup-cancel-button">Cancel</button>' +
            '</span>' +
        '</div>';
    }

    return div;
}

async function loadViewOptionsPage() {

    if (globals.requestRunning) {
        return;
    }

    // Select menu option
    $('#main-menu-right').find('li').removeClass('selected');
    $('#view-options-menu-button').addClass('selected');

    // Hide event effects
    $('.event-prestige-effects-container').hide();
    $('.event-prestige-effects-more i').addClass('fa-angle-down').removeClass('fa-angle-up');
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getOptionsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewOptionsPageData(data);
}

function showViewOptionsPageData(data) {
    if (data) {
        playSoundEffect('success');
        const $numberOfWeeklyShowsOption = $('select[name="number-of-weekly-shows-option"]');
        const $enableFatigueOption = $('.other-options input[value="enable_fatigue"]');
        const $runAnnualTournamentOption = $('.other-options input[value="run_annual_tournament"]');
        const $loadFavoriteCommunitySegmentsOption = $('.other-options input[value="load_favorite_community_segments"]');

        // Run weekly shows
        $numberOfWeeklyShowsOption.val(data['numberOfWeeklyShows']).hide().show();

        // Disable 'run weekly shows' for WoM
        if (globals.game.story !== 'mars') {
            $numberOfWeeklyShowsOption.prop('disabled', false);
            $numberOfWeeklyShowsOption.removeClass('help-text').attr('title', '');
        }
        else {
            $numberOfWeeklyShowsOption.val('0');
            $numberOfWeeklyShowsOption.prop('disabled', true);
            $numberOfWeeklyShowsOption.addClass('help-text').attr('title',
                'Weekly Shows are disabled for Wrestling on Mars');
        }

        // Sandbox options
        if (data['gameSettings']['sandbox_mode_enabled']) {
            let userSandboxOptionsHtml = '';
            let sandboxSettings = ['unlimited_creative_points', 'maximum_roster_capacity',
                'all_indies_available', 'unlock_all_items', 'maximum_staff_and_facilities',
                'no_special_items_cooldown'];
            $.map(data['gameSettings'], function (v, i) {
                if (sandboxSettings.indexOf(i) >= 0 && v) {
                    // Rename maximum roster capacity
                    if (i === 'maximum_roster_capacity') {
                        i = 'highest_roster_capacity'
                    }
                    userSandboxOptionsHtml += '<div class="light-grey">' + toTitleCase(i.replace(/_/g, ' ')) + '</div>'
                }
            });
            // Show toggleable settings
            let toggleableSandboxSettings = ['no_injuries', 'no_unhappiness', 'no_talent_requests',
                'no_random_events', 'no_retirements', 'no_going_part_time'];
            toggleableSandboxSettings.forEach(function(setting) {
                let settingChecked = (data['gameSettings'][setting]) ? ' checked' : '';
                userSandboxOptionsHtml += '<label class="control control--checkbox display-block light-grey">' +
                    toTitleCase(setting.replace(/_/g, ' ')) +
                    '<input type="checkbox" class="toggleable-game-setting" value="' + setting + '"' + settingChecked + '>' +
                    '<div class="control__indicator"></div>' +
                    '</label>'
            });
            $('.user-sandbox-options').html(userSandboxOptionsHtml);
            $('.user-sandbox-options-container').show();
        }
        else {
            $('.user-sandbox-options-container').hide();
        }

        // Competitor difficulty
        if (data['gameSettings']['competitor_difficulty']) {
            $('input[name="competitor-difficulty-option"][value="' + data['gameSettings']['competitor_difficulty'] +'"]').prop('checked', true)
        } else {
            $('input[name="competitor-difficulty-option"][value="normal"]').prop('checked', true)
        }

        // Event preview
        if (data['userSettings']['showEventPreview'] === undefined || data['userSettings']['showEventPreview']) {
            $('.other-options input[value="show_event_preview"]').prop('checked', true)
        }
        else {
            $('.other-options input[value="show_event_preview"]').prop('checked', false)
        }

        // Load favorited community segments
        if (globalUser.paid) {
            if (data['userSettings']['loadFavoriteCommunitySegments'] === undefined || data['userSettings']['loadFavoriteCommunitySegments']) {
                $loadFavoriteCommunitySegmentsOption.prop('checked', true)
            } else {
                $loadFavoriteCommunitySegmentsOption.prop('checked', false)
            }
            $loadFavoriteCommunitySegmentsOption.parent().show()
        }
        else {
            $loadFavoriteCommunitySegmentsOption.parent().hide()
        }

        // Annual tournament
        if (globalUser.paid && !globals.game.story) {
            if (data['gameSettings']['run_annual_tournament'] === undefined || data['gameSettings']['run_annual_tournament']) {
                $runAnnualTournamentOption.prop('checked', true)
            } else {
                $runAnnualTournamentOption.prop('checked', false)
            }
            $runAnnualTournamentOption.parent().show()
        }
        else {
            $runAnnualTournamentOption.parent().hide()
        }

        // Enable fatigue
        if (data['gameSettings']['enable_fatigue'] === undefined || data['gameSettings']['enable_fatigue']) {
            $enableFatigueOption.prop('checked', true)
        } else {
            $enableFatigueOption.prop('checked', false)
        }
        $enableFatigueOption.parent().show();

        // Generate settings
        if (data['gameSettings']['generate_indie_superstars'] === undefined || data['gameSettings']['generate_indie_superstars']) {
            $('.other-options input[value="generate_indie_superstars"]').prop('checked', true)
        }
        else {
            $('.other-options input[value="generate_indie_superstars"]').prop('checked', false)
        }
        if (data['gameSettings']['generate_competitors'] === undefined || data['gameSettings']['generate_competitors']) {
            $('.other-options input[value="generate_competitors"]').prop('checked', true)
        }
        else {
            $('.other-options input[value="generate_competitors"]').prop('checked', false)
        }

        // Last cloud save
        updateLastCloudSave(data['dateTimeLastCloudSave']);

        $('#game-options-container').fadeIn();
        $('.game-options-box').scrollTop(0);

        // Tutorial action check
        checkTutorialStepAction('click_game_options');
    }
    else {
        playSoundEffect('error');
        notie.alert({type: 3, text: 'An error occurred. Please try again.'});
    }
}

function updateLastCloudSave(dateTimeLastCloudSave) {
    let lastCloudSaveText;
    if (dateTimeLastCloudSave) {
        lastCloudSaveText = 'Last saved ' + getTimeDiffHuman(dateTimeLastCloudSave, new Date()) + ' ago'
    }
    else {
        lastCloudSaveText = ''
    }
    $('.game-options-last-cloud-save').text(lastCloudSaveText);
}

async function changeNumberOfWeeklyShowsRequest(value, $el) {
    if (globals.requestRunning) {
        return;
    }

    // Select menu option
    $('#main-menu-right').find('li').removeClass('selected');
    $('#view-options-menu-button').addClass('selected');

    // Hide event effects
    $('.event-prestige-effects-container').hide();
    $('.event-prestige-effects-more i').addClass('fa-angle-down').removeClass('fa-angle-up');
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await changeNumberOfWeeklyShows(value);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showChangeNumberOfWeeklyShowsData(data, $el);
}

function showChangeNumberOfWeeklyShowsData(data, $el) {
    if (!data['error']) {
        playSoundEffect('success');
        notie.alert({type: 4, text: 'Setting updated'});
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'weekly-show') {
            notie.alert({type: 3, text: 'The number of weekly shows can only be changed ' +
                    'at a monthly event'});
            $el.val(data['numberOfWeeklyShows']).hide().show();
        }
        if (data['error'] === 'turn-ended') {
            notie.alert({type: 3, text: 'The number of weekly shows can only be changed ' +
                    'when no users have played their current shows'});
            $el.val(data['numberOfWeeklyShows']).hide().show();
        }
    }
}

async function changeUserSettingRequest(settingName, settingValue) {
    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await changeUserSetting(settingName, settingValue);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showChangeUserSettingData(data);
}

function showChangeUserSettingData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Update user settings
        globalUser.settings = data['userSettings'];
    }
    else if (data['error'] === 'not-logged-in') {
        playSoundEffect('error');
        notie.alert({type: 4, text: 'Please login to save this setting.'});
    }
}

async function changeGameSettingRequest(settingName, settingValue) {
    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await changeGameSetting(settingName, settingValue);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showChangeGameSettingData(data);
}

function showChangeGameSettingData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        notie.alert({type: 4, text: 'Setting updated'});

        // Update game settings
        globals.game.settings = data['gameSettings'];
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'game-not-found') {
            notie.alert({type: 4, text: 'Game could not be found. Please try again.'});
        }
        else if (data['error'] === 'change-not-allowed') {
            notie.alert({type: 4, text: 'That setting cannot be changed.'});
        }
    }
}

async function loadViewEventsPage(companyUid, eventUid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewEventsData(companyUid, eventUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.select-company-for-view-events'));
    }

    // Show data
    hideContent($());
    showViewEventsPageData(data);
}

function showViewEventsPageData(data) {
    // Add select data
    addViewEventsYearSelectOptions(data['years']);
    $(".select-year-for-view-events").val(data['event']['year']);
    $(".select-company-for-view-events").val(data['event']['companyName'].trim().replace(/\s+/g, " "));

    // Show event details
    displayEvent(data);

    // Tutorial action check
    checkTutorialStepAction('click_view_events');
}

function addViewEventsYearSelectOptions(years) {
    const $selectYear = $(".select-year-for-view-events");
    $selectYear.find('option').remove().end();
    years.forEach(function (year) {
        $selectYear.append(
            '<option data-uid="' + year['uid'] + '">' + year['year'] + '</option>'
        );
    });
    if (years.length > 0) {
        $selectYear.prop('disabled', false)
    }
    else {
        $selectYear.prop('disabled', true)
    }
}

function displayEvent(data) {

    const event = data['event'];

    // Show containers
    $("#event-calendar").hide();
    $("#event-history-container").fadeIn('slow');

    // Declare jQuery selectors
    let nextEventSelector = $(".event-history-next-event-button");
    let previousEventSelector = $(".event-history-previous-event-button");
    let eventDetails = $("#event-details");
    let eventHistory = $('<div class="margin-top-20"></div>');
    if (!event['year']) {
        event['year'] = $(".select-year-for-view-events").find(":selected").text();
    }

    // Clear the event box
    eventDetails.text('');

    // Show next/previous event buttons
    if (data['nextEventId']) {
        nextEventSelector.show();
        eventDetails.data('nextEventId', data['nextEventId']);
    }
    else {
        nextEventSelector.hide()
    }
    if (data['previousEventId']) {
        previousEventSelector.show();
        eventDetails.data('previousEventId', data['previousEventId']);
    }
    else {
        previousEventSelector.hide()
    }

    // Display event name, prestige and xp
    let prestigeIcon = '';
    switch (event['prestige']) {
        case 'C':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 current-event-prestige-icon' +
                ' bronze"></i>';
            break;
        case 'B':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 current-event-prestige-icon' +
                ' silver"></i>';
            break;
        case 'A':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6 current-event-prestige-icon' +
                ' gold-light"></i>';
            break;
    }

    // Get top event text
    let topEvent = '';
    if (event['topEvent']) {
        topEvent = '<span class="signature-event-color display-block font-bold margin-bottom-2">Signature Event</span>'
    }

    // Get progress to next level
    let progressHtml = '';
    if (event['prestige']) {
        let progress;
        let levelXp = event['xpToNextPrestige'];
        if (event['prestige'] !== 'A') {
            progress = ((event['xp'] - event['baseXp']) / (levelXp - event['baseXp'])) * 100;
        }
        else {
            progress = 100;
        }

        progressHtml =
            '<div class="event-prestige-progress history display-inline-block">' +
            '<div class="progress-under help-text" title="' + event['xp'] + ' / ' + levelXp + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>' +
            '</div>';
    }

    // Get weekly show name
    let weeklyShowHtml = '';
    if (event['weeklyShowName']) {
        weeklyShowHtml =
            '<span class="display-block line-height-1p25em medium-dark-grey margin-top-10">' +
                event['weeklyShowName'] +
            '</span>';
    }

    // Get hype
    let eventHype = event['hype'];
    if (eventHype < 0) {
        eventHype = '- ' + (eventHype * -1)
    }
    else {
        eventHype = '+ ' + eventHype
    }
    let eventHypeHtml = '<span class="display-block medium-dark-grey font-bold">' + eventHype + ' HYPE' + '</span>';

    // Viewership
    let viewershipHtml = '';
    if (event['viewership'] !== null && globalUser.paid) {
        let viewershipText = getViewershipText(event['viewership']);
        let viewershipWord = (event['weeklyShow'] || event['name'] === 'Weekly Show') ? ' Viewers' : ' Buys';
        let nielsenRatingHtml = (event['weeklyShow']) ? '<span class="margin-left-5 light-grey">(' + event['nielsenRating'] + ')</span>' : '';
        viewershipHtml = '<div class="medium-dark-grey">' + viewershipText + viewershipWord + nielsenRatingHtml + '</div>';
    }

    // Brand
    let brandNameHtml = '';
    if (event['brandName'] && !event['weeklyShow']) {
        brandNameHtml = '<div class="display-block grey">' + event['brandName'] + '</div>'
    }

    eventDetails.append(
        '<span class="display-block font-1p25em event-history-name">' +
            event['name'] +
        '</span>' +
        '<span class="display-block grey margin-top-5">' +
            event['year'] +
        '</span>' +
        brandNameHtml +
        weeklyShowHtml +
        '<span class="display-block margin-top-8 margin-bottom-15">' +
        progressHtml + prestigeIcon +
        '</span>' +
        topEvent +
        eventHypeHtml +
        viewershipHtml
    );

    // Create bonuses divs
    let eventBonusesDiv = $('<div class="font-bold grey"></div>');
    let eventBonusesContainer = $('<div class="event-history-effects-container margin-top-8"></div>');

    // Add streaks container
    if (event['xp']) {
        if (event['streaks'].length > 0) {
            let eventStreaksContainer = $('<div class="bonuses-container"></div>');
            eventStreaksContainer.append('<div class="margin-bottom-2 medium-grey">Streaks</div>');

            let streakPotentials = event['streaks'].reduce(function (filtered, streak) {
                if (streak['length'] < 2) {
                    filtered.push(streak['holder']);
                }
                return filtered;
            }, []);

            event['streaks'].forEach(function (streak) {
                // Potential streaks
                if (streak['length'] >= 2) {
                    let streakText;
                    let streakClass = 'bronze';
                    if (streak['length'] < 5) {
                        streakClass = 'bronze'
                    }
                    else if (streak['length'] < 10) {
                        streakClass = 'gold-light'
                    }
                    else if (streak['length'] < 20) {
                        streakClass = 'faded-red'
                    }
                    else {
                        streakClass = 'obsidian'
                    }

                    if (streak['length'] >= 10) {
                        streakText = '{0} <span class="{1} margin-left-3">{2}-0</span>'.format(
                            streak['holder'], streakClass, streak['length']);
                    }
                    else {
                        let winText = (streak['length'] > 1) ? 'Wins' : 'Win';
                        streakText = '{0} <span class="{1} margin-left-3">{2} {3}</span>'.format(
                            streak['holder'], streakClass, streak['length'], winText);
                    }

                    let streakHtml = '<div>' + streakText + '</div>';
                    eventStreaksContainer.append(streakHtml);
                }
            });

            if (streakPotentials.length > 0) {
                let streakText = '<span class="light-grey">Streak Potential: {0}</span>'.format(
                    streakPotentials.join(', ')
                );
                let streakHtml = '<div>' + streakText + '</div>';
                eventStreaksContainer.append(streakHtml);
            }

            eventBonusesContainer.append(eventStreaksContainer);
        }

        // Add match bonuses container
        if (event['matchEffects'].length > 0) {
            let eventMatchEffectsContainer = $('<div class="bonuses-container"></div>');
            eventMatchEffectsContainer.append('<div class="margin-bottom-2 medium-grey">Gimmick Match Effects</div>');

            let plusPotentials = event['matchEffects'].reduce(function (filtered, matchBonus) {
                if (!matchBonus['bonus'] && matchBonus['points'] > 0) {
                    filtered.push(matchBonus['gimmickMatch']);
                }
                return filtered;
            }, []);

            let minusPotentials = event['matchEffects'].reduce(function (filtered, matchBonus) {
                if (!matchBonus['bonus'] && matchBonus['points'] < 0) {
                    filtered.push(matchBonus['gimmickMatch']);
                }
                return filtered;
            }, []);

            event['matchEffects'].forEach(function (matchEffect) {
                if (matchEffect['bonus']) {
                    let matchEffectText;
                    let matchEffectClass = 'bronze';
                    if (matchEffect['bonus'] < 0) {
                        matchEffectClass = 'puke-green'
                    }
                    else {
                        matchEffectClass = 'gold'
                    }

                    let bonus;
                    if (matchEffect['bonus'] > 0) {
                        bonus = '+ ' + matchEffect['bonus']
                    }
                    else {
                        bonus = '- ' + (matchEffect['bonus'] * -1)
                    }

                    matchEffectText = '{0} <span class="{1} margin-left-3">{2} HYPE</span>'.format(
                        matchEffect['gimmickMatch'], matchEffectClass, bonus);

                    let matchEffectHtml = '<div>' + matchEffectText + '</div>';
                    eventMatchEffectsContainer.append(matchEffectHtml);
                }
            });

            if (plusPotentials.length > 0) {
                let matchBonusText = '<span class="light-grey">+ Effect Potential: {0}</span>'.format(
                    plusPotentials.join(', ')
                );
                let matchBonusHtml = '<div>' + matchBonusText + '</div>';
                eventMatchEffectsContainer.append(matchBonusHtml);
            }

            if (minusPotentials.length > 0) {
                let matchBonusText = '<span class="light-grey">- Effect Potential: {0}</span>'.format(
                    minusPotentials.join(', ')
                );
                let matchBonusHtml = '<div>' + matchBonusText + '</div>';
                eventMatchEffectsContainer.append(matchBonusHtml);
            }

            eventBonusesContainer.append(eventMatchEffectsContainer);
        }

        // Add match contracts container
        if (event['matchContracts'].length > 0) {
            let eventMatchContractsContainer = $('<div class="bonuses-container"></div>');
            eventMatchContractsContainer.append('<div class="margin-bottom-2 medium-grey">Match Contracts</div>');

            event['matchContracts'].forEach(function (matchContract) {
                let matchContractText;

                let matchContractClass;
                if (matchContract['bonus'] < 25) {
                    matchContractClass = 'bronze'
                }
                else if (matchContract['bonus'] < 50) {
                    matchContractClass = 'gold-light'
                }
                else if (matchContract['bonus'] < 70) {
                    matchContractClass = 'faded-red'
                }
                else {
                    matchContractClass = 'obsidian'
                }

                matchContractText = '{0}<span class="margin-left-3 light-grey"> {1}</span><span class="{2} margin-left-3"> + {3} HYPE</span>'.format(
                    matchContract['holder'], matchContract['name'],
                    matchContractClass, matchContract['bonus']
                );

                let matchContractHtml = '<div>' + matchContractText + '</div>';
                eventMatchContractsContainer.append(matchContractHtml);
            });

            eventBonusesContainer.append(eventMatchContractsContainer);
        }

        // Add bonuses to event details
        if (event['streaks'].concat(event['matchEffects'], event['matchContracts']).length > 0) {
            eventBonusesDiv.append(eventBonusesContainer);
            eventDetails.append(eventBonusesDiv);
        }
    }

    // Display text if event not held and return function
    if (event['rating'] === null) {
        let emptyText;
        emptyText = 'To Be Held';
        eventHistory.append(
            '<span class="font-bold display-block grey">' + emptyText + '</span>'
        );

        // Don't show next/prev buttons if event not held (future event)
        nextEventSelector.hide();
        previousEventSelector.hide();
    }
    // Show matches and segments
    else {
        event['matchesAndSegments'].forEach(function (segment) {
            let segmentResultHtml;
            if (segment['segmentType'] === 'segment') {
                segmentResultHtml = getSegmentHistoryHtml(segment)
            }
            else {
                segmentResultHtml = getMatchHistoryHtml(segment)
            }
            eventHistory.append('<div class="margin-bottom-20 font-bold text-left" tabindex="0">' + segmentResultHtml + '</div>');
        });

        // Calculate rating stars
        let eventRating = event['rating'];
        let eventRatingFloor = Math.floor(eventRating);
        let eventDecimalRating = eventRating - eventRatingFloor;
        let eventRatingText = '<i class="fa fa-star"></i>'.repeat(eventRatingFloor);

        // Fix display of stars on quarter and three-quarter star
        if (eventDecimalRating === 0.75) {
            eventDecimalRating = 0.70;
        }
        else if (eventDecimalRating === 0.25) {
            eventDecimalRating = 0.35;
        }

        // Display rating decimal star
        if (eventDecimalRating > 0) {
            eventRatingText += '<i class="star star-under fa fa-star">' +
                '<i class="star star-over fa fa-star" style="width: ' +
                eventDecimalRating * 100 + '%"></i>' +
                '</i>';
        }

        if (eventRatingFloor < 5) {
            if (eventDecimalRating > 0) {
                eventRatingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - eventRatingFloor - 1);
            }
            else {
                eventRatingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - eventRatingFloor);
            }
        }

        // Add points and fans
        let fansAndPointsText = '';

        let pointsEarned = event['pointsEarned'].toLocaleString();
        fansAndPointsText += '<span class="display-block font-1p125em">' +
            '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small"/>';

        if (event['pointsEarned'] >= 0) {
            fansAndPointsText += '<i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i>' +
                '<span>' + pointsEarned + '</span>';
        }
        else {
            fansAndPointsText += '<i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i>' +
                '<span>' + pointsEarned + '</span>';
        }

        // Add fans
        if (event['fansGained'] !== null) {
            let fansEarned = event['fansGained'].toLocaleString();
            fansAndPointsText += '<img alt="Fans" src="static/www/static/fans_icon.png" class="points-image-small margin-left-20"/>';

            if (event['fansGained'] >= 0) {
                fansAndPointsText += '<i class="fa fa-angle-double-up margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Increase"></i>' +
                    '<span>' + fansEarned + '</span></span>';
            } else {
                fansAndPointsText += '<i class="fa fa-angle-double-down margin-left-7 margin-right-5 grey font-0p875em top-1px" role="text" aria-label="Decrease"></i>' +
                    '<span>' + fansEarned + '</span></span>';
            }
        }

        // Add to event results
        eventHistory.append(
            '<div class="event-results-container text-left" tabindex="0">' +
            '<div class=col1>' +
            '<span class="font-bold font-mukta-mahee font-1p125em">' + fansAndPointsText + '</span>' +
            '</div>' +
            '<div class="col2 text-right">' +
            '<span class="font-bold match-star-rating history" role="text" aria-label="Event Rating: ' + event['rating'] + ' stars' + '">' + eventRatingText + '</span>' +
            '</div>' +
            '<div class="clear"></div>' +
            '</div>'
        )
    }

    // Add event history
    eventDetails.append(eventHistory);

    eventDetails.data('uid', event['uid']);
}

function getMatchHistoryHtml(match, blowoff, showFeudBlowoffOnly) {
    if (typeof(blowoff) === 'undefined') blowoff = false;
    if (typeof(showFeudBlowoffOnly) === 'undefined') showFeudBlowoffOnly = false;

    // Get winner text
    let winner = match['winner']['name'];

    // Get manager text if present
    let winnerParticipant = match['participants'].filter(function (m) {
        return m['name'] === match['winner']['name']
    })[0];
    if (winnerParticipant) {
        let managersHtml = getMatchParticipantManagersHtml(winnerParticipant);
        winner += managersHtml;
    }

    let winnerChampionshipText = '';
    let retainedChampionshipText = '';

    if (match['winner']['championshipsWon'] && match['winner']['championshipsDefended']) {
        winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold">' +
            match['winner']['championshipsWon'] + '</span></span>';
        winnerChampionshipText += '<span class="margin-left-5">and retain the<span class="margin-left-5 gold">' +
            match['winner']['championshipsDefended'] + '</span></span>';
    }
    else {
        if (match['winner']['championshipsWon']) {
            winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold">' +
                match['winner']['championshipsWon'] + '</span></span>';
        }
        else if (match['winner']['championshipsDefended']) {
            winnerChampionshipText = '<span class="margin-left-5">to retain the<span class="margin-left-5 gold">' +
                match['winner']['championshipsDefended'] + '</span></span>';
        }
        else if (match['winner']['championshipsRetained']) {
            retainedChampionshipText = '<span class="display-block margin-top-5"><span class="gold">' +
                match['winner']['championshipsRetained'] +
                '</span> didn\'t change hands</span>';
        }
    }

    // Get loser names with managers
    let losers = [];
    match['participants'].forEach(function(matchParticipant) {
        if (matchParticipant !== winnerParticipant) {
            let loserText = matchParticipant['name'];
            let managersHtml = getMatchParticipantManagersHtml(matchParticipant);
            loserText += managersHtml;
            losers.push(loserText);
        }
    });

    // Join losers with comma and 'and'
    let losersHtml;
    if (losers.length > 1) {
        losersHtml = losers.slice(0, -1).join(', ') + ' and ' + losers.slice(-1);
    }
    else {
        losersHtml = losers[0];
    }

    // Match finish text
    let finishHtml = '';
    if (match['finishName']) {
        let finishText = '';
        if (match['finishText']) {
            finishText = '<span class="margin-left-5">by ' + match['finishText'] + '</span>'
        }
        let noContestText = '';
        if (['Double Pin', 'Time-limit Draw', 'Ring Collapse'].indexOf(match['finishName']) >= 0) {
            noContestText = ' No Contest '
        }
        finishHtml = '<span class="margin-left-5 light-grey">' +
            noContestText + 'via <span class="match-finish-color">' + match['finishName'] + '</span>' +
            finishText +
            '</span>'
    }

    let generatedText;
    if (match['text']) {
        generatedText = '<span class="display-block generated-text">' + match['text'] + '</span>';
    }

    // Set rating
    let rating;
    let ratingText;
    if (match['rating'] !== null) {
        let ratingValue = match['rating'];
        let ratingFloor = Math.floor(ratingValue);
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) {
                decimalRating = 0.70;
            }
            else if (decimalRating === 0.25) {
                decimalRating = 0.35;
            }
            ratingText += '<i class="star star-under fa fa-star">' +
                '<i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
                '</i>';
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
            }
        }
        else {
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
            }
        }
        // Set rating element
        rating = '<span class="display-block match-star-rating history" role="text" aria-label="' + match['rating'] + ' stars' + '">' +
            ratingText +
            '</span>';
    }
    else {

        // Show cash in indicator if rating is null and winner is not null
        let cashinHtml = '';
        if (match['winnerName'] !== null) {
            cashinHtml = ' <span>Cash In</span>';
        }

        // Set rating element
        rating = '<span class="display-block">' +
            '<span class="font-0p925em">' +
            '<span class="grey">No Rating</span>' +
            cashinHtml +
            '</span></span>';
    }

    // Show tournament details
    let tournamentText = '';
    if (match['tournamentName']) {
        tournamentText = "<span class='font-bold display-block margin-bottom-5 medium-grey'>" +
            match['tournamentName'] + ' ' + match['tournamentRoundName'] +
            "</span>"
    }

    // Set Gimmick match text
    let text;
    let matchGimmick = match['gimmick'];

    if (match['activeEffect'] === 'draw') {
        text = "{0} wrestled {1} to a {2} minute Time Limit Draw{3}".format(winner, losersHtml, match['text'], winnerChampionshipText);
    }
    else if (match['activeEffect'] === 'squash') {
        text = "{0} squashed {1} in a short match{2}".format(winner, losersHtml, winnerChampionshipText);
    }
    else if (matchGimmick) {
        // Show generated text
        if (match['text']) {
            if (match['rules'] === 'battle_royal') {
                text = "{0}{1} won the {2} match{3}{4}".format(generatedText, winner, matchGimmick, finishHtml, winnerChampionshipText);
            }
            else if (matchGimmick === 'Ironman') {
                text = "{0} <span class='light-grey'>def.</span> {1}{2} with a score of {3}{4}".format(winner,
                    losersHtml, finishHtml, match['text'], winnerChampionshipText);
            }
            else {
                // 2/3 falls, elimination
                text = "{0}{1} <span class='light-grey'>def.</span> {2}{3}{4}<span class='grey margin-left-8'>{5} Match</span>".format(generatedText,
                    winner, losersHtml, finishHtml, winnerChampionshipText, matchGimmick);
            }
        }
        else if (match['refereeName']) {
            let refereeText = '<span> w/ ' + match['refereeName'] + '</span>';
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}<span class='grey margin-left-8'>{4} Match{5}</span>".format(winner,
                losersHtml, finishHtml, winnerChampionshipText, matchGimmick, refereeText);
        }
        else if (matchGimmick === 'Steel Cage' || matchGimmick === 'Graphene Cage') {
            text = "{0} escaped the cage{1}, defeating {2}{3}".format(winner,
                winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'I Quit') {
            text = "{0} made {1} say 'I Quit'{2}{3}".format(winner,
                losersHtml, finishHtml, winnerChampionshipText);
        }
        else if (matchGimmick === 'Street Fight') {
            text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent street fight{3}".format(winner,
                losersHtml, finishHtml, winnerChampionshipText);
        }
        else if (matchGimmick.includes('Ladder')) {
            text = "{0} climbed the ladder{1}, defeating {2}{3}".format(winner,
                winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Pu Ladder') {
            text = "{0} climbed the plutonium ladder{1}, defeating {2}{3}".format(winner,
                winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Pole') {
            text = "{0} grabbed the {1} off the pole{2}, defeating {3}{4}".format(winner,
                match['generated']['objectToClaim'], winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Canyon Fight') {
            text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent canyon fight{3}".format(winner,
                losersHtml, finishHtml, winnerChampionshipText);
        }
        else if (matchGimmick === 'Glacier Escape') {
            text = "{0} escaped the glacier{1}, defeating {2}{3}".format(winner,
                winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Open Challenge') {
            text = "{0} <span class='light-grey'>def.</span> {1}{2} in an Open Challenge{3}".format(winner,
                losersHtml, finishHtml, winnerChampionshipText);
        }
        else {
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}<span class='grey margin-left-8'>{4} Match</span>".format(winner,
                losersHtml, finishHtml, winnerChampionshipText, matchGimmick);
        }
    }
    // Get normal match text
    else {
        if (['Double Pin', 'Time-limit Draw', 'Ring Collapse'].indexOf(match['finishName']) >= 0) {
            text = "{0} <span class='light-grey'>vs</span> {1}{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        }
        else {
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        }
    }

    // Feud Hypes
    let feudsHtml = '';

    if (showFeudBlowoffOnly) {
        match['feuds'].forEach(function (feud) {
            if (blowoff && feud['ended']) {
                let feudName = '<span class="bright-red">Blowoff</span>';
                feudsHtml +=
                    '<span class="margin-left-8">' +
                    '<span class="faded-red-light">' + feudName + '</span>' +
                    '</span>';
            }
        })
    }
    else {
        match['feuds'].forEach(function (feud) {
            let feudName = feud['name'];
            if (blowoff && feud['ended']) {
                feudName += ' <span class="bright-red">Blowoff</span>';
            }
            feudsHtml +=
                '<span class="margin-left-8">' +
                '<span class="faded-red-light">' + feudName + '</span>' +
                '</span>';
        })
    }

    return '<div class=col1>' +
        tournamentText + text + feudsHtml + retainedChampionshipText +
        '</div>' +
        '<div class="col2 text-right">' +
        rating +
        '</div>' +
        '<div class="clear"></div>';
}

function getSegmentHistoryHtml(segment, blowoff, showFeudBlowoffOnly) {
    if (typeof(blowoff) === 'undefined') blowoff = false;
    if (typeof(showFeudBlowoffOnly) === 'undefined') showFeudBlowoffOnly = false;

    let feudsHtml = '';
    if (showFeudBlowoffOnly) {
        segment['feuds'].forEach(function (feud) {
            if (blowoff && feud['ended']) {
                let feudName = '<span class="bright-red">Blowoff</span>';
                feudsHtml +=
                    '<span class="margin-left-8">' +
                    '<span class="faded-red-light">' + feudName + '</span>' +
                    '</span>';
            }
        })
    }
    else {
        segment['feuds'].forEach(function (feud) {
            let feudName = feud['name'];
            if (blowoff && feud['ended']) {
                feudName += ' <span class="bright-red">Blowoff</span>';
            }
            feudsHtml +=
                '<span class="margin-left-8">' +
                '<span class="faded-red-light">' + feudName + '</span>' +
                '</span>';
        })
    }

    let rating = getSegmentRating(segment);
    let text = getSegmentText(segment);

    return '<div class=col1>' +
        text + feudsHtml +
        '</div>' +
        '<div class="col2 text-right">' +
        rating +
        '</div>' +
        '<div class="clear"></div>';
}

function getSegmentText(segment, segmentNameClass) {
    // Segment history text
    if (typeof(segmentNameClass) === 'undefined') segmentNameClass = 'faded-purple';

    let segmentParticipants = '';
    if (Array.isArray(segment['participants'])) {
        let segmentParticipantsList = [];
        segment['participants'].forEach(function(participantName) {
            let segmentParticipant = participantName;
            // Get manager text if present
            if (segment['participantsDetails']) {
                let participant = segment['participantsDetails'].filter(function (m) {
                    return m['name'] === participantName
                })[0];
                if (participant && participant['managerNames'].length > 0) {
                    segmentParticipant += '<span class="margin-left-5 grey"><span>w/</span> {0}</span>'.format(commaSeparate(participant['managerNames'], ' <span>and</span> '));
                }
            }
            segmentParticipantsList.push(segmentParticipant)
        });
        segmentParticipants = commaSeparate(segmentParticipantsList);
    }

    let joinText = '';
    let text;
    if (segment['participants'].length > 0) {
        joinText = 'between';
        if (segment['participants'].length === 1 || segment['managerSegment']) {
            joinText = 'with'
        }
        if (segment['productionSegment']) {
            joinText = 'for'
        }
    }

    text = "<span class='" + segmentNameClass + "'>{0}</span> <span class='light-grey'>" + joinText + "</span> {1}";
    text = text.format(segment['name'], segmentParticipants);

    return text;
}

function getSegmentRating(segment) {
    // Set rating
    let rating;
    let ratingText;
    let ratingValue = segment['rating'];
    let ratingFloor = Math.floor(ratingValue);
    if (ratingFloor === 0) {
        ratingText = '<i class="fa fa-star star-under"></i>'.repeat(5);
    }
    else {
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) {
                decimalRating = 0.70;
            }
            else if (decimalRating === 0.25) {
                decimalRating = 0.35;
            }
            ratingText += '<i class="star star-under fa fa-star">' +
                '<i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
                '</i>';
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
            }
        }
        else {
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
            }
        }
    }
    rating = '<span class="display-block match-star-rating history">' +
        '<span class="dark-grey" role="text" aria-label="' + ratingValue + ' stars' + '">' +
        ratingText +
        '</span></span>';

    return rating;
}

async function loadViewEventCalendarPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getCompanyEventsData(companyUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewEventCalendarPageData(data);
}

function showViewEventCalendarPageData(data) {
    data['events'].forEach(function (event, index) {
        let eventCalendarBox = $('.event-calendar-box').eq(index);
        let eventName = event['name'];
        if (event['brandName']) {
            eventName += ' <span class="grey display-block margin-top-3">' + event['brandName'] + '</span>'
        }
        eventCalendarBox.find('.event-calendar-name').html(eventName);
        eventCalendarBox.find('.event-calendar-name').data('uid', event['uid']);
        eventCalendarBox.find('.event-calendar-name').data('latestChildEventUid', event['latestChildEventUid']);
        eventCalendarBox.removeClass('current');
        if (event['name'] === data['upcomingEventName']) {
            eventCalendarBox.addClass('current');
        }
    });
    $('#event-calendar').fadeIn();
}


async function loadRebrandEventPage(selectedEvent, element) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getCompanyEventsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRebrandEventPageData(data, selectedEvent, element);
}

function showRebrandEventPageData(data, selectedEvent, element) {
    let selectOptions = '';
    let selectElement = element.find('.rebrand-event-event-select');
    data['events'].forEach(function(event) {
        let eventBrandName = event['brandName'];
        if (eventBrandName) {
            eventBrandName = event['brandName'].replace(/"/g, "&quot;")
        }
        selectOptions += '<option data-uid="' + event['uid'] + '" data-brand-name="' + eventBrandName +
            '">' + event['name'] + '</option>'
    });
    if (data['companyWeeklyShowName']) {
        selectOptions += '<option data-weekly-show="true"">' + data['companyWeeklyShowName'] + '</option>'
    }
    selectElement.html(selectOptions);

    // Select previously selected championship
    selectElement.val(selectedEvent);
    if (selectElement.val() === null) {
        selectElement.prop("selectedIndex", 0);
    }

    // Add brand names
    let brandNamesOptions = '<option value="">None</option>';
    data['brandNames'].forEach(function (brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + '</option>'
    });
    element.find('.rebrand-event-brand-select').html(brandNamesOptions);

    // Reset name input
    element.find('.rebrand-event-name-input').val('');

    // Load details for selected event
    $(".rebrand-event-event-select").trigger('change');

    element.fadeIn('slow').removeClass('display-none');
}

async function rebrandEventRequest(uid, name, weeklyShow, brandName) {

    if (globals.requestRunning) {
        return;
    }

    // Check if name entered
    if (name.length <= 0) {
        notie.alert({ type: 3, text: 'Enter a name for the Event', stay: true });
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await rebrandEvent(uid, name, weeklyShow, brandName);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    await showRebrandEventData(data);
}

async function showRebrandEventData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        notie.alert({type: 4, text: "{0} has been Rebranded to {1}".format(data['previousName'], data['newName'])});

        if (data['updateEvent']) {
            // Reload event card
            await loadEventCardPage();

            // Go back to view events
            setTimeout(function () {
                $('#view-events-menu-button').trigger('click')
            }, 1200);
        }
        else {
            // Go back to view events
            setTimeout(function () {
                $('#view-events-menu-button').trigger('click')
            }, 1200);
        }
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to change this Event's Name"
            });
        }
        else if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot change Event Names in Wrestling on Mars"});
        }
        else if (data['error'] === 'name-exists') {
            notie.alert({type: 3, text: "An Event with that name already exists in your Company"});
        }
        else if (data['error'] === 'same-name') {
            notie.alert({
                type: 3,
                text: "Enter a different Name from the Event's current Name"
            });
        }
    }
}

async function loadEventCardPage() {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEventCardData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showEventCardData(data);
}

function showEventCardData(data) {
    const $eventCardNameDetails = $('#event-card-name-details');
    const $eventCardWeeklyShow = $('.event-card-weekly-show');

    // Show brand name
    updateEventCardBrand(data['eventData']);

    let baseHype = data['eventData']['baseHype'];
    if (baseHype < 0) {
        baseHype *= -1;
        baseHype = '- ' + baseHype + '</span>'
    } else {
        baseHype = '+ ' + baseHype + '</span>'
    }
    $('.event-hype').html(baseHype + ' Base HYPE');

    // Show event prestige
    $eventCardNameDetails.html('');
    if (!data['eventData']['weeklyShow']) {
        displayEventPrestigeAndEffects(data['eventData']);
    }
    else {
        $eventCardWeeklyShow.show();
        if (data['eventData']['weeklyShowName']) {
            $eventCardWeeklyShow.text(data['eventData']['weeklyShowName'])
        }
        else {
            $eventCardWeeklyShow.text('Weekly Show')
        }
        $(".event-prestige-effects").hide();
    }

    // Show event name and information
    let eventActiveEffect = '';
    if (data['eventData']['activeEffect']) {
        if (data['eventData']['activeEffect'] === 'premier_event') {
            eventActiveEffect = '<img alt="Trophy" src="static/www/static/trophy_icon_gold.png" class="trophy-image small help-text margin-left-10" title="' +
            toTitleCase(data['eventData']['activeEffect'].replace(/_/g, ' ')) +
            '"/>';
        }
        else {
            eventActiveEffect = '<img alt="Artifact" src="static/www/static/powerup_1_icon_small.png" class="powerup-image-small left-0 help-text margin-left-8" title="' +
                toTitleCase(data['eventData']['activeEffect'].replace(/_/g, ' ')) +
                '"/>';
        }
    }
    $eventCardNameDetails.append(eventActiveEffect);

    // Update match limits
    globals.game.maximumMatchesAndSegments = data['maximumMatchesAndSegments'];
    globals.game.minimumMatchesAndSegments = data['minimumMatchesAndSegments'];

    // Add matches and segments
    addEventCardMatchesAndSegments(data['matchesAndSegments']);

    $('#event-card').fadeIn();
}

async function loadViewFeudsPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewFeudsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewFeudsPageData(data);
}

function showViewFeudsPageData(data) {
    const $currentFeuds = $('.current-feuds');
    const $potentialFeuds = $('.potential-feuds');
    const $pastFeuds = $('.past-feuds');

    // Reset ui
    $('.feud-history').html('').hide();
    $('.feud-history-item.selected').removeClass('selected');
    $('.feuds-history-search-input').val('');

    // Show current feuds
    let currentFeudsHtml = '<div class="margin-bottom-5 font-0p925em dark-grey margin-left-2">Current Feuds</div>';
    data['currentFeuds'].forEach(function (feud) {
        currentFeudsHtml += getFeudDetailsHtml(feud);
    });
    if (data['currentFeuds'].length < 1) {
        currentFeudsHtml += '<div class="grey margin-left-2">None</div>';
    }
    $currentFeuds.html(currentFeudsHtml);

    // Show potential feuds
    let potentialFeudsHtml = '<div class="margin-bottom-5 font-0p925em dark-grey margin-left-2">Potential Feuds</div>';
    data['potentialFeuds'].forEach(function (feud) {
        potentialFeudsHtml += getFeudDetailsHtml(feud);
    });
    if (data['potentialFeuds'].length < 1) {
        potentialFeudsHtml += '<div class="grey margin-left-2">None</div>';
    }
    $potentialFeuds.html(potentialFeudsHtml);

    // Show past feuds
    let pastFeudsHtml = '<div class="margin-bottom-5 font-0p925em dark-grey margin-left-2">Past Feuds</div>';
    data['pastFeuds'].forEach(function (feud) {
        pastFeudsHtml += getFeudDetailsHtml(feud);
    });
    if (data['pastFeuds'].length < 1) {
        pastFeudsHtml += '<div class="grey margin-left-2 past-feuds-none-text">None</div>';
    }
    $pastFeuds.html(pastFeudsHtml);

    $currentFeuds.children().show();
    $potentialFeuds.children().show();
    $pastFeuds.children().show();

    $('.feuds-history-sort').val('date').trigger('change');

    $("#feud-history-container").fadeIn('slow').removeClass('display-none');
    $(".current-feuds, .potential-feuds, .past-feuds").scrollTop(0);

    // Tutorial action check
    checkTutorialStepAction('click_view_feuds_menu_button');
}

function getFeudDetailsHtml(feud, order) {

    let duration = '';
    let sinceEnded = '';
    let endFeudButton = '';
    if (feud['monthsElapsed'] !== undefined) {
        duration = feud['monthsElapsed'] + ' ' + getMonthsWord(feud['monthsElapsed']) + ' long'
    }
    if (feud['monthsSinceBlowoff'] !== undefined) {
        sinceEnded = feud['monthsSinceBlowoff'] + ' ' + getMonthsWord(feud['monthsSinceBlowoff']) + ' since end'
    }
    else {
        endFeudButton = '<button type="button" id="end-feud-button" class="button retro-button condensed ' +
            'grey-button-background margin-bottom-5">End Feud</button>'
    }

    let potential = '';
    if (!feud['started']) {
        potential =
            '<div class="potential-feud-red">Potential</div>';
    }

    let feudHot = '';
    if (feud['hot']) {
        feudHot = '<span class="hot-color margin-left-5">Hot</span>'
    }

    let feudStale = '';
    if (feud['stale']) {
        feudStale = '<span class="stale-color margin-left-5">Stale</span>'
    }

    let participants = feud['participants'].join(' vs ');
    let feudOrder = (order) ? order : feud['order'];

    return '<div class="margin-bottom-15 feud-history-item inside-box" data-uid="' + feud['uid'] + '" ' +
        'data-hype="' + feud['hype'] + '" data-duration="' + feud['monthsElapsed'] + '" data-order="' + feudOrder + '" ' +
        'data-name="' + feud['name'] + '" data-participants="' + feud['participants'].join(',').replace(/"/g, "&quot;") + '" tabindex="0">' +
        '<div class="margin-bottom-3 faded-red-light">' +
        feud['name'] + feudHot + feudStale +
        '<span class="float-right faded-red-light">' +
        '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(feud['hype']) +
        '</span>' +
        '</div>' +
        '<div class="grey">' + participants + '</div>' +
        potential +
        '<div class="light-grey">' + duration + '</div>' +
        '<div class="light-grey">' + sinceEnded + '</div>' +
        '<div class="margin-top-10">' + endFeudButton + '</div>' +
        '</div>';
}

async function loadViewFeudHistoryPage(uid, $el) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getFeudHistoryData(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showViewFeudHistoryPageData(data, $el);
}

function showViewFeudHistoryPageData(data, $el) {
    let feudHistoryHtml = getFeudHistoryHtml(data);
    $('.feud-history').html(feudHistoryHtml).show();

    // Hide all labels and feuds
    $('.current-feuds').children().hide();
    $('.potential-feuds').children().hide();
    $('.past-feuds').children().hide();
    $el.addClass('selected').show();

    // Tutorial action check
    if (data['nextTutorialState']) {
        globals.game.tutorialState = data['nextTutorialState']
    }

    // Tutorial action check
    checkTutorialStepAction('select_feud_history_item');
}

function getFeudHistoryHtml(feud) {

    let history = '';
    if (feud['events'].length > 0) {

        // Win records
        feud['winRecords'].sort(function (a, b) {
            return b['wins'] - a['wins']
        });
        let winRecords = Array.from(feud['winRecords'], function (participant) {
            return '{0}<span class="light-grey margin-left-5">{1}</span>'.format(participant['name'], participant['wins'])
        }).join('<span class="margin-left-8">');
        history += '<div class="margin-top-10">';
        history += '<span class="display-block grey">Win Record</span>';
        history += '<span class="display-block dark-grey">' + winRecords +
            '</span>';
        history += '</div>';

        // Staleness check
        if (feud['staleLength']) {
            history += '<div class="margin-top-20">';
            history += '<span class="display-block grey">Staleness Check</span>';
            history += '<span class="display-block dark-grey help-text margin-left-1" ' +
                'title="Monthly Event Matches add +1, Weekly Show Matches add ' +
                '+0.5 and Segments add +0.25 to the Feud\'s Staleness Check.">' + feud['stalenessCounter'] + ' / ' +
                '<span class="stale-color">' + feud['staleLength'] + '</span>' +
                '</span>';
            history += '</div>';
        }

        // Match/segment history
        history += '<div class="display-block grey margin-top-20">History</div>';

        feud['events'].forEach(function (event, i) {
            let blowoff = false;
            let html;
            if (i === 0) {
                blowoff = true
            }
            if (event['eventType'] === 'match') {
                html = getMatchHistoryHtml(event, blowoff, true);
            }
            else if (event['eventType'] === 'segment') {
                 html = getSegmentHistoryHtml(event, blowoff, true);
            }
            if (event['eventWeeklyShow']) {
                history +=
                    '<div class="margin-bottom-15 font-bold text-left">' +
                    '<div class="faded-blue">' + event['event'] + '</div>' +
                    html +
                    '</div>'
            }
            else {
                history +=
                    '<div class="margin-bottom-15 font-bold text-left">' +
                    '<div class="blue">' + event['event'] + '</div>' +
                    html +
                    '</div>'
            }
        });

        if (feud['rating']) {
            history +=
                '<div class="event-results-container text-left margin-bottom-5" tabindex="0">' +
                '<div class=col1>' +
                '<span class="font-bold">Feud Rating</span>' +
                '</div>' +
                '<div class="col2 text-right">' +
                '<span class="font-bold match-star-rating history text-right" role="text" aria-label="' + feud['rating'] + ' stars' + '">' + getStarRatingHtml(feud['rating']) + '</span>' +
                '</div>' +
                '<div class="clear"></div>' +
                '</div>'
        }

        if (feud['pastFeuds'].length > 0) {
            // Past feuds
            history += '<div class="display-block grey margin-top-20 margin-bottom-5">Past Feuds</div>';

            feud['pastFeuds'].forEach(function (pastFeud) {
                let sinceEnded = '';
                if (pastFeud['monthsSinceBlowoff'] !== undefined) {
                    sinceEnded = pastFeud['monthsSinceBlowoff'] + ' ' + getMonthsWord(pastFeud['monthsSinceBlowoff']) + ' since end'
                }
                let feudHot = '';
                if (pastFeud['hot']) {
                    feudHot = '<span class="hot-color margin-left-8">Hot</span>'
                }
                let feudStale = '';
                if (pastFeud['stale']) {
                    feudStale = '<span class="stale-color margin-left-8">Stale</span>'
                }

                let html =
                    '<div class="margin-bottom-15">' +
                        '<div class="faded-red-light margin-left-1">' +
                            pastFeud['name'] + feudHot + feudStale +
                            '<span class="float-right faded-red-light">' +
                            '<i class="fa fa-bolt margin-right-5"></i>' + Math.round(pastFeud['hype']) +
                            '</span>' +
                        '</div>' +
                        '<div class="light-grey">' + sinceEnded + '</div>' +
                    '</div>';

                history += html;
            })
        }
    }
    else {
        history +=
            '<div class="font-bold text-left">No Matches or Segments held</div>';
    }

    return history;
}

function applyFeudsHistorySort(value) {
    let sortedElements = $('.feud-history-item');

    let sortClass = '';
    if (value === 'hype') {
        sortedElements.sort(function (a, b) {
            return (parseFloat($(b).attr('data-hype')) - parseFloat($(a).attr('data-hype'))
            );
        });
        sortClass = 'fa-sort-down';
    }
    else if (value === 'duration') {
        sortedElements.sort(function (a, b) {
            let durationA = ($(a).attr('data-duration') !== 'undefined') ? parseFloat($(a).attr('data-duration')) : 0;
            let durationB = ($(b).attr('data-duration') !== 'undefined') ? parseFloat($(b).attr('data-duration')) : 0;
            return (durationB - durationA);
        });
        sortClass = 'fa-sort-down';
    }
    else if (value === 'date') {
        sortedElements.sort(function (a, b) {
            return (parseFloat($(a).attr('data-order')) - parseFloat($(b).attr('data-order'))
            );
        });
        sortClass = 'fa-sort-down';
    }

    sortedElements.toArray().forEach(function (e) {
        $(e).parent().append(e)
    });

    // Select default sort order
    if (sortClass) {
        let sortOrderElement = $('.feuds-history-sort-order');
        let sortOrderIcon = sortOrderElement.find('i');
        sortOrderIcon.removeClass('fa-sort fa-sort-up fa-sort-down').addClass(sortClass);
        sortOrderElement.addClass('cursor-pointer');
    }
}


function runFeudHistorySearch() {

    let feudElements = $('.feud-history-item');
    let searchTerm = $(".feuds-history-search-input").val();

    // Show all feuds
    feudElements.show();

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(feudElements, searchTerm, ['dataset.name', 'dataset.participants']);
        feudElements.toArray().forEach(function (e) {
            if (searchResults.indexOf(e) < 0) {
                $(e).hide()
            }
        });
        // Show results if found
        if (searchResults.length > 0) {
            $('.no-feuds-history-search-results').hide();
        }
        else {
            $('.no-feuds-history-search-results').show()
        }
    }
}

async function getEndFeudRequest(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await endViewFeudsFeud(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showEndFeudData(data);
}

function showEndFeudData(data) {

    // Show feud ended notification
    let rating =
    '<span class="display-inline-block margin-left-5">' + getStarRatingHtml(data['rating']) + '</span>';
    let text = 'Ended the <span class="faded-red-light">' + data['name'] + '</span>' +
    ' Feud between ' + commaSeparate(data['participants']) + ' ' + rating;
    notie.alert({
        type: 4, text: text, stay: true
    });

    // Go back to view feuds
    setTimeout(function () {
        $("#view-feuds-menu-button").trigger('click');
    }, 1200);
}

async function loadCreateFeudPage(participantType, participantUids, getParticipants, runHideContent) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let talentData;
    if (getParticipants) {
        talentData = await getAllTalentData(participantType);
    }
    let itemsData = await getCreateFeudItemsData(participantUids, participantType);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    if (runHideContent) {
        hideContent($());
    }
    if (talentData) {
        showCreateFeudParticipantsData(talentData)
    }
    showCreateFeudItemsData(itemsData);
}

function showCreateFeudParticipantsData(data) {
    playSoundEffect('success');

    // Populate participant select
    let $firstParticipantSelect = $('#create-feud .create-feud-first-participant-select');
    let $secondParticipantSelect = $('#create-feud .create-feud-second-participant-select');
    $firstParticipantSelect.html('');
    $secondParticipantSelect.html('');

    let optionsHtml = '';
    optionsHtml += '<option selected disabled>Select Participant</option>';
    data.forEach(function (participant) {
        optionsHtml += '<option value="' + participant['name'].replace(/"/g, "&quot;") +
            '" data-uid="' + participant['uid'] + '">' + participant['name'] + '</option>'
    });

    $firstParticipantSelect.html(optionsHtml);
    $secondParticipantSelect.html(optionsHtml);

    $("#create-feud").fadeIn('slow');
}

function showCreateFeudItemsData(data) {
    const $createFeudItemsContainer = $('.create-feud-items-container');
    if (!data['error']) {
        playSoundEffect('success');
        $createFeudItemsContainer.html('');

        data['availableFeudItems'].forEach(function (item) {
            let feudItemHtml = getAvailableFeudItemHtml(item, data['randomFeudName']);
            $createFeudItemsContainer.append(feudItemHtml);
        });

        // Adjust custom feud name input's width
        $('#create-feud .feud-item-custom-name').trigger('input');

        // Unavailable feud items
        data['unavailableFeudItems'].forEach(function (item) {
            let feudItemHtml = getUnavailableFeudItemHtml(item);
            $createFeudItemsContainer.append(feudItemHtml);
        });

        // Show randomize feud hint
        if (!randomizeFeudHintShown) {
            randomizeFeudHintShown = true;
            notie.alert({
                type: 4,
                text: '<span class="display-block">Click the <i class="fa fa-refresh grey"></i> button to randomize the Feud name or add your own</span>'
            });
        }

        $createFeudItemsContainer.scrollTop(0);
        $createFeudItemsContainer.show();

        disableTutorialPointerEvents(globals.currentTutorialStep);

        // Tutorial action check
        checkTutorialStepAction('click_create_feud_menu_button');
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'participant-not-found') {
            notie.alert({type: 3, text: 'The selected participants could not be found', stay: true});
        }
    }
}

function getFeudItemUnlockedBy(feudItemName) {
    let unlockedByName;
    switch (feudItemName) {
        case 'That\'s My Title':
            unlockedByName = 'New Challenger';
            break;
        case 'Innovation':
            unlockedByName = 'Who\'s the Best?';
            break;
        case 'It\'s My Time Now':
            unlockedByName = 'Taking My Spot';
            break;
        case 'Us vs Them':
            unlockedByName = 'This Is Our Home';
            break;
        case 'Greatest Wrestler':
            unlockedByName = 'Better Wrestler';
            break;
        case 'Streak vs Career':
            unlockedByName = 'Retire Me';
            break;
        case 'Legend Killer':
            unlockedByName = 'Stepping Up';
            break;
        case 'Redemption':
            unlockedByName = 'Friendly Contest';
            break;
        case 'Corruption':
            unlockedByName = 'Better Villain';
            break;
        case 'Best in the World':
            unlockedByName = 'Main Event Ready';
            break;
        case 'Bitter Rivals':
            unlockedByName = 'Rivals';
            break;
    }
    return unlockedByName;
}

async function getCreateFeudRequest(feudItemUid, customFeudName, participantUids, participantType) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await createFeud(feudItemUid, customFeudName, participantUids, participantType);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showCreateFeudData(data);
}

function showCreateFeudData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Show feud name and participants
        let participants = data['feudParticipantNames'].join(' and ');
        let notieText =
            '<span class="display-block">' +
                '<span class="faded-red-light">' +
                data['feudName'] + ' <span class="potential-feud-red">Potential</span>' + '</span>' + ' Feud created between ' + participants +
                '</span>' +
            '</span>';

        // Show consequence applied to
        if (data['consequenceAppliedTo']) {
            let consequenceHtml = '<span class="faded-red-light">{0}</span>'.format(toTitleCase(data['consequence'].replace(/-/g, ' ')));
            notieText += '<span class="display-block">{0} Consequence applied to {1}</span>'.format(consequenceHtml, data['consequenceAppliedTo'])
        }

        notie.alert({type: 4, text: notieText, stay: true});

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Unselect selected feud item
        $('#create-feud .feud-item-container.selected').trigger('click');

        // Reset inputs
        $("#create-feud .create-feud-first-participant-select").prop('selectedIndex', 0);
        $("#create-feud .create-feud-second-participant-select").prop('selectedIndex', 0);

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Tutorial action check
        checkTutorialStepAction('create_feud');
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'feud-item-not-found') {
            notie.alert({type: 3, text: 'The selected Feud could not be found', stay: true});
        }
        else if (data['error'] === 'participant-not-found') {
            notie.alert({type: 3, text: 'The selected participants could not be found', stay: true});
        }
        else if (data['error'] === 'duplicate-participants') {
            notie.alert({type: 3, text: 'Participants cannot feud with themselves', stay: true});
        }
        else if (data['error'] === 'existing-feud-present') {
            notie.alert({type: 3, text: 'A Feud is already present between these participants', stay: true});
        }
        else if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: 'You do not have enough Creative Points to create a Feud', stay: true});
        }
    }
}

async function loadViewStatsPage(companyUid, brandName) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewStatsData(companyUid, brandName);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.select-company-for-view-stats'));
    }

    // Show data
    hideContent($());
    showViewStatsPageData(data);
}

function showViewStatsPageData(data) {
    const $companyStatsDataContainer = $('#company-stats-data-container');

    // Select company
    $(".select-company-for-view-stats").val(data['companyName'].trim().replace(/\s+/g, " "));

    // Add brand filters
    $('.company-stats-brand-filters').html('');
    if (data['brandNames'].length > 0) {
        data['brandNames'].forEach(function (rosterBrandName) {
            let selectedClass = '';
            if (rosterBrandName === data['brandName']) {
                selectedClass = ' selected';
            }
            let rosterBrandFilterHtml = '<button type="button" class="company-stats-brand-filter ' +
                'button retro-button condensed light-button-background' + selectedClass + '">' + rosterBrandName + '</button> ';
            $('.company-stats-brand-filters').append(rosterBrandFilterHtml);
        });
    }

    // Company name
    let div = '';
    let companyName = '<div class="display-block dark-grey font-1p25em">' + data['companyName'] + '</div>';
    let inactive = '';
    if (data['inactive']) {
        inactive = '<div class="display-block grey margin-top-5">Inactive</div>';
    }
    div += '<div class="display-block margin-bottom-15 margin-top-2">' + companyName + inactive + '</div>';

    // Iconic superstars
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Iconic Wrestlers</span>';
    data['iconicSuperstars'].forEach(function (superstar) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + superstar + '</span>';
    });
    if (data['iconicSuperstars'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Most over
    let mostOver = data['mostOverSuperstar'];
    if (!mostOver) {
        mostOver = 'None'
    }
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Most Over</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + mostOver + '</span>';
    div += '</div>';

    // Top heel/face
    let topHeel = data['topHeelSuperstar'];
    if (!topHeel) {
        topHeel = 'None'
    }
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Top Heel</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + topHeel + '</span>';
    div += '</div>';
    let topFace = data['topFaceSuperstar'];
    if (!topFace) {
        topFace = 'None'
    }
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Top Face</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + topFace + '</span>';
    div += '</div>';

    // Iconic teams
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Iconic Teams</span>';
    data['iconicTagTeams'].forEach(function (team) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + team + '</span>';
    });
    if (data['iconicTagTeams'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Iconic factions
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Iconic Factions</span>';
    data['iconicFactions'].forEach(function (faction) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + faction + '</span>';
    });
    if (data['iconicFactions'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Top championship
    let topChampionshipData = data['topChampionship'];
    let topChampionshipHtml = 'None';
    if (topChampionshipData) {
        topChampionshipHtml = topChampionshipData['name'] +
            ' <span class="display-inline-block font-17px">' +
            getChampionshipPrestigeIconHtml(topChampionshipData['prestige']) +
            '</span>'
    }
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Top Championship</span>';
    div += '<span class="display-block dark-grey margin-bottom-2">' + topChampionshipHtml + '</span>';
    div += '</div>';

    // Iconic events
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Best Events</span>';
    data['iconicEvents'].forEach(function (event) {
        let rating = setRating(event['rating']);
        div += '<span class="display-block dark-grey margin-bottom-2">' + event['name'] +
            ' ' + event['year'] +
            '<span class="margin-left-10 display-inline-block">' + rating + '</span>' +
            '</span>';
    });
    if (data['iconicEvents'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Signature event
    if (data['signatureEvent']) {
        let prestigeIcon;
        switch (data['signatureEvent']['prestige']) {
            case 'C':
                prestigeIcon = '<i class="fa fa-star-o font-bold bronze"></i>';
                break;
            case 'B':
                prestigeIcon = '<i class="fa fa-star-o font-bold silver"></i>';
                break;
            case 'A':
                prestigeIcon = '<i class="fa fa-star-o font-bold gold-light"></i>';
                break;
        }
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Signature Event</span>';
        div += '<span class="display-block dark-grey margin-bottom-2">' + data['signatureEvent']['name'] +
            ' <span class="display-inline-block font-17px">' + prestigeIcon + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Most bought event
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Most Buys</span>';
    if (data['mostBoughtEvent']) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + data['mostBoughtEvent']['name'] +
            ' ' + data['mostBoughtEvent']['year'] +
            '<span class="light-grey margin-left-5">' + getViewershipText(data['mostBoughtEvent']['buys']) + '</span>' +
            '</span>';
    }
    else {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Highest viewership event
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Highest Viewership</span>';
    if (data['highestViewershipEvent']) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + data['highestViewershipEvent']['name'] +
            '<span class="light-grey margin-left-5">' + getViewershipText(data['highestViewershipEvent']['viewership']) +
            ' (' + data['highestViewershipEvent']['date'] + ')</span>' +
            '</span>';
    }
    else {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Iconic matches
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Best Matches</span>';
    data['iconicMatches'].forEach(function (match) {
        let rating = setRating(match['rating']);
        let losers = match['losers'];
        let losersText;
        // Join losers with comma and 'and'
        if (losers.length > 1) {
            losersText = losers.slice(0, -1).join(', ') + ' and ' + losers.slice(-1);
        }
        else {
            losersText = losers[0];
        }
        let gimmickHtml = '';
        if (match['gimmick']) {
            gimmickHtml = '<span class="grey margin-left-8">{0} Match</span>'.format(match['gimmick']);
        }
        let text = '{0} <span class="light-grey">def.</span> {1}{2}<span class="light-grey margin-left-8">{3}</span>'.format(match['winner']['name'],
            losersText, gimmickHtml, match['event']);
        div += '<span class="display-block dark-grey margin-bottom-8">' + text +
            '<span class="margin-left-10 display-inline-block">' + rating + '</span>' +
            '</span>';
    });
    if (data['iconicMatches'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Iconic segments
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Best Segments</span>';
    data['iconicSegments'].forEach(function (segment) {
        let rating = setRating(segment['rating']);
        let text = '{0}<span class="light-grey margin-left-8">{1}</span>'.format(getSegmentText(segment), segment['event']);
        div += '<span class="display-block dark-grey margin-bottom-8">' + text +
            '<span class="margin-left-10 display-inline-block">' + rating + '</span>' +
            '</span>';
    });
    if (data['iconicSegments'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Special segments
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Special Segments</span>';
    data['specialSegments'].forEach(function (segment) {
        let rating = setRating(segment['rating']);
        let text = '{0}<span class="light-grey margin-left-8">{1}</span>'.format(getSegmentText(segment), segment['event']);
        div += '<span class="display-block dark-grey margin-bottom-8">' + text +
            '<span class="margin-left-10 display-inline-block">' + rating + '</span>' +
            '</span>';
    });
    if (data['specialSegments'].length < 1) {
        div += '<span class="display-block dark-grey">None</span>';
    }
    div += '</div>';

    // Iconic feuds
    if (data['iconicFeuds']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Feuds</span>';
        data['iconicFeuds'].forEach(function (feud) {
            let participantNames = feud['participants'].join(' and ');
            let feudName = feud['name'];
            let rating =
                '<span class="display-inline-block margin-left-8">' + getStarRatingHtml(feud['rating']) + '</span>';
            let text =
                '<span class="faded-red-light">' + feudName + '</span>' +
                ' between ' + participantNames + rating;
            div += '<span class="display-block dark-grey margin-bottom-8">' + text +
                '</span>';
        });
        if (data['iconicFeuds'].length < 1) {
            div += '<span class="display-block dark-grey">None</span>';
        }
        div += '</div>';
    }

    // Top moments
    if (data['topMoments']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Moments</span>';
        data['topMoments'].forEach(function (moment) {
            div += '<span class="display-block dark-grey margin-bottom-8">' + moment['name'] +
                ' <span class="light-grey">' + moment['event'] + '</span>' + '</span>';
        });
        if (data['topMoments'].length < 1) {
            div += '<span class="display-block dark-grey">None</span>';
        }
        div += '</div>';
    }

    // Shocking turns
    if (data['shockingTurns']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Shocking Turns</span>';
        data['shockingTurns'].forEach(function (turn) {
            div += '<span class="display-block dark-grey margin-bottom-8">' + turn['name'] +
                ' <span class="light-grey">' + turn['event'] + '</span>' + '</span>';
        });
        if (data['shockingTurns'].length < 1) {
            div += '<span class="display-block dark-grey">None</span>';
        }
        div += '</div>';
    }

    // Awards won
    if (data['awardsWon']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Awards Won</span>';
        data['awardsWon'].forEach(function (award) {
            let trophy = '';
            switch (award['value']) {
                case 0:
                    trophy = 'trophy_icon_trash';
                    break;
                case 1:
                    trophy = 'trophy_icon_bronze';
                    break;
                case 2:
                    trophy = 'trophy_icon_silver';
                    break;
                case 3:
                    trophy = 'trophy_icon_gold';
                    break;
            }
            div += '<span class="display-block dark-grey margin-bottom-8">' +
                '<img alt="Trophy" src="static/www/static/' + trophy + '.png" class="trophy-image margin-right-8"/>' +
                award['name'] + '</span>';
        });
        if (data['awardsWon'].length < 1) {
            div += '<span class="display-block dark-grey">No Awards Won</span>';
        }
        div += '</div>';
    }

    // Legends
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Legends</span>';
    data['legends'].forEach(function (legend) {
        div += '<span class="display-block dark-grey margin-bottom-2">' + legend + '</span>';
    });
    if (data['legends'].length < 1) {
        div += '<span class="display-block dark-grey">No Legends</span>';
    }
    div += '</div>';

    // FotC losses
    if (data['fotcLosses']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Only Wrestlers to Beat ' +
            data['fotcLosses']['name'] + '</span>';
        data['fotcLosses']['losses'].forEach(function (loss) {
            div += '<span class="display-block dark-grey margin-bottom-2">' + loss +
                '</span>';
        });
        div += '</div>';
    }

    // Top signings
    if (data['topSignings']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Signings</span>';
        data['topSignings'].forEach(function (signing) {
            div += '<span class="display-block dark-grey margin-bottom-2">' + signing['name'] +
                '<span class="blue">' +
                '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-left-10 margin-right-5"/>' + signing['value'] +
                '</span>' +
                '</span>';
        });
        if (data['topSignings'].length < 1) {
            div += '<span class="display-block dark-grey">No Signings</span>';
        }
        div += '</div>';
    }

    // Most world titles held
    if (data['mostWorldChampionshipsHeld']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most World Titles</span>';
        div += '<span class="display-block dark-grey">' + data['mostWorldChampionshipsHeld']['name'] +
            '<span class="margin-left-5 light-grey">' + data['mostWorldChampionshipsHeld']['number'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Most titles held
    if (data['mostChampionshipsHeld']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Titles</span>';
        div += '<span class="display-block dark-grey">' + data['mostChampionshipsHeld']['name'] +
            '<span class="margin-left-5 light-grey">' + data['mostChampionshipsHeld']['number'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Longest title reign
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Longest Title Reign</span>';
    if (data['longestReign']) {
        let monthsText = 'Months';
        if (data['longestReign']['length'] === 1) {
            monthsText = 'Month'
        }
        div += '<span class="display-block dark-grey">' + data['longestReign']['championName'] +
            '<span class="margin-left-5 gold">' + data['longestReign']['championshipName'] + '</span>' +
            '<span class="margin-left-5 light-grey">' + data['longestReign']['length'] + ' ' + monthsText + '</span>' +
            '</span>';
    }
    else {
        div += '<div class="display-block dark-grey">N/A</div>';
    }
    div += '</div>';

    // Shortest title reign
    div += '<div class="margin-bottom-20">';
    div += '<span class="display-block blue margin-bottom-2">Shortest Title Reign</span>';
    if (data['shortestReign']) {
        let monthsText = 'Months';
        if (data['shortestReign']['length'] === 1) {
            monthsText = 'Month'
        }
        div += '<span class="display-block dark-grey">' + data['shortestReign']['championName'] +
            '<span class="margin-left-5 gold">' + data['shortestReign']['championshipName'] + '</span>' +
            '<span class="margin-left-5 light-grey">' + data['shortestReign']['length'] + ' ' + monthsText + '</span>' +
            '</span>';
    }
    else {
        div += '<div class="display-block dark-grey">N/A</div>';
    }
    div += '</div>';

    // Greatest non world champion
    if (data['greatestNonWorldChampion']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Greatest to Not Win the Big One</span>';
        div += '<span class="display-block dark-grey">' + data['greatestNonWorldChampion']['name'] +
            '</span>';
        div += '</div>';
    }

    // Most main events
    if (data['mostMainEvents']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Main Events</span>';
        div += '<span class="display-block dark-grey">' + data['mostMainEvents']['name'] +
            '<span class="margin-left-5 light-grey">' + data['mostMainEvents']['number'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Most opening matches
    if (data['mostOpeningMatches']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Opening Matches</span>';
        div += '<span class="display-block dark-grey">' + data['mostOpeningMatches']['name'] +
            '<span class="margin-left-5 light-grey">' + data['mostOpeningMatches']['number'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Top worker
    if (data['topWorker']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Worker</span>';
        div += '<span class="display-block dark-grey">' + data['topWorker']['name'] +
            '<span class="margin-left-5 light-grey">Average Rating: ' + data['topWorker']['rating'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Most 5 star matches
    if (data['mostFiveStarMatches']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Five Star Matches</span>';
        div += '<span class="display-block dark-grey">' + data['mostFiveStarMatches']['name'] +
            '<span class="margin-left-5 light-grey">' + data['mostFiveStarMatches']['number'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Top win percentage
    if (data['topWinPercentage']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Top Win Percentage</span>';
        div += '<span class="display-block dark-grey">' + data['topWinPercentage']['name'] +
            '<span class="margin-left-5 light-grey">' + data['topWinPercentage']['winPercentage'] + '%</span>' +
            '</span>';
        div += '</div>';
    }

    // Biggest streak
    if (data['biggestStreak']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Biggest Streak</span>';
        div += '<span class="display-block dark-grey">' + data['biggestStreak']['holder'] +
            '<span class="margin-left-5 light-grey margin-right-5">' + data['biggestStreak']['length'] + '-0</span>at ' +
            '<span>' + data['biggestStreak']['event'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Longest win streak
    if (data['longestWinningStreak']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Longest Winning Streak</span>';
        div += '<span class="display-block dark-grey">' + data['longestWinningStreak']['name'] +
            '<span class="margin-left-5 light-grey">' + data['longestWinningStreak']['length'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Longest losing streak
    if (data['longestLosingStreak']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Longest Losing Streak</span>';
        div += '<span class="display-block dark-grey">' + data['longestLosingStreak']['name'] +
            '<span class="margin-left-5 light-grey">' + data['longestLosingStreak']['length'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Greatest to not turn
    if (data['greatestToNotTurn']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Greatest to Never Turn</span>';
        div += '<span class="display-block dark-grey">' + data['greatestToNotTurn']['name'] +
            '</span>';
        div += '</div>';
    }

    // Most simultaneous feuds
    if (data['mostSimultaneousFeuds']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Most Feuds at One Time</span>';
        div += '<span class="display-block dark-grey">' + data['mostSimultaneousFeuds']['name'] +
            '<span class="margin-left-5 light-grey">' + data['mostSimultaneousFeuds']['numberOfFeuds'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Best gimmick
    if (data['bestGimmick']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Best Gimmick</span>';
        div += '<span class="display-block dark-grey">' + data['bestGimmick']['name'] +
            '<span class="margin-left-5 light-grey">' + data['bestGimmick']['superstarName'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Worst gimmick
    if (data['worstGimmick']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Worst Gimmick</span>';
        div += '<span class="display-block dark-grey">' + data['worstGimmick']['name'] +
            '<span class="margin-left-5 light-grey">' + data['worstGimmick']['superstarName'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Longest gimmick
    if (data['longestGimmick']) {
        div += '<div class="margin-bottom-20">';
        div += '<span class="display-block blue margin-bottom-2">Longest Gimmick</span>';
        div += '<span class="display-block dark-grey">' + data['longestGimmick']['name'] +
            '<span class="margin-left-5 light-grey">' + data['longestGimmick']['superstarName'] + '</span>' +
            '</span>';
        div += '</div>';
    }

    // Add html, show container
    $companyStatsDataContainer.html(div);
    $('#company-stats-container').fadeIn('slow');
    $companyStatsDataContainer.scrollTop(0);
}

async function loadViewTournamentsPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewTournamentsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewTournamentsPageData(data);
}

function showViewTournamentsPageData(data) {
    const $tournamentHistoryContainer = $("#tournament-history-container");

    if (data['tournaments'].length > 0) {
        let tournament = data['tournaments'][0];
        const $selectTournamentForViewTournaments = $('.select-tournament-for-view-tournaments');

        // Add tournament select data
        $selectTournamentForViewTournaments.find('option').remove().end();
        data['tournaments'].forEach(function (tournament) {
            $(".select-tournament-for-view-tournaments").append(
                '<option data-uid="' + tournament['uid'] + '">' +
                tournament['name'] +
                '</option>'
            );
        });
        $('#tournament-container .tournament-history').show();
        $selectTournamentForViewTournaments.val(tournament['name']);

        showTournamentData(tournament);
    }
    else {
        $('#tournament-container .tournament-details').html(
            '<span class="font-bold display-block grey">' +
            'No Tournaments held yet' +
            '</span>'
        );
        $('#tournament-container .tournament-history').html('').hide();
        $tournamentHistoryContainer.fadeIn('slow').removeClass('display-none');
        $(".select-tournament-for-view-tournaments").find('option').remove().end();
    }

    // Select tournament
    $tournamentHistoryContainer.off('change', '.select-tournament-for-view-tournaments');
    $tournamentHistoryContainer.on('change', '.select-tournament-for-view-tournaments', function () {
        let uid = parseInt($(this).find(':selected').attr('data-uid'));
        let tournament = data['tournaments'].filter(function (tournament) {
            return tournament['uid'] === uid;
        })[0];
        showTournamentData(tournament);
    });
}

function showTournamentData(tournament) {

    const $tournamentContainer = $('#tournament-container');

    // Reset
    $tournamentContainer.find('.tournament-history').html('');
    $tournamentContainer.find('.tournament-details').html('');

    // Get prestige
    let prestigeIcon;
    switch (tournament['prestige']) {
        case 'C':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6' +
                ' bronze"></i>';
            break;
        case 'B':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6' +
                ' silver"></i>';
            break;
        case 'A':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-6' +
                ' gold-light"></i>';
            break;
    }

    // Get progress to next level
    let progressHtml = '';
    if (tournament['prestige']) {
        let progress;
        let levelXp = tournament['xpToNextPrestige'];
        if (tournament['prestige'] !== 'A') {
            progress = ((tournament['xp'] - tournament['baseXp']) / (levelXp - tournament['baseXp'])) * 100;
        }
        else {
            progress = 100;
        }

        progressHtml =
            '<div class="event-prestige-progress history display-inline-block">' +
            '<div class="progress-under help-text" title="' + tournament['xp'] + ' / ' + levelXp + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>' +
            '</div>';
    }

    // Show tournament details
    $('#tournament-container .tournament-details').append(
        '<span class="font-bold display-block font-1p25em line-height-1p25em margin-bottom-5">' +
        tournament['name'] +
        '</span>' +
        '<span class="display-block medium-grey font-bold">' +
        '<span class="display-block margin-top-8 margin-bottom-15">' +
        progressHtml + prestigeIcon +
        '</span>' +
        '</span>'
    );

    // Show tournament history for each time it was held
    tournament['history'].forEach(function (history, i) {
        let tournamentHistoryHtml = getTournamentHistoryHtml(history, i);
        $('.tournament-history').append(tournamentHistoryHtml);
    });

    // Navigate bracket rounds
    $tournamentContainer.off('click', '.tournament-bracket-next, .tournament-bracket-prev');
    $tournamentContainer.on('click', '.tournament-bracket-next, .tournament-bracket-prev', function () {
        let bracketContainer = $(this).closest('.tournament-bracket-container');
        let round = bracketContainer.attr('data-round');
        let rounds = bracketContainer.attr('data-rounds');
        let index = bracketContainer.attr('data-index');

        // Go to next/prev round
        if ($(this).hasClass('tournament-bracket-next')) {
            round++
        }
        else {
            round--
        }
        let bracket = tournament['history'][index]['bracket'][round];
        if (!bracket) {
            return false;
        }
        bracketContainer.attr('data-round', round);

        // Show new bracket
        let bracketHtml = getTournamentBracketHtml(bracket, round, rounds);
        $('.tournament-history .tournament-bracket-container').eq(index).html(bracketHtml).hide().fadeIn('fast');
    });

    $tournamentContainer.scrollTop(0);
    $("#tournament-history-container").hide().fadeIn('slow').removeClass('display-none');
}

function getTournamentHistoryHtml(data, index) {
    let historyHtml = '';

    // History Container
    historyHtml += '<div class="margin-top-30">';

    // Add event name, year, award
    let awardHtml = '';
    if (data['awardName']) {
        awardHtml = '<span class="gold display-block text-center">' + data['awardName'] + '</span>'
    }
    historyHtml +=
        '<span class="display-block font-bold year text-center margin-bottom-5">' +
        data['event'] + ' ' + data['eventYear'] +
        awardHtml +
        '</span>' +
        '<div class="margin-bottom-10">';

    // Check for winner
    if (data['winnerName']) {
        historyHtml += '<span class="display-block light-grey text-center font-bold">Winner</span>' +
            '<span class="cyan display-block text-center">' + data['winnerName'] + '</span>';
    }

    historyHtml += '</div>';

    // Add bracket
    if (data['bracket']) {
        let tournamentRound = data['startRound'] + 1;  // Start with knockout round, or 1 by default
        let tournamentRounds = Object.keys(data['bracket']).length;
        let bracketHtml = getTournamentBracketHtml(data['bracket'][tournamentRound], tournamentRound,
            tournamentRounds, false, data['startRound']);
        historyHtml += '<div class="tournament-bracket-container history font-bold margin-top-10" ' +
            'data-index="' + index + '" data-round="' + tournamentRound + '" data-rounds="' + tournamentRounds + '">' +
            bracketHtml +
            '</div>';
    }
    // Add table
    if (data['table']) {
        let tableHtml = getTournamentGroupTableHtml(data['table'], data['participantsAdvancing'], true);
        historyHtml += '<div class="font-bold margin-bottom-20 margin-top-20">' +
            tableHtml +
            '</div>';
    }

    historyHtml += '</div>';
    return historyHtml;
}

async function loadViewGimmickMatchesPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewGimmickMatchesData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewGimmickMatchesPageData(data);
}

function showViewGimmickMatchesPageData(data) {
    const $viewGimmickMatchesItemsContainer = $(".view-gimmick-matches-items-container");

    // Reset
    $viewGimmickMatchesItemsContainer.html('');

    // Add gimmick matches
    data['gimmickMatches'].forEach(function (gimmickMatch) {
        let gimmickMatchHtml = getViewGimmickMatchesPageGimmickMatchHtml(gimmickMatch);
        $viewGimmickMatchesItemsContainer.append(gimmickMatchHtml);
    });

    if (data['gimmickMatches'].length === 0) {
        let div =
            '<div class="view-gimmick-matches-item">' +
                '<div>' +
                    '<span class="grey">No Gimmick Matches present</span>' +
                '</div>' +
            '</div>';

        $('.view-gimmick-matches-items-container').append(div);
    }

    $("#view-gimmick-matches-container").fadeIn('slow');
    $viewGimmickMatchesItemsContainer.scrollTop(0);

    // Tutorial action check
    checkTutorialStepAction('click_view_gimmick_matches_menu_button');
}

function getViewGimmickMatchesPageGimmickMatchHtml(gimmickMatch) {
    let div;

    // Set level
    let level;
    switch (gimmickMatch['level']) {
        case 1:
            level = '<i class="fa fa-star-o gimmick-match-level-icon bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o gimmick-match-level-icon silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o gimmick-match-level-icon gold-light"></i>';
            break;
    }

    // Set boosts
    let rating, pop, injury;
    rating = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch['ratingBoost']);
    if (gimmickMatch['ratingBoost'] < 3) {
        rating += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch['ratingBoost'])
    }
    pop = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch['popularityBoost']);
    if (gimmickMatch['popularityBoost'] < 3) {
        pop += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch['popularityBoost'])
    }
    injury = '<i class="fa fa-star dark-grey"></i>'.repeat(gimmickMatch['injuryRate']);
    if (gimmickMatch['injuryRate'] < 3) {
        injury += '<i class="fa fa-star light-grey"></i>'.repeat(3 - gimmickMatch['injuryRate'])
    }

    let fatigueHtml = '';
    if (globals.game.settings['enable_fatigue'] !== false) {
        let fatigueText = '<span class="gimmick-match-fatigue-value"><span class="margin-right-2">+</span>' + gimmickMatch['fatigueChange'] + '<span class="margin-left-2">%</span></span>';
        fatigueHtml = '<div class="medium-grey">' +
            '<span class="gimmick-match-label">Fatigue</span> ' + fatigueText +
            '</div>';
    }

    // Info
    let specialMatchHtml = '';
    if (gimmickMatch['cashinContractName']) {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 gold">' + 'Cash-in Contract' + '</span>'
    }
    else if (gimmickMatch['matchContractName']) {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 gold">' + 'Fixed Match Contract' + '</span>'
    }
    else if (gimmickMatch['consequence'] === 'loser_unavailable') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Loser Unavailable' + '</span>'
    }
    else if (gimmickMatch['consequence'] === 'remove_hair') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Remove Hair' + '</span>'
    }
    else if (gimmickMatch['consequence'] === 'add_hair') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Add Hair' + '</span>'
    }
    else if (gimmickMatch['consequence'] === 'random_opponent') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Random Opponent' + '</span>';
    }
    else if (gimmickMatch['consequence'] === 'remove_mask') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Remove Mask' + '</span>'
    }
    else if (gimmickMatch['consequence'] === 'remove_mask_or_hair') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Remove Mask or Hair' + '</span>'
    }
    else if (gimmickMatch['rules'] === '2/3_falls') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Best of Three Falls' + '</span>'
    }
    else if (gimmickMatch['rules'] === 'special_referee') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Guest Referee' + '</span>'
    }
    else if (gimmickMatch['rules'] === 'elimination') {
        specialMatchHtml = '<span class="display-block margin-top-7 margin-bottom--2 light-grey">' + 'Superstar Elimination' + '</span>'
    }

    // Add description if present
    let descriptionHtml = '';
    if (gimmickMatch['description']) {
        descriptionHtml = '<div class="medium-light-grey">' + escapeHTML(gimmickMatch['description']) + '</div>';
    }

    // Get progress to next level
    let progress;
    let levelXp;
    if (gimmickMatch['level'] < 3) {
        levelXp = Math.pow(gimmickMatch['level'], 2) * 50;
        progress = (gimmickMatch['xp'] / levelXp) * 100;
    }
    else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml =
        '<div class="margin-bottom-2 margin-top-12 item-progress-container display-inline-block">' +
            '<div class="progress-under help-text" title="' + gimmickMatch['xp'] + ' / ' + levelXp + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>' +
        '</div>';

    div =
        '<div class="view-gimmick-matches-item">' +
            '<div class="margin-bottom-8">' +
                '<span class="">' + gimmickMatch['name'] + '</span>' +
                '<span class="blue float-right top--2px">' +
                '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-2"/> ' + gimmickMatch['cost'] +
                '</span>' +
            '</div>' +
            descriptionHtml +
            '<div class="margin-top-7">' +
                '<div class="medium-grey">' +
                '<span class="gimmick-match-label">Rating</span> ' + rating +
                '</div>' +
                '<div class="medium-grey">' +
                '<span class="gimmick-match-label">Pop.</span> ' + pop +
                '</div>' +
                '<div class="medium-grey">' +
                '<span class="gimmick-match-label">Injury</span> ' + injury +
                '</div>' +
                fatigueHtml +
            '</div>' +
            '<div>' +
                specialMatchHtml +
                progressHtml + level +
            '</div>' +
        '</div>';
    return div;
}

async function loadRemoveGimmickMatchesPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getRemoveGimmickMatchesData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRemoveGimmickMatchesPageData(data);
}

function showRemoveGimmickMatchesPageData(data) {
    let $select = $('#remove-gimmick-match .select-gimmick-match');
    $select.html('');
    $.each(data, function () {
        $select.append($("<option />").val(this).text(this));
    });
    $("#remove-gimmick-match").fadeIn('slow').removeClass('display-none');
}

async function getRemoveGimmickMatchRequest(name) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await removeGimmickMatch(name);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRemoveGimmickMatchData(data);
}

function showRemoveGimmickMatchData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let html = '<span class="display-block">' +
            data['name'] + " Match removed" +
            '</span>';
        notie.alert({type: 4, text: html});

        // Select next gimmick match
        let selected = $("#remove-gimmick-match .select-gimmick-match").find(":selected");
        selected.next().prop('selected', true);

        // Remove gimmick match
        selected.remove();
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "The Gimmick Match could not be found. Please try again."});
        }
    }
}

async function getAddGimmickMatchRequest() {

    if (globals.requestRunning) {
        return;
    }

    // Validate
    let name = $('#add-gimmick-match input[name="match-name"]').val();
    let cashinContractName = $('#add-gimmick-match input[name="cashin-contract-name"]').val();
    let cashinContractExpiry = $('#add-gimmick-match input[name="cashin-contract-expiry"]').val();
    let matchContractName = $('#add-gimmick-match input[name="match-contract-name"]').val();
    let consequence = $('#add-gimmick-match select[name="match-consequence"]').val();
    let rules = $('#add-gimmick-match select[name="match-rules"]').val();
    let ratingBoost = $('#add-gimmick-match select[name="match-rating-boost"]').val();
    let popularityBoost = $('#add-gimmick-match select[name="match-popularity-boost"]').val();
    let injuryRate = $('#add-gimmick-match select[name="match-injury-rate"]').val();
    let graphicType = $('#add-gimmick-match select[name="match-graphic"]').val();
    let addRandomWeapons = $('#add-gimmick-match select[name="match-add-random-weapons"]').val();
    if (name.length <= 0) {
        notie.alert({type: 3, text: "Enter a name for the Gimmick Match"});
        return false;
    }
    if (consequence === 'cashin_contract') {
        if (cashinContractName.length <= 0) {
            notie.alert({type: 3, text: "Enter a name for the Cash-in Contract"});
            return false;
        }
        if (cashinContractExpiry.length <= 0 || !parseInt(cashinContractExpiry)) {
            notie.alert({type: 3, text: "Enter a number greater than 0 for Months to Expire for the Cash-in Contract"});
            return false;
        }
    }
    if (consequence === 'match_contract') {
        if (matchContractName.length <= 0) {
            notie.alert({type: 3, text: "Enter a name for the Match Contract"});
            return false;
        }
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addGimmickMatch(name, rules, ratingBoost, popularityBoost, injuryRate,
        consequence, cashinContractName, cashinContractExpiry, matchContractName,
        graphicType, addRandomWeapons);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddGimmickMatchData(data);
}

function showAddGimmickMatchData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let html = '<span class="display-block">' +
            data['name'] + " Match added!" +
            '</span>';
        notie.alert({type: 4, text: html});
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Tutorial action check
        checkTutorialStepAction('add_gimmick_match');

        // Go back to view gimmick matches
        setTimeout(function () {
            $('#view-gimmick-matches-menu-button').trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        let notieText = '';
        if (data['error'] === 'already-exists') {
            notieText = 'You already have a Gimmick Match with that name'
        }
        else if (data['error'] === 'not-enough-points') {
            notieText = 'You do not have enough Creative Points to add a Gimmick Match'
        }
        else if (data['error'] === 'match-contract-exists') {
            notieText = 'You already have a Match Contract with that name'
        }
        else if (data['error'] === 'cashin-contract-exists') {
            notieText = 'You already have a Cash-in Contract with that name'
        }
        else if (data['error'] === 'pow-femme-fatale') {
            notieText = "\"That's my idea!\" - Hank Hughes"
        }
        else if (data['error'] === 'pow-cashin') {
            notieText = "\"I don't want anyone winning the championship like that. You'll have to do it the old fashioned way.\" - Hank Hughes"
        }
        notie.alert({type: 3, text: notieText});
    }
}

async function loadViewTitlesPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewTitlesData(companyUid);
    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.select-company-for-view-titles'));
    }

    // Show data
    hideContent($());
    showViewTitlesPageData(data);
}

function showViewTitlesPageData(data) {
    const $titleStatsContainer = $('#title-stats-container');
    const $titlesBox = $('#titles-box');
    const $companyChampionshipSelect = $(".company-championship-select");

    $titleStatsContainer.html('');
    $(".select-company-for-view-titles").val(data['companyName'].trim().replace(/\s+/g, " "));

    let inactive = data['inactive'];
    let championships = data['championships'];

    // Get championship
    let index = 0;
    let championship = championships[index];

    if (championships.length > 0) {
        // Add select data
        $companyChampionshipSelect.find('option').remove().end();
        championships.forEach(function (championship) {
            let name = championship['name'];
            if (championship.retired) {
                name += ' (r)'
            }
            $(".company-championship-select").append(
                '<option>' + name + '</option>'
            );
        });

        // Select first title. Remove double spaces.
        $companyChampionshipSelect.val(championship['name'].trim().replace(/\s+/g, " "));

        // Show stats for first title
        showTitleStatsPageData(championship, inactive);
    }
    else {
        // None text
        $titleStatsContainer.html('<span class="grey">No Titles present</span>');
    }

    $titlesBox.fadeIn('slow');
    $titleStatsContainer.scrollTop(0);

    // Select championship, show stats
    $titlesBox.off('change', '.company-championship-select');
    $titlesBox.on('change', '.company-championship-select', function () {
        index = $companyChampionshipSelect.prop("selectedIndex");
        championship = championships[index];
        showTitleStatsPageData(championship, inactive);
        $titleStatsContainer.scrollTop(0);
    });
}

function showTitleStatsPageData(data, inactive) {
    const $titleStatsContainer = $('#title-stats-container');
    $titleStatsContainer.html('');

    let div = '';

    div += '<div id="championship-stats-graphic" class="margin-bottom-20"></div>';

    // Name, inactive text
    let championshipName = '<div class="display-block gold font-1p125em">' +
        data['name'] + '</div>';
    let inactiveHtml = '';
    if (inactive) {
        inactiveHtml = '<div class="display-block grey">Inactive</div>';
    }
    let retiredText = '';
    if (data['retired']) {
        retiredText = '<div class="display-block">Retired</div>';
    }

    // Brand
    let brandNameHtml = '';
    if (data['brandName'] && !data['retired']) {
        brandNameHtml = '<div class="display-block grey">Exclusive to ' + data['brandName'] + '</div>'
    }

    // Rank
    let rankHtml = '<div class="display-block grey">' + data['rank'] + '</div>';

    // Gimmick Restriction
    let gimmickRestrictionHtml = '';
    let gimmickRestrictionText = getChampionshipGimmickRestrictionText(data['gimmickRestriction']);
    if (gimmickRestrictionText) {
        gimmickRestrictionHtml = '<div class="display-block grey">' + gimmickRestrictionText + '</div>';
    }

    // Prestige progress
    let prestigeHtml = '<div class="margin-top-10">' +
        getChampionshipPrestigeProgressHtml(data['prestigeData']) +
        '</div>';

    div += '<div class="display-block margin-bottom-20">' + championshipName + retiredText + brandNameHtml + rankHtml + inactiveHtml + gimmickRestrictionHtml +
        prestigeHtml + '</div>';

    // Add stats if present
    if (data['reignsData'] !== undefined) {

        // Current champion
        if (!data['retired']) {
            div += '<div class="margin-bottom-20">';
            div += '<div class="display-block blue margin-bottom-2">Current Champion</div>';
            if (data['currentReign']) {
                let monthsWord = (data['currentReign']['length'] === 1) ? 'Month' : 'Months';
                let defensesWord = (data['currentReign']['numberOfDefenses'] === 1) ? 'Defense' : 'Defenses';
                let reignDefenses = '{0} {1}'.format(data['currentReign']['numberOfDefenses'], defensesWord);
                let reignLength = '{0} {1}'.format(data['currentReign']['length'], monthsWord);

                div += '<span class="display-block dark-grey">' + data['currentReign']['championName'] +
                    '<span class="margin-left-7 light-grey">' + reignLength + '</span>' +
                    '<span class="margin-left-5 medium-light-grey">' + reignDefenses + '</span>' +
                    '</span>';
            }
            else {
                div += '<div class="display-block light-grey">Vacant</div>';
            }
            div += '</div>';
        }

        // Longest reigns
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Longest Reigns</div>';
        data['longestReigns'].forEach(function (reign) {
            let monthsWord = (reign['length'] === 1) ? 'Month' : 'Months';
            let defensesWord = (reign['numberOfDefenses'] === 1) ? 'Defense' : 'Defenses';
            let reignDefenses = '{0} {1}'.format(reign['numberOfDefenses'], defensesWord);
            let reignLength = '{0} {1}'.format(reign['length'], monthsWord);

            div += '<span class="display-block dark-grey">' + reign['championName'] +
                '<span class="margin-left-7 light-grey">' + reignLength + '</span>' +
                '<span class="margin-left-5 medium-light-grey">' + reignDefenses + '</span>' +
                '</span>';
        });
        if (data['longestReigns'].length <= 0) {
            div += '<div class="display-block dark-grey">N/A</div>';
        }
        div += '</div>';

        // Shortest reign
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Shortest Reign</div>';
        if (data['shortestReign']) {
            let monthsText = 'Months';
            if (data['shortestReign']['length'] === 1) {
                monthsText = 'Month'
            }
            div += '<div class="display-block dark-grey">' + data['shortestReign']['championName'] +
                '<span class="margin-left-5 light-grey">' + data['shortestReign']['length'] + ' ' + monthsText + '</span>' +
                '</div>';
        } else {
            div += '<div class="display-block dark-grey">N/A</div>';
        }
        div += '</div>';

        // Most reigns
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Most Reigns</div>';
        if (data['mostReigns'] !== undefined) {
            let monthsText = 'Reigns';
            if (data['mostReigns']['number'] === 1) {
                monthsText = 'Reign'
            }
            div += '<div class="display-block dark-grey">' + data['mostReigns']['name'] +
                '<span class="margin-left-5 light-grey">' + data['mostReigns']['number'] + ' ' + monthsText + '</span>' +
                '</div>';
        } else {
            div += '<div class="display-block dark-grey">N/A</div>';
        }
        div += '</div>';

        // Best match
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Best Match</div>';
        let bestMatch = data['bestMatch'];
        if (bestMatch) {
            div += getTitleReignMatchHtml(bestMatch, false)
        } else {
            div += '<div class="display-block dark-grey">N/A</div>';
        }
        div += '</div>';

        // Worst match
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Worst Match</div>';
        let worstMatch = data['worstMatch'];
        if (worstMatch) {
            div += getTitleReignMatchHtml(worstMatch, false)
        } else {
            div += '<div class="display-block dark-grey">N/A</div>';
        }
        div += '</div>';

        // Title changes + Months per reign
        let averageReign = '';
        if (data['averageReignLength']) {
            let averageReignText = 'Months per Reign';
            if (data['averageReignLength'] === 1) {
                averageReignText = 'Month per Reign';
            }
            averageReign = data['averageReignLength'] + ' ' + averageReignText;
        }
        let changesText = 'Title Changes';
        if (data['changes'] === 1) {
            changesText = 'Title Change'
        }
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block blue margin-bottom-2">Title Changes</div>';
        div += '<span class="dark-grey">' + data['changes'] + ' ' + changesText + '</span>';
        if (averageReign) {
            div += '<span class="margin-left-10 light-grey">' + averageReign + '</span>';
        }
        div += '</div>';

        // Reigns
        div += '<div class="margin-bottom-20">';
        div += '<div class="display-block margin-bottom-5 blue">Reign History</div>';
        if (data['reignsData'].length > 0) {
            data['reignsData'].forEach(function (reign) {
                // Reign
                let monthsWord = (reign['length'] === 1) ? 'Month' : 'Months';
                let defensesWord = (reign['numberOfDefenses'] === 1) ? 'Defense' : 'Defenses';
                let reignDefenses = '{0} {1}'.format(reign['numberOfDefenses'], defensesWord);
                let reignLength = '{0} {1}'.format(reign['length'], monthsWord);

                div += '<div class="margin-bottom-15 display-block">';
                div += '<div class="margin-bottom-5 display-block">';
                div += '<div class="display-block dark-grey">' + reign['championName'] +
                    '<span class="margin-left-7 light-grey">' + reignLength + '</span>' +
                    '<span class="margin-left-5 medium-light-grey">' + reignDefenses + '</span>' +
                    '</div>';
                div += '</div>';

                // Matches
                div += '<div class="title-history-box">';

                // Vacated
                if (reign['vacated']) {
                    div += '<div class="margin-bottom-8 title-history-item">' +
                        '<div class="display-block red">Vacated</div>' +
                        '</div>';
                }

                // Retired
                if (reign['retired']) {
                    div += '<div class="margin-bottom-8 title-history-item">' +
                        '<div class="display-block red">Retired</div>' +
                        '</div>';
                }

                if (reign['matchesData'].length > 0) {
                    reign['matchesData'].forEach(function (match) {
                        div += '<div class="margin-bottom-8 title-history-item">';
                        div += getTitleReignMatchHtml(match, true, false);
                        div += '</div>';
                    });
                } else {
                    div += '<div class="margin-bottom-8 title-history-item light-grey">No title matches</div>'
                }
                div += '</div>';

                div += '</div>';
            });
        } else {
            div += '<div class="title-history-box">No Reigns</div>';
        }
        div += '</div>';
    }
    else {
        // Show JoW Paid text
        div +=
            '<div>' +
                '<div class="margin-top-15">' +
                    '<span class="display-block light-grey">Title Stats are only available in JoW Paid. View stats like ' +
                    'Reign History, Best Matches, Most Reigns and more.</span>' +
                '</div>' +
            '</div>'
    }

    $titleStatsContainer.append(div);

    // Show graphic
    let el = $('#championship-stats-graphic');
    if (data['graphic']) {
        showTitlePageGraphic(el, data['graphic'])
    }
    else {
        el.hide();
    }
}

function getTitleReignMatchHtml(match, addChampionshipChange = true, addRating = true) {
    // Join losers with comma and 'and'
    let losers = match['losers'];
    let losersText;
    if (losers.length > 1) {
        losersText = losers.slice(0, -1).join(', ') + ' and ' + losers.slice(-1);
    }
    else {
        losersText = losers[0];
    }

    // Championship
    let championshipText = '';
    if (match['winner']['championshipsWon'] && addChampionshipChange) {
        championshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold">' +
            match['winner']['championshipsWon'] + '</span></span>';
    }
    if (match['winner']['championshipsRetained'] && addChampionshipChange) {
        championshipText = '<span class="margin-left-5">(No Title Change)</span>';
    }

    // Tournament details
    let tournamentText = '';
    if (match['tournamentName']) {
        tournamentText = ' (' + match['tournamentName'] + ' ' + match['tournamentRoundName'] + ')'
    }

    // Match gimmick
    let gimmickHtml = '';
    if (match['gimmick']) {
        gimmickHtml = '<span class="grey margin-left-8">{0} Match</span>'.format(match['gimmick']);
    }

    // Rating
    let ratingHtml = '';
    if (addRating) {
        ratingHtml = '<span class="margin-left-10 display-inline-block">' + setRating(match['rating']) + '</span>'
    }

    let text = '';
    if (['Double Pin', 'Time-limit Draw', 'Ring Collapse'].indexOf(match['finishName']) >= 0) {
        text = '{0} <span class="light-grey">vs</span> {1} (No Contest){2}<span class="light-grey margin-left-8">{3}</span>{4}'.format(match['winner']['name'],
            losersText, gimmickHtml, match['event'], tournamentText);
    }
    else {
        text = '{0} <span class="light-grey">def.</span> {1}{2}{3}<span class="light-grey margin-left-8">{4}</span>{5}'.format(match['winner']['name'],
            losersText, championshipText, gimmickHtml, match['event'], tournamentText);
    }

    return '<div class="display-block dark-grey">' + text +
        ratingHtml +
        '</div>';
}

function getAddChampionshipCost(parent, addGimmickCost) {
    if (typeof(addGimmickCost) === 'undefined') addGimmickCost = true;
    let rankValue = parent.find("select[name=championship-rank]").val();
    let points = 0;
    switch (rankValue) {
        case 'Main Eventer':
            points = 250;
            break;
        case 'Upper Midcarder':
            points = 150;
            break;
        case 'Lower Midcarder':
            points = 100;
            break;
        case 'Jabroni':
            points = 50;
            break;
    }
    if (parent.hasClass('rebrand-championship-container')) {
        points += 50
    }
    if (addGimmickCost) {
        let championshipGimmick = parent.find(".championship-gimmick-select").val();
        if (championshipGimmick && championshipGimmick !== 'none') {
            points += 100
        }
    }
    return points;
}

async function loadAddChampionshipPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let gimmickMatches = await getCompanyGimmickMatchesForChampionshipGimmick();
    let brandNames = await getCompanyBrandNames();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddChampionshipPageData(brandNames, gimmickMatches);
}

function showAddChampionshipPageData(brandNames, gimmickMatches) {
    // Add brand names to select
    let brandNameSelect = $('.add-championship-container select[name="championship-brand"]');
    let brandNamesOptions = '<option value="">None</option>';
    brandNames.forEach(function (brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + '</option>'
    });
    brandNameSelect.html(brandNamesOptions);

    // Load default graphic
    let el = $('#championship-graphic');
    showAddChampionshipPageGraphic(el, null);

    let addChampionshipElement = $('.add-championship-container');
    addChampionshipElement.fadeIn('slow').removeClass('display-none');
    addChampionshipElement.find('.character-creator-controls').show();

    // Reset inputs
    addChampionshipElement.find('input').val('');
    addChampionshipElement.find('select[name="championship-rank"]').val('Upper Midcarder').trigger('change');
    addChampionshipElement.find('select[name="championship-division"]').val('singles').trigger('change');
    addChampionshipElement.find('select[name="championship-graphic-option"]').val('1').trigger('change');
    addChampionshipElement.find('select[name="championship-gimmick-select"]').val('none').trigger('change');

    if (globalUser.paid) {
        addChampionshipElement.find('select[name="championship-brand"]').parent().show();
    }
    else {
        addChampionshipElement.find('select[name="championship-brand"]').parent().hide();
    }

    // Show championship gimmick inputs
    const $gimmickSelect = $(".add-championship-container .championship-gimmick-select");
    $gimmickSelect.off('change');
    $gimmickSelect.on('change', function () {
        let value = $(this).val();
        const $addChampionshipGimmickMatchSelect = $(".add-championship-container .championship-gimmick-match-select");
        const $addChampionshipMaximumAgeInput = $(".add-championship-container .championship-maximum-age-input");
        const $addChampionshipMinimumAgeInput = $(".add-championship-container .championship-minimum-age-input");
        $addChampionshipGimmickMatchSelect.parent().hide();
        $addChampionshipMaximumAgeInput.parent().hide();
        $addChampionshipMinimumAgeInput.parent().hide();
        if (value === 'gimmick_match') {
            let gimmickMatchSelectDiv = $addChampionshipGimmickMatchSelect;
            gimmickMatchSelectDiv.parent().show();
            // Populate with gimmick matches
            gimmickMatchSelectDiv.html('');
            gimmickMatchSelectDiv.append($("<option />").val('Any').text('Any'));
            gimmickMatches.forEach(function (gimmickMatch) {
                gimmickMatchSelectDiv.append($("<option />").val(gimmickMatch).text(gimmickMatch));
            });
        }
        else if (value === 'maximum_age') {
            $addChampionshipMaximumAgeInput.parent().show();
        }
        else if (value === 'minimum_age') {
            $addChampionshipMinimumAgeInput.parent().show();
        }

        // Update cost
        let cost = getAddChampionshipCost($('.add-championship-container'));
        $(this).closest('.add-championship-container').find('.add-championship-cost').text(cost);
    });
}

async function loadVacateChampionshipPage($selectElement, selectedChampionship) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getCompanyChampionshipsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showVacateChampionshipPageData(data, $selectElement, selectedChampionship);
}

function showVacateChampionshipPageData(data, $selectElement, selectedChampionship) {
    $selectElement.html('');

    data['championships'].forEach(function (championship) {
        let select = $("<option></option>");
        select.text(championship['name']);
        select.data('uid', championship['uid']);
        $selectElement.append(select);
    });

    // Select previously selected championship
    $selectElement.val(selectedChampionship);
    if ($selectElement.val() === null) {
        $selectElement.prop("selectedIndex", 0);
    }

    $("#vacate-championship").fadeIn('slow');
}

async function loadRetireChampionshipPage($selectElement, selectedChampionship) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getCompanyChampionshipsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRetireChampionshipPageData(data, $selectElement, selectedChampionship);
}

function showRetireChampionshipPageData(data, $selectElement, selectedChampionship) {
    $selectElement.html('');

    data['championships'].forEach(function (championship) {
        let select = $("<option></option>");
        select.text(championship['name']);
        select.data('uid', championship['uid']);
        $selectElement.append(select);
    });

    // Select previously selected championship
    $selectElement.val(selectedChampionship);
    if ($selectElement.val() === null) {
        $selectElement.prop("selectedIndex", 0);
    }

    $("#retire-championship").fadeIn('slow');
}

async function loadRebrandChampionshipPage($element, selectedChampionship) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let gimmickMatches = await getCompanyGimmickMatchesForChampionshipGimmick();
    let data = await getCompanyChampionshipsData(false);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRebrandChampionshipPageData(data, $element, selectedChampionship, gimmickMatches);
}

function showRebrandChampionshipPageData(data, $element, selectedChampionship, gimmickMatches) {
    // Reset name input
    $element.find('.rebrand-championship-name-input').val('');

    // Add championships to select, with uid, graphic and brand as data attributes
    let selectElement = $element.find('.rebrand-championship-championship-select');
    selectElement.html('');
    data['championships'].forEach(function(championship) {
        let select = $("<option></option>");
        select.text(championship['name']);
        select.data('uid', championship['uid']);
        select.data('graphic', championship['graphic']);
        select.data('gimmickRestriction', championship['gimmickRestriction']);
        select.data('brandName', championship['brandName']);
        selectElement.append(select);
    });

    // Select previously selected championship
    selectElement.val(selectedChampionship);
    if (selectElement.val() === null) {
        selectElement.prop("selectedIndex", 0);
    }

    if (data['championships'].length > 0) {
        // Load title graphic for selected title
        $('#change-championship-graphic').data('key', JSON.stringify(data['championships'][selectElement.prop("selectedIndex")]['graphic']));
        $('input:radio[name="radio-change-championship-graphic-option"][value="change"]').trigger('change').trigger('click');
    }

    // Add brand names
    let brandNamesOptions = '<option value="">None</option>';
    data['brandNames'].forEach(function (brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + '</option>'
    });
    $element.find('.rebrand-championship-brand-select').html(brandNamesOptions);

    // Show championship gimmick inputs
    const $rebrandChampionshipContainer = $(".rebrand-championship-container");
    $rebrandChampionshipContainer.off('change', '.championship-gimmick-select');
    $rebrandChampionshipContainer.on('change', '.championship-gimmick-select', function () {
        let value = $(this).val();
        let addGimmickCost = true;
        const $rebrandChampionshipGimmickMatchSelect = $(".rebrand-championship-container .championship-gimmick-match-select");
        const $rebrandChampionshipMaximumAgeInput = $(".rebrand-championship-container .championship-maximum-age-input");
        const $rebrandChampionshipMinimumAgeInput = $(".rebrand-championship-container .championship-minimum-age-input");

        if (value === 'gimmick_match') {
            let gimmickMatchSelectDiv = $rebrandChampionshipGimmickMatchSelect;
            let gimmickMatchSelectDivDefaultValue = gimmickMatchSelectDiv.data('default-value');
            // Don't add championship gimmick cost if already added
            if (gimmickMatchSelectDivDefaultValue) {
                addGimmickCost = false;
            }

            // Populate with gimmick matches
            gimmickMatchSelectDiv.html('');
            gimmickMatchSelectDiv.append($("<option />").val('Any').text('Any'));
            gimmickMatches.forEach(function (gimmickMatch) {
                gimmickMatchSelectDiv.append($("<option />").val(gimmickMatch).text(gimmickMatch));
            });

            // Add default value if present
            if (gimmickMatchSelectDivDefaultValue) {
                gimmickMatchSelectDiv.val(gimmickMatchSelectDivDefaultValue);
                gimmickMatchSelectDiv.data('default-value', null);
            }

            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
            gimmickMatchSelectDiv.parent().show();
        }
        else if (value === 'maximum_age') {
            // Reset input
            let ageInputDiv = $rebrandChampionshipMaximumAgeInput;
            ageInputDiv.val('');

            // Add default value if present
            let ageInputDivDefaultValue = ageInputDiv.data('default-value');
            if (ageInputDivDefaultValue) {
                ageInputDiv.val(ageInputDivDefaultValue);
                ageInputDiv.data('default-value', null);
                addGimmickCost = false;
            }

            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
            ageInputDiv.parent().show();
        }
        else if (value === 'minimum_age') {
            let ageInputDiv = $rebrandChampionshipMinimumAgeInput;
            ageInputDiv.val('');

            let ageInputDivDefaultValue = ageInputDiv.data('default-value');
            if (ageInputDivDefaultValue) {
                ageInputDiv.val(ageInputDivDefaultValue);
                ageInputDiv.data('default-value', null);
                addGimmickCost = false;
            }

            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
            ageInputDiv.parent().show();
        }
        else {
            $rebrandChampionshipGimmickMatchSelect.parent().hide();
            $rebrandChampionshipMaximumAgeInput.parent().hide();
            $rebrandChampionshipMinimumAgeInput.parent().hide();
        }

        // Update cost
        let cost = getAddChampionshipCost($('.rebrand-championship-container'), addGimmickCost);
        $(this).closest('.rebrand-championship-container').find('.rebrand-championship-cost').text(cost);
    });

    // Load gimmick restriction for selected title
    $(".rebrand-championship-championship-select").trigger('change');

    $element.fadeIn('slow').removeClass('display-none');
}

async function getAddChampionshipRequest() {

    if (globals.requestRunning) {
        return;
    }

    let name = $(".add-championship-container input[name=championship-name]").val();
    let championUid = parseInt($(".add-championship-container select[name=championship-champion]").val());
    let rank = $(".add-championship-container select[name=championship-rank]").val();
    let championshipDivision = $(".add-championship-container select[name=championship-division]").val();
    let addGraphic = $(".add-championship-container select[name='championship-graphic-option']").val() === '1';
    let brandName = $(".add-championship-container select[name='championship-brand']").val();

    // Get gimmick
    let gimmickMatchName;
    let gimmickRestrictionMaxAge;
    let gimmickRestrictionMinAge;
    let gimmickRestriction = $(".add-championship-container .championship-gimmick-select").val();
    if (gimmickRestriction === 'gimmick_match'){
        gimmickMatchName = $(".add-championship-container .championship-gimmick-match-select").val();
    }
    else if (gimmickRestriction === 'maximum_age'){
        gimmickRestrictionMaxAge = $(".add-championship-container .championship-maximum-age-input").val();
    }
    else if (gimmickRestriction === 'minimum_age'){
        gimmickRestrictionMinAge = $(".add-championship-container .championship-minimum-age-input").val();
    }

    // Get graphic data
    $('.add-championship-container .share-character').trigger('click').removeClass('selected');
    $('.add-championship-container .share-character-code-container').hide();
    let graphicData = $('.add-championship-container .share-character-code-input').val();

    // Validate
    if (name.length <= 0) {
        notie.alert({type: 3, text: "Enter a name for the Championship"});
        return false;
    }
    if (gimmickRestriction === 'maximum_age') {
        if (gimmickRestrictionMaxAge.length <= 0 || !parseInt(gimmickRestrictionMaxAge)) {
            notie.alert({type: 3, text: "Enter a number greater than 0 for the Maximum Age"});
            return false;
        }
    }
    if (gimmickRestriction === 'minimum_age') {
        if (gimmickRestrictionMinAge.length <= 0 || !parseInt(gimmickRestrictionMinAge)) {
            notie.alert({type: 3, text: "Enter a number greater than 0 for the Minimum Age"});
            return false;
        }
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addChampionship(name, rank, championUid, championshipDivision, addGraphic,
        graphicData, gimmickRestriction, gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMinAge,
        brandName);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddChampionshipData(data);
}

function showAddChampionshipData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let html = '<span class="display-block">' +
            '<span class="gold">' +
            data['championshipName'] +
            '</span>' +
            " added" +
            '</span>';

        notie.alert({type: 4, text: html});

        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view titles
        setTimeout(function () {
            $('#view-titles-menu-button').trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'level-2-production-facility-required') {
            notie.alert({type: 3, text: "You need to have the Championship Gimmicks Facility " +
                    "(Level 2 Production) present in order to add Gimmicks to Championships."});
        }
        else if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: "Brands are only available in JoW Paid"});
        }
        else if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: "That brand could not be found. Please try again"});
        }
        else if (data['error'] === 'points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points"});
        }
        else if (data['error'] === 'already-exists') {
            notie.alert({type: 3, text: "A Championship with that name already exists in your Company"});
        }
        else if (data['error'] === 'champion-not-found') {
            notie.alert({type: 3, text: "That talent could not be found for the selected division"});
        }
    }
}

function showVacateChampionshipData({data} = {}) {
    if (!data['error']) {
        let text;
        if (data['tag']) {
            text = '<span class="display-block">' +
                '<span class="gold">' + data['championshipName'] + '</span>' +
                " have been vacated" +
                '</span>';
        }
        else {
            text = '<span class="display-block">' +
                '<span class="gold">' + data['championshipName'] + '</span>' +
                " has been vacated" +
                '</span>';
        }

        // Show lowered prestige if vacated too often
        if (data['vacatedTooOftenXpDecrease']) {
            let xpChange = '<span class="red margin-left-5">- ' +
                (data['vacatedTooOftenXpDecrease'] * -1) + ' XP</span>';
            text += '<span class="display-block">Prestige decreased due to being vacated ' +
                'too often ' + xpChange + '</span>';
        }

        notie.alert({type: 4, text: text, stay: true});
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    }
    else {
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "That Championship could not be found"});
        }
        else if (data['error'] === 'already-vacant') {
            notie.alert({type: 3, text: "That championship is already vacant"});
        }
        else if (data['error'] === 'pow-title') {
            notie.alert({type: 3, text: "\"I can't let you vacate the POW Championship like this. You'll have to find another way to do it.\" - Hank Hughes"});
        }
    }
}

async function getRetireChampionshipRequest(uid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await retireChampionship(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRetireChampionshipData(data);
}

function showRetireChampionshipData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let text;
        if (data['tag']) {
            text = '<span class="gold">' + data['championshipName'] + "</span> have been retired, returning " +
                '<span class="blue margin-left-3">' + " <img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small'/> " +
                data['pointsReturned'] + '</span>';
        }
        else {
            text = '<span class="gold">' + data['championshipName'] + "</span> has been retired, returning " +
                '<span class="blue margin-left-3">' + " <img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small'/> " +
                data['pointsReturned'] + '</span>';
        }

        let html = '<span class="display-block">' +
            text +
            '</span>';
        notie.alert({
            type: 4, text: html, stay: true
        });
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Select next championship
        let selected = $("#retire-championship .select-championship-all").find(":selected");
        selected.next().prop('selected', true);
        // Remove deleted championship
        selected.remove();
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'championship-not-found') {
            notie.alert({type: 3, text: "That Championship could not be found"});
        }
        else if (data['error'] === 'pow-title') {
            notie.alert({type: 3, text: "\"No, you can't retire the POW Championship.\" - Hank Hughes"});
        }
    }
}

async function getRebrandChampionshipRequest() {

    if (globals.requestRunning) {
        return;
    }

    let uid = $('.rebrand-championship-container .rebrand-championship-championship-select').find(':selected').data('uid');
    let name = $('.rebrand-championship-container .rebrand-championship-name-input').val().trim();
    let appearanceOption = $('.rebrand-championship-container input[name="radio-change-championship-graphic-option"]:checked').val();
    let brandName = $('.rebrand-championship-container .rebrand-championship-brand-select').val();

    // Get graphic if 'change' graphic selected
    let graphicData;
    if (appearanceOption === 'change') {
        $('#change-championship-graphic-container .share-character').trigger('click').removeClass('selected');
        $('#change-championship-graphic-container .share-character-code-container').hide();
        graphicData = $('#change-championship-graphic-container .share-character-code-input').val();
    }

    // Get gimmick
    let gimmickMatchName;
    let gimmickRestrictionMaxAge;
    let gimmickRestrictionMinAge;
    let gimmickRestriction = $(".rebrand-championship-container .championship-gimmick-select").val();
    if (gimmickRestriction === 'gimmick_match'){
        gimmickMatchName = $(".rebrand-championship-container .championship-gimmick-match-select").val();
    }
    else if (gimmickRestriction === 'maximum_age'){
        gimmickRestrictionMaxAge = $(".rebrand-championship-container .championship-maximum-age-input").val();
        if (gimmickRestrictionMaxAge === '') {
            notie.alert({type: 3, text: "Enter the maximum age for this Championship Gimmick"});
            return false;
        }
    }
    else if (gimmickRestriction === 'minimum_age'){
        gimmickRestrictionMinAge = $(".rebrand-championship-container .championship-minimum-age-input").val();
        if (gimmickRestrictionMinAge === '') {
            notie.alert({type: 3, text: "Enter the minimum age for this Championship Gimmick"});
            return false;
        }
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await rebrandChampionship(uid, name, appearanceOption, graphicData, gimmickRestriction,
        gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMinAge, brandName);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRebrandChampionshipData(data);
}

function showRebrandChampionshipData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        let notieText = '<span class="display-block">Rebranded {0}</span>'.format(data['previousName']);

        // Show lowered prestige if vacated too often
        if (data['rebrandXpChange']) {
            let xpChange = '<span class="red margin-left-5">- ' +
                (data['rebrandXpChange'] * -1) + ' XP</span>';
            notieText += '<span class="display-block">Prestige decreased due to rebranding ' +
                xpChange + '</span>';
        }

        notie.alert({type: 4, text: notieText});

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view titles
        setTimeout(function () {
            $('#view-titles-menu-button').trigger('click')
        }, 1200);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to change this Championship's Name"
            });
        }
        else if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot change Championship Names in Wrestling on Mars"});
        }
        else if (data['error'] === 'pow-title') {
            notie.alert({
                type: 3,
                text: "\"We don't need to make any changes to the POW Championship.\" - Hank Hughes"
            });
        }
        else if (data['error'] === 'already-exists') {
            notie.alert({type: 3, text: "A Championship with that name already exists in your Company"});
        }
        else if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: "Brands are only available in JoW Paid"});
        }
        else if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: "That brand could not be found. Please try again"});
        }
        else if (data['error'] === 'level-2-production-facility-required') {
            notie.alert({
                type: 3, text: "You need to have the Championship Gimmicks Facility " +
                    "(Level 2 Production) present in order to add Gimmicks to Championships."
            });
        }
    }
}

async function getRebrandCompanyRequest() {

    if (globals.requestRunning) {
        return;
    }

    let name = $('.rebrand-company-container .rebrand-company-name-input').val().trim();

    // Check if name entered
    if (name.length <= 0) {
        notie.alert({ type: 3, text: 'Enter a name for your Company', stay: true });
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await rebrandCompany(name);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRebrandCompanyData(data);
}

function showRebrandCompanyData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        notie.alert({type: 4, text: "{0} has been Rebranded to {1}".format(data['previousName'], data['newName'])});

        // Update company name
        $("#company-name").html(getCompanyHeaderHtml(data['newName'], data['playerName']));

        // Go back to view companies
        setTimeout(function () {
            $('#view-companies-menu-button').trigger('click')
        }, 1200);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to rebrand your Company"
            });
        }
        else if (data['error'] === 'story') {
            notie.alert({type: 3, text: "You cannot rebrand your Company in Stories"});
        }
        else if (data['error'] === 'name-exists') {
            notie.alert({type: 3, text: "A Company with that name already exists"});
        }
    }
}

function showBuyPowerupData({data, powerupContainer} = {}) {
    if (!data['error']) {
        // Add use button if stock goes from 0 to 1
        if (data['stock'] > 0) {
            if (!(powerupContainer.find('.use-powerup').length)) {
                let useButton = '<button type="button" class="button retro-button condensed margin-left-5 blue-button-background ' +
                    'use-powerup">Use</button>';
                powerupContainer.find('.buy-powerup').after(useButton);
            }
        }

        // Update stock
        powerupContainer.find('.powerup-stock-number').text(data['stock']).hide().fadeIn();

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    } else {
        if (data['error'] === 'not-enough-points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to buy a use of this " + globals.game.powerupWord
            });
        }
    }
}

function showUsePowerupData({data, powerupContainer} = {}) {
    $('#powerups-selection').html('');
    if (!data['error']) {
        let div;

        // Show selections
        if (data['selections'].length > 0) {
            let text;
            if (data['help']) {
                text = data['help']
            } else {
                text = 'Activate ' + globals.game.powerupWord + ' on';
            }
            div = '<span class="powerups-selection-text light-grey display-block font-bold margin-bottom-10 margin-left-5">' +
                text + '</span>';

            let powerupsHtml = '';
            data['selections'].forEach(function (selection) {
                powerupsHtml += '<div class="powerups-selection-item" data-uid="' + selection['uid'] + '">' + selection['name'] + '</div>';
            });
            div += '<div class="powerups-selection-container">' + powerupsHtml + '</div>';
        }
        // Apply powerup without any selections
        else {
            div = '<div class="powerups-selection-item">Activate</div>';
        }

        $('#powerups-selection').append(div);

        powerupContainer.siblings().hide();
        powerupContainer.addClass('selected');
        powerupContainer.find('.powerup-bottom').hide();
        powerupContainer.find('.powerup-cancel').show();
        powerupContainer.find('.powerup-description').show();
        powerupContainer.removeClass('help-text');
        $('#powerups-selection').fadeIn();
        $('.powerups-header').hide();
        $('.powerups-selection-container').scrollTop(0);

        // Add powerup uid
        $('#powerups-selection').attr('data-uid', data['uid']);
    } else {
        let text;
        if (data['error'] === 'not-available') {
            // Set error text
            switch (data['selectionsType']) {
                case 'matches':
                    text = "You don't have any matches booked to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'non_multi_matches':
                    text = "You don't have any non multi-person matches booked to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'training_superstars':
                    text = "You don't have any training superstars to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'part_time_superstars':
                    text = "You don't have any part time superstars to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'retired_superstars':
                    text = "You don't have any eligible retired superstars to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'injured_superstars':
                    text = "You don't have any injured superstars to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'returning_superstars':
                    text = "You don't have any superstars returning from injury to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'unhappy_superstars':
                    text = "You don't have any unhappy superstars to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'dead_superstars':
                    text = "You don't have any dead superstars to activate this " + globals.game.powerupWord + " on.";
                    break;
                case 'past_gimmick_superstars':
                    text = "You don't have any superstars with past gimmicks to activate this " + globals.game.powerupWord + " on.";
                    break;

                default:
                    text = "You don't have anything available to activate this " + globals.game.powerupWord + " on."
            }
        } else if (data['error'] === 'stock-empty') {
            text = "You don\'t have any available uses of this " + globals.game.powerupWord + ".";
        } else if (data['error'] === 'trade-deal-active') {
            text = 'You\'re already running a trade deal.';
        } else if (data['error'] === 'upcoming-show-active') {
            text = 'This ' + globals.game.powerupWord + ' has already been applied to the upcoming event.';
        }

        let div;
        div = '<span class="powerups-selection-text light-grey display-block font-bold margin-bottom-10 margin-left-5">' +
            text + '</span>';

        $('#powerups-selection').append(div);

        powerupContainer.siblings().hide();
        powerupContainer.addClass('selected');
        powerupContainer.find('.powerup-bottom').hide();
        powerupContainer.find('.powerup-cancel').show();
        powerupContainer.find('.powerup-description').show();
        $('#powerups-selection').fadeIn();
        $('.powerups-header').hide();

        // Add powerup uid
        $('#powerups-selection').attr('data-uid', data['uid']);
    }
}

async function showApplyPowerupData({data} = {}) {
    if (!data['error']) {
        globals.requestRunning = true;

        notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Running', stay: true});
        let selectedPowerup = $('#powerups-inventory').find('.selected');
        let image = selectedPowerup.find('.powerup-image').find('img');

        // Hide cancel button
        selectedPowerup.find('.powerup-cancel-button').hide();

        // Animate powerup
        let animation = 'dissolve';
        if (globals.game.story === 'mars') {
            animation = 'use-experiment';
        }
        setTimeout(function () {
            image.removeClass('pulse').addClass(animation);
        }, 0);
        setTimeout(async function () {
            globals.requestRunning = false;
            image.removeClass(animation);
            notie.hideAlerts();

            // Hide stock number for dissolve animation
            if (animation === 'dissolve') {
                selectedPowerup.find('.powerup-stock-number').hide();
            }

            if (globals.game.story !== 'mars') {
                image.addClass('transparent');
            }

            // Show result and back button
            let text = '<span class="powerups-selection-text medium-grey display-block font-bold ' +
                'margin-bottom-8 margin-left-5 line-height-24px">' +
                data['result'] + '</span>';
            let backButton = '<button type="button" class="powerups-back-button display-block ' +
                'button retro-button condensed blue-button-background margin-left-5">Back</button>';
            $('#powerups-selection').html(text + backButton).fadeIn();

            // Update event card
            let effects = ['increase_matches', 'virtual', 'raise_multiplier', 'gimmick_match_roulette',
                'allow_other_brands', 'allow_other_brands_extended'];
            if (effects.indexOf(data['effect']) >= 0) {
                await loadEventCardPage();
            }

            // Update game style if changed
            if (data['style']) {
                globals.game.style = data['style'];
            }

        }, 2100);

        // Back button
        $('#powerups-box').off('click', '.powerups-back-button');
        $('#powerups-box').on('click', '.powerups-back-button', function () {
            image.removeClass('transparent');

            if (globals.game.story !== 'mars') {
                image.addClass('pulse');
            }

            // Show powerups
            $('#powerups-inventory').children().show();

            selectedPowerup.removeClass('selected').find('.powerup-bottom').show();
            selectedPowerup.find('.powerup-stock-number').show();
            selectedPowerup.find('.powerup-cancel').hide();
            selectedPowerup.find('.powerup-description').hide();
            selectedPowerup.find('.powerup-cancel-button').show();

            // Update stock
            selectedPowerup.find('.powerup-stock-number').text(data['stock']).hide().fadeIn();

            // Remove use button if stock is 0
            if (data['stock'] === 0) {
                selectedPowerup.find('.use-powerup').remove()
            }

            $('#powerups-selection').hide();
            $('.powerups-header').show();

            // Update unread messages
            if (data['unreadMessages']) {
                let unreadMessages = data['unreadMessages'].toLocaleString('en');
                $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
                $('.messages-number').text(unreadMessages);
                $('#messages').hide().fadeIn('fast');
            }
        });

    } else {
        if (data['error'] === 'stock-empty') {
            notie.alert({type: 3, text: "You don\'t have any available uses of this " + globals.game.powerupWord + "."});
        } else if (data['error'] === 'virtual-exemption') {
            notie.alert({
                type: 3,
                text: 'The Virtual Experiment can\'t be applied to the Olympus Mons Match!'
            });
        } else if (data['error'] === 'empty-roster') {
            notie.alert({type: 3, text: 'There are no available superstars in that company\'s roster!'});
        } else if (data['error'] === 'max-roster-capacity') {
            notie.alert({
                type: 3, text: "You do not have enough space in your roster. Release superstars " +
                    "or raise your Company Reputation to increase roster capacity."
            });
        } else if (data['error'] === 'not-enough-competitor-superstars') {
            notie.alert({type: 3, text: 'There are not enough superstars in that company\'s roster!'});
        } else if (data['error'] === 'no-competitors-present') {
            notie.alert({type: 3, text: 'There are no competitors present'});
        } else if (data['error'] === 'not-enough-superstars') {
            notie.alert({type: 3, text: 'There are not enough superstars in your roster!'});
        } else if (data['error'] === 'champion') {
            notie.alert({type: 3, text: 'This ' + globals.game.powerupWord + ' cannot be used on a champion'});
        } else if (data['error'] === 'injured') {
            notie.alert({type: 3, text: 'This ' + globals.game.powerupWord + ' cannot be used on an injured superstar'});
        } else if (data['error'] === 'suspensionMonths') {
            notie.alert({type: 3, text: 'This ' + globals.game.powerupWord + ' cannot be used on a suspended superstar'});
        } else if (data['error'] === 'no-appearances') {
            notie.alert({
                type: 3,
                text: 'This ' + globals.game.powerupWord + ' cannot be used on a part timer with no appearances left'
            });
        } else if (data['error'] === 'cannot-use-on-event') {
            notie.alert({
                type: 3,
                text: 'An ' + globals.game.powerupWord + ' has already been used on this Event'
            });
        } else if (data['error'] === 'no-gimmick-matches-available') {
            notie.alert({
                type: 3,
                text: 'There are no basic Gimmick Matches present'
            });
        } else if (data['error'] === 'gimmick-match-already-present') {
            notie.alert({
                type: 3,
                text: 'This Match is already a Gimmick Match'
            });
        } else if (data['error'] === 'owner-not-found') {
            notie.alert({
                type: 3,
                text: 'The owner could not be found in the roster'
            });
        } else if (data['error'] === 'event-already-non-exclusive') {
            notie.alert({
                type: 3,
                text: 'This Event already allows Superstars from all brands to be booked.'
            });
        }
    }
}

function getUnavailableFeudItemHtml(item, addToMatch) {
    let lockedText = 'Locked: Unlocked with Feud Item Prestige (JoW Paid)';
    if (globalUser.paid) {
        lockedText = 'Locked: Unlocked with Feud Item Prestige';
    }

    // Set level
    let level;
    switch (item['level']) {
        case 1:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px gold-light"></i>';
            break;
    }

    let consequence = 'No Consq.';
    if (item['consequence']) {
        let consequenceText = item['consequence'];
        if (consequenceText === 'retirement-or-unmasking') {
            consequenceText = 'retirement-/-unmasking'
        }
        consequence =
            '<span class="faded-red-light">' +
            toTitleCase(consequenceText.replace(/-/g, ' ')) +
            '</span>';
    }

    let requirement = '';
    if (item['requirement']) {
        requirement =
            '<div class="sky-blue feud-item-requirement">' +
            toTitleCase(item['requirement'].replace(/-/g, ' ')) +
            '</div>'
    }
    else {
        requirement =
            '<div class="feud-item-requirement">' +
            'No Reqs.' +
            '</div>'
    }

    // Get progress to next level
    let progress;
    let levelXp;
    if (item['level'] < 3) {
        levelXp = Math.pow(item['level'], 2) * 50;
        progress = (item['xp'] / levelXp) * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml =
        '<div class="margin-top-8 margin-bottom-3 item-progress-container display-inline-block">' +
        '<div class="progress-under help-text" title="' + item['xp'] + ' / ' + levelXp + ' XP">' +
        '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + '</div>' +
        '</div>' +
        '</div>';

    let div;
    if (addToMatch) {
        if (item['unlocked']) {
            div =
                '<div class="feud-item-container item-container font-bold disabled">' +
                '<div class="margin-bottom-5">' +
                item['name'] +
                '</div>' +
                '<div class="grey">' +
                '<i class="fa fa-bolt margin-right-5"></i>' + '??' +
                '</div>' +
                '<div class="grey">' +
                consequence +
                '</div>' +
                '<div class="light-grey">' +
                requirement +
                '</div>' +
                progressHtml + level +
                '</div>';
        } else {
            let unlockedBy = getFeudItemUnlockedBy(item['name']);
            let unlockText = ' (by getting Gold Prestige on ' + unlockedBy + ')';
            div =
                '<div class="feud-item-container item-container font-bold disabled locked help-text" ' +
                'title="' + lockedText + unlockText + '">' +
                '<div class="margin-bottom-5">' +
                item['name'] +
                '</div>' +
                '<div class="grey">' +
                '<i class="fa fa-bolt margin-right-5"></i>' + '??' +
                '</div>' +
                '<div class="grey">' +
                consequence +
                '</div>' +
                '<div class="light-grey">' +
                requirement +
                '</div>' +
                progressHtml + level +
                '</div>';
        }
    }
    else {
        if (item['unlocked']) {
            div =
                '<div class="feud-item-container item-container font-bold disabled">' +
                '<div class="margin-bottom-5">' +
                item['name'] +
                '<span class="float-right grey">' +
                '<i class="fa fa-bolt margin-right-5"></i>' + '??' +
                '</span>' +
                '</div>' +
                '<div class="grey">' +
                consequence +
                '</div>' +
                '<div class="light-grey">' +
                requirement +
                '</div>' +
                progressHtml + level +
                '</div>';
        } else {
            let unlockedBy = getFeudItemUnlockedBy(item['name']);
            let unlockText = ' (by getting Gold Prestige on ' + unlockedBy + ')';
            div =
                '<div class="feud-item-container item-container font-bold disabled locked help-text" ' +
                'title="' + lockedText + unlockText + '">' +
                '<div class="margin-bottom-5">' +
                item['name'] +
                '<span class="float-right grey">' +
                '<i class="fa fa-bolt margin-right-5"></i>' + '??' +
                '</span>' +
                '</div>' +
                '<div class="grey">' +
                consequence +
                '</div>' +
                '<div class="light-grey">' +
                requirement +
                '</div>' +
                progressHtml + level +
                '</div>';
        }
    }
    return div;
}

function getAvailableFeudItemHtml(item, randomFeudName, addToMatch) {
    // Set level
    let level;
    switch (item['level']) {
        case 1:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-6 font-bold top--3px font-16px gold-light"></i>';
            break;
    }

    let consequence = 'No Consq.';
    if (item['consequence']) {
        let consequenceText = item['consequence'];
        if (consequenceText === 'retirement-or-unmasking') {
            consequenceText = 'retirement-/-unmasking'
        }
        consequence =
            '<span class="faded-red-light">' +
            toTitleCase(consequenceText.replace(/-/g, ' ')) +
            '</span>';
    }

    let requirement = '';
    if (item['requirement']) {
        requirement =
            '<div class="sky-blue feud-item-requirement">' +
            toTitleCase(item['requirement'].replace(/-/g, ' ')) +
            '</div>'
    }
    else {
        requirement =
            '<div class="feud-item-requirement">' +
            'No Reqs.' +
            '</div>'
    }

    let helpClass = '';
    let titleHtml = '';
    if (item['description']) {
        helpClass = ' help-text';
        titleHtml = ' title="' + item['description'] + '"';
    }

    let name = item['name'];
    let generate = '';
    if (name === 'Grudge') {
        let randomName = getRandomChoice(['Grudge', randomFeudName]);
        if (addToMatch) {
            name = '<span id="feud-items-container-custom-name-hide"></span><input type="text" id="feud-items-container-custom-name" maxlength="25" ' +
                'value="' + randomName + '" class="feud-item-custom-name help-text compact" title="Enter a custom Feud name">';
            generate = '<i class="fa fa-refresh generate-feud-name-icon help-text" ' +
                'title="Randomize Feud Name"></i>';
        }
        else {
            name = '<span id="create-feud-custom-name-hide"></span><input type="text" id="create-feud-custom-name" maxlength="25" ' +
                'value="' + randomName + '" class="feud-item-custom-name help-text" title="Enter a custom Feud name">';
            generate = '<i class="fa fa-refresh generate-feud-name-icon help-text" ' +
                'title="Randomize Feud Name"></i>';
        }
    }

    // Get progress to next level
    let progress;
    let levelXp;
    if (item['level'] < 3) {
        levelXp = Math.pow(item['level'], 2) * 50;
        progress = (item['xp'] / levelXp) * 100;
    } else {
        levelXp = Math.pow(2, 2) * 50;
        progress = 100;
    }
    let progressHtml =
        '<div class="margin-top-8 margin-bottom-3 item-progress-container display-inline-block">' +
        '<div class="progress-under help-text" title="' + item['xp'] + ' / ' + levelXp + ' XP">' +
        '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + '</div>' +
        '</div>' +
        '</div>';

    if (addToMatch) {
        return '<div class="feud-item-container item-container font-bold' + helpClass + '" data-uid="' + item['uid'] +
            '"' + titleHtml + '>' +
            '<div class="margin-bottom-5">' +
            name +
            '<span class="float-right grey">' +
            generate +
            '</span>' +
            '</div>' +
            '<div class="grey">' +
            '<i class="fa fa-bolt margin-right-5"></i>' + item['baseHype'] +
            '</div>' +
            '<div class="grey">' +
            consequence +
            '</div>' +
            '<div class="light-grey">' +
            requirement +
            '</div>' +
            progressHtml + level +
            '</div>';
    }
    else {
        return '<div class="feud-item-container item-container font-bold' + helpClass + '" data-uid="' + item['uid'] +
            '"' + titleHtml + '>' +
            '<div class="margin-bottom-5">' +
            name +
            '<span class="float-right grey">' +
            '<i class="fa fa-bolt margin-right-5"></i>' + item['baseHype'] + generate +
            '</span>' +
            '</div>' +
            '<div class="grey">' +
            consequence +
            '</div>' +
            '<div class="light-grey">' +
            requirement +
            '</div>' +
            progressHtml + level +
            '</div>';
    }
}

function showBuyoutInformationData({data, element, uid} = {}) {
    if (!data['error']) {
        element.data('uid', uid);
        element.find('.buyout-competitor-company-name').text(data['name']);
        element.find('.buyout-competitor-cost').text(data['cost']);
        element.find('.buyout-competitor-info').text(
            'If you buyout {0}, the Company will dissolve and you can acquire some of their Superstars and Championships.'.format(data['name'])
        );

        if (data['availableForBuyout']) {
            element.find('.buyout-competitor-available').html('<div class="green">Yes</div>')
        } else {
            element.find('.buyout-competitor-available').html('<div class="dark-red">No</div>')
        }

        if (data['acquisitionFacilityPresent']) {
            element.find('.buyout-competitor-facility').html('<div class="green">Yes</div>')
        } else {
            element.find('.buyout-competitor-facility').html('<div class="dark-red">No</div>')
        }

        // Populate talent manager select
        let talentManagerSelect = element.find('.buyout-competitor-talent-manager-select');
        let talentManagerOptions = '';
        data['talentManagers'].forEach(function (talentManager) {
            talentManagerOptions += '<option value="' + talentManager['uid'] + '">' + talentManager['name'] +
                ' (Lvl ' + talentManager['level'] + ')</option>'
        });
        talentManagerSelect.html(talentManagerOptions);

        element.fadeIn('slow').removeClass('display-none');

        // Show company info
        let rostersDiv = '';
        data['companyInformation']['rosters'].forEach(function (roster) {
            let rosterDiv = getRosterInfo(roster, true, false, false);
            rostersDiv += rosterDiv;
        });
        let owner = (data['ownerName']) ? data['ownerName'] : 'None';
        let companyInfo =
            '<div class="margin-bottom-25">' +
            '<div class="blue margin-bottom-5">Company</div>' +
            getItemColumnDiv('Name', data['name']) +
            getItemColumnDiv('REP', data['reputation']) +
            getItemColumnDiv('Owner', owner) +
            getItemColumnDiv('Style', toTitleCase(data['style'])) +
            '</div>';
        let companyInfoHtml = companyInfo + rostersDiv +
            getChampionshipsInfo(data['companyInformation']['championships'], true, false);
        $('.buyout-company-information').html(companyInfoHtml);
        $('.buyout-company-information').scrollTop(0);
    }
    else {
        if (data['error'] === 'competitor-not-found') {
            notie.alert({type: 3, text: "That Competitor could not be found. Please try again."});
        } else if (data['error'] === 'no-talent-manager-available') {
            let errorText = 'You need to have a Talent Manager available on your staff to make a buyout offer.';
            if (!globalUser.paid) {
                errorText += ' (JoW Paid)'
            }
            notie.alert({type: 3, text: errorText});
        }
    }
}

function showMakeBuyoutOfferData({data, uid} = {}) {
    if (!data['error']) {
        notie.alert({
            type: 4,
            text: '{0} has been assigned to Negotiate the {1} Buyout'.format(data['talentManager'], data['competitorName']),
            stay: true
        });
        setTimeout(function () {
            $(".buyout-competitor-box").fadeOut('fast', function() {
                $("#view-companies-container").fadeIn();
                $('.view-companies-list-item[data-uid="' + uid + '"]').find('.buyout-competitor-button').hide();
                let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
                $(".points-number").html(pointsHtml);
            });
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot make Buyout Offers in Wrestling on Mars."});
        }
        if (data['error'] === 'competitor-not-found') {
            notie.alert({type: 3, text: "That Competitor could not be found. Please try again."});
        }
        else if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to make this buyout offer."});
        }
        else if (data['error'] === 'talent-manager-not-found') {
            notie.alert({type: 3, text: "The selected Talent Manager could not be found. Please try again."});
        }
        else if (data['error'] === 'talent-management-facility-level') {
            notie.alert({type: 3, text: "You need to have the Company Acquisition Facility (Level 3 Talent " +
            "Management) present in order to make a buyout offer."});
        }
        else if (data['error'] === 'not-available-for-buyout') {
            notie.alert({type: 3, text: "That Competitor is not available for a buyout."});
        }
        else if (data['error'] === 'negotiating-buyout') {
            notie.alert({type: 3, text: "{0} is already working on {1}. Another Buyout Offer cannot be made until this one is completed.".format(data['talentManager'], data['currentTask'])});
        }
    }
}

function changeFanHistoryVisibility(value) {

    // Replace update function with empty one, add later. Optimizes hiding/showing multiple series
    const update = fanHistoryChart.update;
    fanHistoryChart.update = () => {
        return Promise.resolve();
    };

    let seriesData = fanHistoryChart.w.config.series;
    if (value === 'all') {
        for (const [index, _] of seriesData.entries()) {
            fanHistoryChart.showSeriesById(index)
        }
    } else if (value === 'none') {
        for (const [index, _] of seriesData.entries()) {
            fanHistoryChart.hideSeriesById(index)
        }
    } else if (value === '5') {
        let addedCompanyIds = [];
        for (const [index, x] of seriesData.entries()) {
            // Show series data for first 5 companies, check by companyId
            if (addedCompanyIds.length < 6 || addedCompanyIds.includes(x.companyId)) {
                fanHistoryChart.showSeriesById(index);
                if (!addedCompanyIds.includes(x.companyId)) {
                    addedCompanyIds.push(x.companyId)
                }
            } else {
                fanHistoryChart.hideSeriesById(index)
            }
        }
    } else if (value === 'users') {
        for (const [index, x] of seriesData.entries()) {
            // Show series data for user controlled companies
            if (x.userControlled) {
                fanHistoryChart.showSeriesById(index);
            } else {
                fanHistoryChart.hideSeriesById(index)
            }
        }
    }

    fanHistoryChart.update = update;
    fanHistoryChart.update();

    notie.alert({type: 4, text: 'Graph filter applied'});
}

function showFormNewCompanyInformationData({data} = {}) {
    let element = $(".form-new-company-box");

    // Show requirements status
    let yearsHtml = `<span class="grey margin-left-8">${data['yearsAtCompany']} ${getYearsWord(data['yearsAtCompany'])}</span>`;
    if (data['yearsAtCompanyFulfilled']) {
        element.find('.form-new-company-years-requirement').html('<div><span class="green">Yes</span>' + yearsHtml + '</div>')
    } else {
        element.find('.form-new-company-years-requirement').html('<div><span class="dark-red">No</span>' + yearsHtml + '</div>')
    }
    if (data['companySpaceAvailable']) {
        element.find('.form-new-company-space-requirement').html('<div class="green">Yes</div>')
    } else {
        element.find('.form-new-company-space-requirement').html('<div class="dark-red">No</div>')
    }

    element.fadeIn('slow').removeClass('display-none');

    // Show company info
    let points = '10% of remaining points'
    if (globals.game.unlimitedCreativePoints) {
        points = 'Max'
    }
    let companyInfo =
        '<div class="margin-bottom-15">' +
        getItemColumnDiv('REP', '5') +
        getItemColumnDiv('Roster Capacity', '60') +
        getItemColumnDiv('Points', points) +
        getItemColumnDiv('Owner', data['ownerName']) +
        '</div>';
    $('.form-new-company-information').html(companyInfo);
}

function showFormNewCompanyData({data} = {}) {
    if (!data['error']) {
        notie.alert({
            type: 4,
            text: 'New message from ' + data['ownerName'] + '.',
            stay: true
        });
        $(".form-new-company-box").fadeOut('fast', async function() {
            $("#view-companies-container").fadeIn();
            let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
            $(".points-number").html(pointsHtml);

            if (data['unreadMessages']) {
                let unreadMessages = data['unreadMessages'].toLocaleString('en');
                $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
                $('.messages-number').text(unreadMessages);
                $('#messages').hide().fadeIn('fast');
            }

            $('#form-new-company-menu-button').replaceWith('<span class="float-right faded-orange top-1px">Forming new company</span>');
        });
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to form a new company."});
        }
        else if (data['error'] === 'story') {
            notie.alert({type: 3, text: "You cannot form a new company in story modes."});
        }
        else if (data['error'] === 'local-multiplayer') {
            notie.alert({type: 3, text: "You cannot form a new company in Local Multiplayer."});
        }
        else if (data['error'] === 'paid-only') {
            notie.alert({type: 3, text: "You can only form a new company in JoW Paid."});
        }
        else if (data['error'] === 'already-forming') {
            notie.alert({type: 3, text: "You are already in the process of forming a new company."});
        }
        else if (data['error'] === 'not-enough-years') {
            notie.alert({type: 3, text: "You need to be managing this company for at least 2 years."});
        }
        else if (data['error'] === 'not-enough-space') {
            notie.alert({type: 3, text: "There isn't enough space in the market for a new company."});
        }
    }
}

export {loadViewCompaniesPage, loadViewObjectivesPage, loadManagementActivityPage, loadFanHistoryPage,
    loadViewCompanyStaffPage, loadViewCompanyFacilitiesPage, loadViewYearlyRankingsHistoryPage,
    loadViewAnnualTournamentHistoryPage, loadViewSpecialSegmentsPage, loadViewPowerupsPage, loadViewOptionsPage,
    loadViewEventsPage, showEventCardData, loadViewFeudsPage, loadViewStatsPage, loadViewTournamentsPage,
    loadViewGimmickMatchesPage, loadViewTitlesPage, loadEventCardPage, getUnavailableFeudItemHtml,
    getAvailableFeudItemHtml, changeGameSettingRequest, getTournamentBracketHtml, getTournamentGroupTableHtml,
    displayYearlyRankingsData, changeUserSettingRequest, updateLastCloudSave}
